/* eslint-disable unicode-bom */
const messages = {
  es: {
    translations: {
      gridHotelFeedback: {
        dashboard: 'Panel de Control',
        service_grid: 'Grillas de Encuesta y Satisfacción',
        service_grid_single: 'Grilla de Encuesta y Satisfacción',
        listed_grids: 'Las Grillas de Encuesta y Satisfacción se listan a continuación',
        create_service_grid: 'Crear Grilla de Encuesta y Satisfacción',
        title: 'Título',
        status: 'Estado',
        grid_deleted: '¡Grilla Eliminada!',
        grid_deleted_message: 'La Grilla de Encuesta y Satisfacción fue eliminada con éxito.',
        error: 'Error',
        error_delete_message: 'Ocurrió un error al eliminar la Grilla de Encuesta y Satisfacción.',
        service_grid_name: 'Título',
        service_grid_name_placeholder: 'Ej.: Encuesta de Satisfacción',
        fill_information_create:
          'Rellene la información a continuación y haga clic en el botón Crear para guardar los cambios',
        missing_fields: 'Campos obligatorios',
        missing_fields_message: '¡El campo "Título" y la "Lista de Ítems" son obligatorios!',
        grid_created: 'Grilla registrada',
        grid_created_message: '¡Registro completado con éxito!',
        error_create_message: '¡Error al registrar la grilla!',
        service_list: 'Lista de Ítems',
        service_placeholder: 'Añada un ítem (Ej.: Calidad de la Habitación)',

        // CHAVES ADICIONADAS/MIGRADAS PARA A PÁGINA DE EDIÇÃO (UPDATE)
        edit_service_grid: 'Editar Grilla de Encuesta y Satisfacción',
        save_changes_edit:
          'Rellene la información a continuación y haga clic en el botón Guardar para confirmar los cambios',
        grid_updated: 'Grilla modificada',
        grid_updated_message: '¡Edición completada con éxito!',
        error_update_message: '¡Error al modificar la grilla!',

        general: {
          actions: 'Acciones',
          edit: 'Editar',
          delete: 'Eliminar',
          active: 'Activo',
          inactive: 'Inactivo',
        },
        buttons: {
          create: 'Crear',
          back: 'Volver',
          save: 'Guardar',
        },
      },
      // Traducciones para la página de gestión de idiomas de las tiendas
      translate_stores: {
        page_title: 'Gestión de Idiomas y Relaciones de Tiendas',
        page_subtitle:
          'Gestiona los idiomas de traducción y las relaciones de cada tienda del sistema.',
        page_title_relationships: 'Gestión de Relaciones de Tiendas',
        page_subtitle_relationships: 'Gestiona las relaciones entre las tiendas del sistema.',
        tab_translations: 'Gestionar Idiomas',
        tab_relations: 'Relaciones de Tiendas',
        breadcrumb: {
          dashboard: 'Dashboard',
          translate_stores: 'Gestionar Idiomas',
        },
        filters: {
          status: 'Estado',
          type: 'Tipo',
          active: 'Activo',
          inactive: 'Inactivo',
          both: 'Ambos',
          all_types: 'Todos',
          status_placeholder: 'Estado de la Tienda',
          type_placeholder: 'Tipo de la Tienda',
          filter_button: 'Filtrar',
        },
        status_options: {
          active: 'Activo',
          inactive: 'Inactivo',
          both: 'Ambos',
          all_types: 'Todos',
        },
        languages: {
          portuguese: 'Portugués',
          spanish: 'Español',
          english: 'Inglés',
          french: 'Francés',
          german: 'Alemán',
          italian: 'Italiano',
          japanese: 'Japonés',
          korean: 'Coreano',
          chinese: 'Mandarín',
        },
        table: {
          headers: {
            type: 'Tipo',
            id: 'ID',
            name: 'Nombre',
            subdomain: 'Subdominio',
            status: 'Estado',
            created: 'Creado el',
            cnpj: 'CNPJ',
            actions: 'Acciones',
          },
          type: 'Tipo',
          id: 'ID',
          name: 'Nombre',
          subdomain: 'Subdominio',
          status: {
            active: 'Activo',
            inactive: 'Inactivo',
          },
          created: 'Creado el',
          cnpj: 'CNPJ',
          actions: 'Acciones',
        },
        actions: {
          manage_languages: 'Gestionar Idiomas',
          edit: 'Editar',
        },
        messages: {
          success: {
            title: 'Éxito',
            save: 'Idiomas guardados con éxito!',
          },
          error: {
            title: 'Error',
            load_data: 'Error al cargar datos de las tiendas!',
            save_languages: 'Error al guardar idiomas!',
          },
        },
        modal: {
          title: 'Gestionar Idiomas',
          description:
            'Seleccione los idiomas que estarán disponibles para traducción en esta tienda:',
          alert: {
            title: 'Atención',
            message:
              'Active o desactive los idiomas que se deben usar para la traducción en esta tienda.',
          },
          buttons: {
            cancel: 'Cancelar',
            save: 'Guardar',
          },
        },
        relations: {
          no_relations: 'No se encontró ninguna relación',
          create_title: 'Crear Relación',
          edit_title: 'Editar Relación',
          parent_label: 'Tienda Padre',
          child_label: 'Tienda Hija',
          parent_missing: 'Seleccione la tienda padre',
          child_missing: 'Seleccione la tienda hija',
          same_store_error: 'La tienda padre no puede ser igual a la tienda hija',
          created_success: 'Relación creada con éxito',
          updated_success: 'Relación actualizada con éxito',
          deleted_success: 'Relación eliminada con éxito',
          error_create: 'Error al crear relación',
          error_update: 'Error al actualizar relación',
          error_delete: 'Error al eliminar relación',
          store_not_found: 'Tienda no encontrada',
          all_option: 'Todas',
          cancel: 'Cancelar',
          save: 'Guardar',
          delete_confirm: 'Sí, eliminar',
          create_button: 'Crear Relación',
          save_changes: 'Guardar Cambios',
          create_description:
            'Defina qué tienda será la tienda padre y cuál será la tienda hija. Una tienda padre puede tener varias tiendas hijas y gestionar sus configuraciones.',
          edit_description:
            'Edite la relación entre las tiendas seleccionadas. Los cambios se aplicarán inmediatamente.',
          summary_title: 'Resumen de la relación:',
          tips_title: 'Consejos importantes:',
          tip_parent_multiple: 'Una tienda padre puede tener múltiples tiendas hijas',
          tip_child_single: 'Una tienda hija puede tener múltiples padres',
          tip_all_available:
            'Todas las tiendas (activas e inactivas) están disponibles para selección',
          click_new: 'Haga clic en "Nueva Relación" para comenzar',
          message_delete:
            '¿Está seguro de que desea eliminar esta relación? Esta acción no se puede deshacer.',
        },
      },
      hospitality_review: {
        page_title: 'Evaluaciones del Hotel',
        page_subtitle:
          'Gestione y supervise las evaluaciones y clasificaciones de los huéspedes del hotel.',
        breadcrumb: {
          dashboard: 'Dashboard',
          hospitality: 'Hospitalidad',
          reviews: 'Evaluaciones',
        },
        statistics: {
          total_reviews: 'Total de Evaluaciones',
          average_rating: 'Media General',
        },
        filters: {
          filter_by_type: 'Filtrar por Tipo',
          filter_by_rating: 'Filtrar por Evaluación',
        },
        type_options: {
          all_types: 'Todos',
          general: 'General',
          room: 'Habitación',
          food: 'Comida',
          service: 'Servicio',
          cleanliness: 'Limpieza',
          activities: 'Actividades',
        },
        rating_options: {
          all_ratings: 'Todas las evaluaciones',
          five_stars: '5 estrellas',
          four_stars: '4 estrellas',
          three_stars: '3 estrellas',
          two_stars: '2 estrellas',
          one_star: '1 estrella',
        },
        table: {
          headers: {
            rating: 'Evaluación',
            type: 'Tipo',
            comment: 'Comentario',
            date: 'Fecha',
            actions: 'Acciones',
          },
          actions: {
            view_full_review: 'Visualizar evaluación completa',
          },
          status: {
            approved: 'Aprobada',
            pending: 'Pendiente',
          },
        },
        modal: {
          review_title: 'Evaluación de',
          fields: {
            rating: 'Evaluación',
            type: 'Tipo',
            status: 'Estado',
            date: 'Fecha',
            comment: 'Comentario',
            email: 'Email',
          },
          guest_anonymous: 'Anónimo',
        },
        messages: {
          success: {
            review_deleted: 'Evaluación eliminada',
            delete_success: 'Eliminación realizada con éxito!',
            status_updated: 'Estado actualizado',
            approved_success: 'Evaluación aprobada con éxito!',
            suspended_success: 'Evaluación suspendida con éxito!',
          },
          error: {
            title: 'Error',
            load_reviews: 'Error al cargar evaluaciones del hotel!',
            invalid_id: 'ID inválido para eliminación!',
            delete_error: 'Error al eliminar la evaluación!',
            status_error: 'Error al cambiar el estado de la evaluación!',
          },
          confirm: {
            delete_title: 'Confirmar eliminación',
            delete_text: '¿Está seguro de que desea eliminar esta evaluación?',
            delete_confirm: 'Sí, eliminar',
            delete_cancel: 'Cancelar',
          },
        },
      },
      hospitality_info: {
        page_title: 'Información del Hotel',
        page_subtitle: 'Gestione contacto, horarios y servicios del hotel.',
        tabs: {
          contact: 'Contacto',
          hours: 'Horarios e Información',
          services: 'Servicios',
          ramal: 'Extensión',
          about: 'Acerca de',
        },
        contact: {
          phone_label: 'Teléfono',
          phone_placeholder: '(11) 99999-9999',
          whatsapp_label: 'WhatsApp',
          whatsapp_placeholder: '(11) 99999-9999',
          email_label: 'E-mail',
          email_placeholder: 'hotel@email.com',
        },
        hours: {
          title: 'Horarios e Información del Hotel',
          add_button: 'Añadir Horario/Información',
          remove_button: 'Eliminar',
          hour_number: 'Ítem',
          title_label: 'Título',
          title_placeholder: 'Ej.: Recepción, Piscina, Restaurante',
          description_label: 'Horario e Información',
          description_placeholder:
            'Describa el horario de funcionamiento e información adicional (Ej.: 08:00 - 22:00, no funciona los fines de semana)',
        },
        services: {
          title: 'Servicios del Hotel',
          add_button: 'Añadir Servicio',
          remove_button: 'Eliminar',
          service_number: 'Servicio',
          service_title_label: 'Título del Servicio',
          service_title_placeholder: 'Ej.: Room Service',
          service_description_label: 'Descripción',
          service_description_placeholder: 'Describa el servicio',
        },
        ramal: {
          title: 'Extensión del Hotel',
          add_button: 'Agregar Extensión',
          remove_button: 'Eliminar',
          ramal_number: 'Extensión',
          ramal_title_label: 'Título de la Extensión',
          ramal_title_placeholder: 'Ej.: 504',
          ramal_description_label: 'Descripción',
          ramal_description_placeholder: 'Describa la extensión',
        },
        about: {
          description_label: 'Acerca del Hotel',
          description_placeholder:
            'Describa información general sobre el hotel, historia, características únicas y especiales',
        },
        actions: {
          save_button: 'Guardar',
        },
        messages: {
          error_title: 'Error',
          error_text: 'No fue posible guardar la información del hotel.',
          success_title: '¡Guardado!',
          success_text: 'Información del hotel guardada con éxito.',
          required_phone: 'El teléfono es obligatorio.',
          required_email: 'El e-mail es obligatorio.',
          required_hours: 'Todos los ítems deben tener título y descripción.',
          required_service: 'Todos los servicios deben tener título y descripción.',
          required_ramal: 'Todas las extensiones deben tener título y descripción.',
        },
      },
      hospitality_schedules: {
        page_title: 'Programación del Hotel',
        page_subtitle: 'Gestione eventos y programaciones del hotel.',
        new_button: 'Nueva Programación',
        edit_button: 'Editar Programación',
        delete_button: 'Eliminar Programación',
        delete_confirm:
          '¿Está seguro de que desea eliminar esta programación? Esta acción no se puede deshacer.',
        table: {
          title: 'Título',
          type: 'Tipo',
          location: 'Local',
          time: 'Horario',
          recurrence: 'Recurrencia',
          period: 'Período',
          status: 'Estado',
          actions: 'Acciones',
          active: 'Activo',
          inactive: 'Inactivo',
          single_event: 'Evento único',
          all_types: 'Todos',
          all_status: 'Todos los estados',
          age_group: 'Grupo de Edad',
        },
        filters: {
          type: 'Tipo',
          type_placeholder: 'Seleccione el tipo',
          status: 'Estado',
          status_placeholder: 'Seleccione el estado',
          date_init: 'Fecha Inicial',
          date_init_placeholder: 'Fecha de inicio',
          date_end: 'Fecha Final',
          date_end_placeholder: 'Fecha de fin',
          search: 'Buscar',
          clear: 'Limpiar Filtros',
        },
        messages: {
          load_error: '¡Error al cargar las programaciones!',
          delete_success: '¡Programación eliminada con éxito!',
          delete_error: '¡Error al eliminar la programación!',
        },
        types: {
          activity: 'Entretenimiento',
          food: 'Gastronomía',
          event: 'Evento',
          tour: 'Paseo',
        },
        age_groups: {
          all: 'Todos',
          children: 'Niños',
          teens: 'Adolescentes',
          adults: 'Adultos',
          seniors: 'Mayores',
          family: 'Familia',
        },
        singleEvent: 'Evento Único',
      },
      hospitality_schedule_edit: {
        page_title: 'Editar Programación',
        page_subtitle: 'Editando: {{title}}',
        not_found: {
          title: 'Programación no encontrada',
          description: 'La programación que está intentando editar no fue encontrada.',
          back_button: 'Volver a la Lista',
        },
        form: {
          type_label: 'Tipo',
          type_placeholder: 'Seleccione el tipo',
          type_sports: 'Deportes',
          type_wellness: 'Bienestar',
          type_other: 'Otro',
          title_label: 'Título',
          title_placeholder: 'Escriba el título de la programación',
          description_label: 'Descripción',
          description_placeholder: 'Describa la programación',
          location_label: 'Local',
          location_placeholder: 'Local de la programación',
          time_label: 'Horario',
          time_placeholder: 'Ej: 14:00 - 16:00 o 14:00',
          time_smalltext: 'Formato: "HH:MM - HH:MM" o "HH:MM"',
          recurrence_config: 'Configuración de Recurrencia',
          single_event_radio: 'Evento Único - Evento que ocurre en fechas específicas',
          recurring_event_radio:
            'Evento Recurrente - Evento que se repite en días específicos de la semana',
          day_within_date_range_radio:
            'Evento dentro de un Rango de Fechas - Evento que ocurre dentro de un rango de fechas específico',
          days_of_week_label: 'Días de la Semana',
          selected_days: 'Seleccionados: {{days}}',
          date_init_label: 'Fecha Inicial',
          date_init_placeholder: 'Fecha de inicio',
          date_end_label: 'Fecha Final',
          date_end_placeholder: 'Fecha de fin (opcional)',
          status_label: 'Estado',
          back_button: 'Volver',
          save_button: 'Guardar Cambios',
        },
      },
      hospitality_schedule_create: {
        page_title: 'Nueva Programación',
        page_subtitle: 'Crear una nueva programación para el hotel',
        success: {
          title: '¡Éxito!',
          text: '¡Programación creada con éxito!',
        },
        error: {
          title: 'Error',
          text: '¡Error al crear programación!',
        },
        form: {
          title_label: 'Título *',
          title_placeholder: 'Escriba el título de la programación',
          title_required: 'Título es obligatorio',
          type_label: 'Tipo *',
          type_placeholder: 'Seleccione el tipo',
          type_sports: 'Deportes',
          type_wellness: 'Bienestar',
          type_other: 'Otros',
          description_label: 'Descripción *',
          description_placeholder: 'Describa la programación',
          description_required: 'Descripción es obligatoria',
          location_label: 'Local *',
          location_placeholder: 'Local de la programación',
          location_required: 'Local es obligatorio',
          time_label: 'Horario *',
          time_placeholder: 'Ej: 14:00 - 16:00 o 14:00',
          time_smalltext: 'Formato: "HH:MM - HH:MM" o "HH:MM"',
          time_required: 'Horario es obligatorio',
          recurrence_config: 'Configuración de Recurrencia',
          single_event_radio: 'Evento Único - Evento que ocurre en fechas específicas',
          recurring_event_radio:
            'Evento Recurrente - Evento que se repite en días específicos de la semana',
          day_within_date_range_radio:
            'Evento dentro de un Rango de Fechas - Evento que ocurre dentro de un rango de fechas específico',
          days_of_week_label: 'Días de la Semana',
          selected_days: 'Seleccionados: {{days}}',
          date_init_label: 'Fecha Inicial',
          date_init_placeholder: 'Fecha de inicio',
          date_end_label: 'Fecha Final',
          date_end_placeholder: 'Fecha de fin (opcional)',
          status_label: 'Estado',
          back_button: 'Volver',
          save_button: 'Guardar',
        },
      },
      hospitality_banner: {
        page_title: 'Banners del Hotel',
        page_subtitle:
          'Gestione los banners de su hotel. Controle período de exhibición, orden y estado.',
        breadcrumb: {
          hospitality: 'Hospitalidad',
          publicity: 'Publicidad',
        },
        new_button: 'Nueva Publicidad',
        table: {
          title: 'Título',
          image: 'Imagen',
          order: 'Orden',
          period: 'Período',
          created_date: 'Fecha de Creación',
          status: 'Estado',
          actions: 'Acciones',
        },
        actions: {
          edit: 'Editar publicidad',
          view: 'Visualizar detalles',
          delete: 'Eliminar publicidad',
        },
        modal: {
          title: 'Publicidad #{{id}}',
          order: 'Orden',
          status: 'Estado',
          active: 'Activa',
          inactive: 'Inactiva',
          period: 'Período',
          created: 'Creado el',
          updated: 'Última actualización',
          image: 'Imagen',
          no_image: 'Sin imagen',
        },
        delete: {
          confirm_title: 'Confirmar eliminación',
          confirm_text: '¿Está seguro de que desea eliminar esta publicidad?',
          confirm_button: 'Sí, eliminar',
          cancel_button: 'Cancelar',
          success_title: 'Publicidad eliminada',
          success_text: '¡Eliminación realizada con éxito!',
        },
        status: {
          success_title: 'Estado actualizado',
          success_text: '¡Publicidad {{action}} con éxito!',
          activated: 'activada',
          deactivated: 'desactivada',
        },
        error: {
          title: 'Error',
          load_data: '¡Error al cargar datos de publicidad!',
          invalid_id: '¡ID inválido para eliminación!',
          delete: '¡Error al eliminar la publicidad!',
          status_change: '¡Error al cambiar el estado de la publicidad!',
        },
      },
      hospitality_banner_create: {
        page_title: 'Crear nuevo Banner del Hotel',
        page_subtitle: 'Rellene la información a continuación para crear un nuevo banner.',
        breadcrumb: {
          hospitality: 'Hospitalidad',
          publicity: 'Publicidad',
          create: 'Crear Publicidad',
        },
        form: {
          title_label: 'Título del Banner *',
          title_placeholder: 'Ej: Caminatas...',
          order_label: 'Orden de Visualización *',
          order_placeholder: 'Ej: 1, 2, 3...',
          order_smalltext:
            'Orden de prioridad de la publicidad (los números más pequeños aparecen primero)',
          status_label: 'Publicidad Activa',
          status_smalltext: 'Marque para activar la publicidad',
          start_date_label: 'Fecha de Inicio *',
          start_time_label: 'Hora de Inicio *',
          end_date_label: 'Fecha de Fin *',
          end_time_label: 'Hora de Fin *',
          image_label: 'Imagen de la Publicidad',
          image_select: 'Seleccionar una imagen',
          image_formats: 'Formatos aceptados: JPG, PNG, GIF',
          image_optional: 'Opcional - Se utilizará una imagen predeterminada si no se proporciona',
          image_preview: 'Vista previa de la Imagen',
          image_remove: 'Eliminar Imagen',
        },
        preview: {
          period_title: 'Período de la Publicidad:',
          start: 'Inicio',
          end: 'Fin',
        },
        validation: {
          title: 'Error de validación',
          order_positive: '¡El orden debe ser un número mayor que cero!',
          start_date_required: '¡La fecha de inicio es obligatoria!',
          end_date_required: '¡La fecha de fin es obligatoria!',
          dates_required: '¡Fechas y horarios son obligatorios!',
          start_before_end: '¡La fecha de inicio debe ser anterior a la fecha de fin!',
        },
        success: {
          title: 'Publicidad creada',
          text: '¡Publicidad creada con éxito!',
        },
        error: {
          title: 'Error',
          text: '¡Error al crear la publicidad!',
        },
      },
      hospitality_banner_update: {
        page_title: 'Editar Publicidad del Hotel',
        page_subtitle: 'Editando publicidad #{{id}}',
        breadcrumb: {
          edit: 'Editar Publicidad',
        },
        current_image: 'Imagen Actual',
        save_button: 'Guardar Cambios',
        not_found: {
          title: 'Publicidad no encontrada',
          text: 'La publicidad que está intentando editar no fue encontrada.',
          back_button: 'Volver a la Lista',
        },
        no_changes: {
          title: 'Ninguna alteración',
          text: '¡Ningún campo fue modificado!',
        },
        success: {
          title: 'Publicidad actualizada',
          text: '¡Publicidad actualizada con éxito!',
        },
        error: {
          title: 'Error',
          text: 'Error al actualizar publicidad',
          load_data: '¡Error al cargar datos de la publicidad!',
          update: '¡Error al actualizar la publicidad!',
        },
      },
      hospitality_publicity: {
        page_title: 'Banners Destacados del Hotel',
        page_subtitle:
          'Gestione los banners destacados de su hotel. Controle período de exhibición, orden y estado.',
        breadcrumb: {
          hospitality: 'Hospitalidad',
          publicity: 'Publicidad',
        },
        new_button: 'Nuevo Banner',
        table: {
          image: 'Imagen',
          order: 'Orden',
          period: 'Período',
          created_date: 'Fecha de Creación',
          status: 'Estado',
          actions: 'Acciones',
        },
        actions: {
          edit: 'Editar publicidad',
          view: 'Visualizar detalles',
          delete: 'Eliminar publicidad',
        },
        modal: {
          title: 'Publicidad #{{id}}',
          order: 'Orden',
          status: 'Estado',
          active: 'Activa',
          inactive: 'Inactiva',
          period: 'Período',
          created: 'Creado el',
          updated: 'Última actualización',
          image: 'Imagen',
          no_image: 'Sin imagen',
        },
        delete: {
          confirm_title: 'Confirmar eliminación',
          confirm_text: '¿Está seguro de que desea eliminar esta publicidad?',
          confirm_button: 'Sí, eliminar',
          cancel_button: 'Cancelar',
          success_title: 'Publicidad eliminada',
          success_text: '¡Eliminación realizada con éxito!',
        },
        status: {
          success_title: 'Estado actualizado',
          success_text: '¡Publicidad {{action}} con éxito!',
          activated: 'activada',
          deactivated: 'desactivada',
        },
        error: {
          title: 'Error',
          load_data: '¡Error al cargar datos de publicidad!',
          invalid_id: '¡ID inválido para eliminación!',
          delete: '¡Error al eliminar la publicidad!',
          status_change: '¡Error al cambiar el estado de la publicidad!',
        },
      },
      hospitality_publicity_create: {
        page_title: 'Crear Publicidad del Hotel',
        page_title_edit: 'Editar Publicidad del Hotel',
        page_subtitle: 'Rellene la información a continuación para crear una nueva publicidad.',
        breadcrumb: {
          hospitality: 'Hospitalidad',
          publicity: 'Publicidad',
          create: 'Crear Publicidad',
        },
        form: {
          order_label: 'Orden de Visualización *',
          order_placeholder: 'Ej: 1, 2, 3...',
          order_smalltext:
            'Orden de prioridad de la publicidad (los números más pequeños aparecen primero)',
          status_label: 'Publicidad Activa',
          status_smalltext: 'Marque para activar la publicidad',
          start_date_label: 'Fecha de Inicio *',
          start_time_label: 'Hora de Inicio *',
          end_date_label: 'Fecha de Fin *',
          end_time_label: 'Hora de Fin *',
          image_label: 'Imagen de la Publicidad',
          image_select: 'Seleccionar una imagen',
          image_formats:
            'Formatos aceptados: JPG, PNG, GIF | Dimensiones: ~200x112px | Tamaño máx: 2MB',
          image_optional: 'Opcional - Se utilizará una imagen predeterminada si no se proporciona',
          image_preview: 'Vista previa de la Imagen',
          image_remove: 'Eliminar Imagen',
          external_link_checkbox: 'Incluir Enlace Externo',
          external_link_label: 'Enlace Externo',
          external_link_placeholder: 'https://example.com',
          description_label: 'Descripción del Banner',
          description_smalltext: '* Máximo {qtd} caracteres',
          title_label: 'Título del Banner',
          title_placeholder: 'Ejemplo: Senderismo...',
          title_smalltext: '* Máximo {qtd} caracteres',
        },
        preview: {
          period_title: 'Período de la Publicidad:',
          start: 'Inicio',
          end: 'Fin',
        },
        validation: {
          title: 'Error de validación',
          order_positive: '¡El orden debe ser un número mayor que cero!',
          start_date_required: '¡La fecha de inicio es obligatoria!',
          end_date_required: '¡La fecha de fin es obligatoria!',
          dates_required: '¡Fechas y horarios son obligatorios!',
          start_before_end: '¡La fecha de inicio debe ser anterior a la fecha de fin!',
          external_link_required:
            '¡El enlace externo es obligatorio cuando se selecciona la opción!',
          image_size_error: '¡La imagen debe tener un tamaño máximo de 2MB!',
          image_dimensions_error:
            '¡Las dimensiones de la imagen deben ser aproximadamente 200x112 píxeles! Actual: {{current}}',
          image_invalid: '¡Archivo de imagen inválido! Por favor, seleccione una imagen válida.',
        },
        success: {
          title: 'Publicidad creada',
          text: '¡Publicidad creada con éxito!',
        },
        error: {
          title: 'Error',
          text: '¡Error al crear la publicidad!',
          update: '¡Error al actualizar la publicidad!',
        },
        not_found: {
          title: 'Publicidad no encontrada',
          text: 'La publicidad que está intentando editar no fue encontrada.',
          back_button: 'Volver a la lista',
        },
        no_changes: {
          title: 'Sin alteraciones',
          text: '¡Ningún campo fue modificado!',
        },
        current_image: 'Imagen Actual',
      },
      // Adicionar ao arquivo
      service_list: {
        filters: {
          categories: 'Categorías',
          category_placeholder: 'Categoría',
          filter_button: 'Filtrar',
          all_categories: 'TODOS',
        },
        table: {
          schedule: 'Horario',
          extension: 'Extensión',
        },
        actions: {
          delete_service: 'Eliminar Servicio',
        },
      },
      // Adicionar ao arquivo
      service_create: {
        page_title: 'Registrar Servicio',
        breadcrumb: {
          services: 'Servicios',
          create: 'Crear',
        },
        form: {
          classification_placeholder: 'Seleccione una clasificación',
          name_label: 'Nombre',
          name_placeholder: 'Nombre del servicio',
          description_label: 'Descripción',
          description_placeholder: 'Descripción del servicio',
          schedule_label: 'Horario de Funcionamiento',
          schedule_placeholder: 'Ej: 24h, 08:00-18:00, Bajo demanda',
          schedule_smalltext: 'Máximo 50 caracteres',
          extension_label: 'Extensión',
          extension_placeholder: 'Ej: 1001, 2050',
          extension_smalltext: 'Máximo 10 caracteres',
          code_label: 'Código',
          code_placeholder: 'Código del servicio',
          order_label: 'Orden',
          order_placeholder: 'Orden de visualización',
          status_label: 'Estado',
          status_active: 'Activo',
          status_inactive: 'Inactivo',
          external_link_label: 'Enlace Externo',
          external_link_placeholder: 'https://example.com',
          priority_label: 'Prioridad',
          priority_low: 'Baja',
          priority_normal: 'Normal',
          priority_high: 'Alta',
          priority_critical: 'Crítica',
        },
        icons: {
          title: 'Íconos',
          category_label: 'Categoría del Ícono',
          all_categories: 'Todos',
          selected_icon: 'Ícono seleccionado',
        },
        validation: {
          missing_fields_title: 'Campos faltantes',
          missing_fields_text:
            '¡Verifique si ha llenado todos los campos obligatorios: Nombre, Clasificación e Ícono!',
        },
        success: {
          title: 'Servicio registrado',
          text: '¡Registro realizado con éxito!',
        },
        error: {
          title: 'Error',
          text: '¡Error al registrar el servicio!',
          icons_load: 'Error al encontrar los tipos',
        },
      }, // Adicionar ao arquivo
      service_update: {
        page_title: 'Editar Servicio',
        page_title_full: 'Actualizar Servicio',
        breadcrumb: {
          edit: 'Editar',
        },
        error: {
          title: 'Error',
          load_data: '¡Error al cargar datos del servicio!',
          text: '¡Error al actualizar el servicio!',
        },
        success: {
          title: 'Servicio actualizado',
          text: '¡Edición realizada con éxito!',
        },
      },
      // Adicionar ao arquivo
      service_category_create: {
        validation: {
          missing_fields_title: 'Campos faltantes',
          missing_fields_text: '¡Verifique si ha llenado todos los campos!',
        },
        success: {
          title: 'Clasificación registrada',
          text: '¡Registro realizado con éxito!',
        },
        error: {
          title: 'Error',
          text: '¡Error al registrar la clasificación!',
          create: '¡Error al registrar clasificación!',
        },
      },

      // Adicionar ao arquivo
      service_category_list: {
        page_title: 'Categorías de Contenido',
        page_subtitle:
          'Aquí están listadas las categorías de contenido junto con sus respectivas acciones.',
        breadcrumb: {
          categories: 'Categorías',
        },
        add_button: 'Añadir',
        table: {
          name: 'Nombre',
          status: 'Estado',
          actions: 'Acciones',
        },
        actions: {
          edit_category: 'Editar categoría',
          delete_category: 'Eliminar categoría',
        },
        delete: {
          error_title: 'Error',
          error_text: '¡Error al eliminar la categoría!',
          success_title: 'Categoría eliminada',
          success_text: '¡Eliminación realizada con éxito!',
          confirm_title: '¿Está seguro?',
          confirm_text: '¡La categoría será eliminada y no se podrá restaurar!',
          cancel_button: '¡Cerrar!',
          confirm_button: '¡Eliminar!',
        },
      },
      service_category_update: {
        error: {
          title: 'Error',
          load_data: '¡Error al cargar datos de la clasificación!',
          text: '¡Error al actualizar la clasificación!',
          update: '¡Error al actualizar la clasificación!',
        },
        success: {
          title: 'Clasificación actualizada',
          text: '¡Edición realizada con éxito!',
        },
      },
      hotelRoom: {
        status: {
          available: 'Disponible',
          reserved: 'Reservado',
          maintenance: 'En Mantenimiento',
          occupied: 'Ocupado',
          being_cleaning: 'Siendo Limpiado',
        },
        type: {
          single: 'Individual',
          double: 'Doble',
          twin: 'Dos Camas',
          queen: 'Queen',
          king: 'King',
          suite: 'Suite',
          junior_suite: 'Suite Junior',
          master_suite: 'Suite Master',
          presidential: 'Suite Presidencial',
          family: 'Habitación Familiar',
          accessible: 'Habitación Accesible',
        },
      },
      hospitality_room_reservation: {
        create: {
          wizard_step_customer: 'Cliente',
          wizard_step_reservation: 'Reserva',
          wizard_step_confirmation: 'Confirmación',
          wizard_step1: 'Paso 1',
          wizard_step2: 'Paso 2',
          wizard_step3: 'Paso 3',
          wizard_customer_title: 'Seleccionar o Registrar Cliente',
          wizard_customer_search_placeholder: 'Buscar por nombre, email o teléfono...',
          wizard_customer_search_button: 'Buscar Cliente Existente',
          wizard_customer_new_button: 'Registrar Nuevo Cliente',
          wizard_customer_none_found: 'Ningún cliente encontrado',
          wizard_customer_showing_first:
            'Mostrando los primeros 20 resultados. Refine su búsqueda para encontrar otros clientes.',
          wizard_reservation_title: 'Datos de la Reserva',
          wizard_reservation_room_label: 'Habitación *',
          wizard_reservation_room_subtitle:
            'Haga clic en las habitaciones para seleccionarlas. Puede seleccionar múltiples habitaciones.',
          wizard_reservation_room_placeholder: 'Seleccione una habitación',
          wizard_reservation_status_label: 'Estado de la Reserva',
          wizard_reservation_status_placeholder: 'Seleccione el estado',
          wizard_reservation_checkin_label: 'Fecha y Hora de Check-in *',
          wizard_reservation_checkout_label: 'Fecha y Hora de Check-out *',
          wizard_reservation_password_label: 'Contraseña del Cliente',
          wizard_reservation_password_placeholder: 'Escriba la contraseña del cliente',
          wizard_reservation_generate_password: 'Generar contraseña',
          wizard_confirmation_title: 'Confirmar Reserva',
          wizard_confirmation_customer_data: 'Datos del Cliente',
          wizard_confirmation_reservation_data: 'Datos de la Reserva',
          wizard_confirmation_room: 'Habitación',
          wizard_confirmation_capacity: 'Capacidad',
          wizard_confirmation_price: 'Precio',
          wizard_confirmation_checkin: 'Check-in',
          wizard_confirmation_checkout: 'Check-out',
          wizard_confirmation_status: 'Estado',
          wizard_confirmation_password: 'Contraseña',
          wizard_confirmation_address: 'Dirección',
          wizard_confirmation_zipcode: 'Código Postal',
          wizard_confirmation_gender_male: 'Masculino',
          wizard_confirmation_gender_female: 'Femenino',
          wizard_confirmation_gender_other: 'Otro',
          wizard_confirmation_gender_not_informed: 'Prefiero no informar',
          wizard_buttons_back: 'Volver',
          wizard_buttons_cancel: 'Cancelar',
          wizard_buttons_next: 'Siguiente',
          wizard_buttons_create: 'Crear',
          wizard_page_title: 'Nueva Reserva de Habitación',
          wizard_page_subtitle: 'Crear nueva reserva para el hotel',
          legend: {
            title: 'Leyenda de Estado de Habitaciones',
            available: 'Disponible',
            selected: 'Seleccionado',
            unavailable: 'No Disponible',
            occupied: 'Ocupada',
            reserved: 'Reservada',
            being_cleaning: 'En Limpieza',
            maintenance: 'En Mantenimiento',
            no_info: 'Sin Información',
          },
        },
        customer_form: {
          title: 'Datos del Cliente',
          personal_info_title: 'Información Personal',
          cpf_label: 'CPF *',
          cpf_placeholder: '000.000.000-00',
          name_label: 'Nombre Completo *',
          name_placeholder: 'Escriba el nombre completo',
          email_label: 'E-mail *',
          email_placeholder: 'Escriba el e-mail',
          birthdate_label: 'Fecha de Nacimiento *',
          gender_label: 'Género',
          gender_placeholder: 'Seleccione el género',
          gender_male: 'Masculino',
          gender_female: 'Femenino',
          gender_other: 'Otro',
          contact_info_title: 'Información de Contacto',
          phone_label: 'Teléfono *',
          phone_placeholder: '(11) 99999-9999',
          phone_type_label: 'Tipo de Teléfono',
          phone_type_cell: 'Celular',
          phone_type_landline: 'Fijo',
          whatsapp_optin: 'Acepta recibir mensajes en WhatsApp',
          address_title: 'Dirección Residencial',
          cep_label: 'Código Postal *',
          cep_placeholder: '00000-000',
          street_label: 'Calle *',
          street_placeholder: 'Calle, Avenida, etc.',
          number_label: 'Número *',
          number_placeholder: '123',
          extra_label: 'Complemento',
          extra_placeholder: 'Apto, Bloque, etc.',
          district_label: 'Barrio *',
          district_placeholder: 'Nombre del barrio',
          city_label: 'Ciudad *',
          city_placeholder: 'Nombre de la ciudad',
          state_label: 'Estado *',
          state_placeholder: 'SP',
          reference_label: 'Punto de Referencia',
          reference_placeholder: 'Cerca del centro comercial, frente a la plaza, etc.',
          terms_title: 'Términos y Condiciones',
          accept_terms: 'Acepto los términos y condiciones de uso *',
          lgpd_consent: 'Autorizo el tratamiento de mis datos personales (LGPD) *',
        },
        title: 'Reservas de Habitaciones',
        subtitle: 'Gestión de reservas del hotel',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_reservation: 'Reservas',
        btn_new_reservation: 'Nueva Reserva',
        btn_confirm: 'Confirmar Reserva',
        btn_checkin: 'Hacer Check-in',
        btn_checkout: 'Hacer Check-out',
        btn_cancel: 'Cancelar Reserva',
        btn_no_show: 'Marcar como No Presentado',
        btn_delete: 'Eliminar Reserva',
        btn_details: 'Detalles Reserva',
        filter_status_label: 'Estado de la Reserva',
        filter_status_placeholder: 'Seleccione un estado',
        filter_status_all: 'Todos los Estados',
        table_reservation: 'Reserva',
        table_room: 'Habitación',
        table_customer: 'Cliente',
        table_checkin: 'Check-in',
        table_checkout: 'Check-out',
        table_status: 'Estado',
        table_price: 'Valor',
        table_actions: 'Acciones',
        status_confirmed: 'Confirmada',
        status_in_progress: 'En curso',
        status_completed: 'Concluida',
        status_cancelled: 'Cancelada',
        status_no_show: 'No Presentado',
        status_pending: 'Pendiente',
        msg_success_delete: '¡Eliminación realizada con éxito!',
        msg_success_update: '¡Estado de la reserva actualizado con éxito!',
        msg_error_delete: '¡Error al eliminar la reserva!',
        msg_error_update: '¡Error al actualizar el estado de la reserva!',
        msg_confirm_status_change: '¿Desea cambiar el estado de la reserva a "{status}"?',
        msg_confirm_checkin: '¿Desea hacer el check-in para esta reserva?',
        msg_confirm_checkout: '¿Desea finalizar el check-out? Esta acción no se puede deshacer.',
        msg_checkout_attention: '⚠️ ATENCIÓN - LEA ATENTAMENTE:',
        msg_checkout_list: [
          'El cliente ya efectuó el pago',
          'No hay pendientes financieras',
          'Todos los servicios han sido debidamente saldados',
        ],
        msg_checkout_confirm_read: 'Leí y confirmo que todas las validaciones fueron verificadas',
        msg_checkout_validation:
          'Debe confirmar que leyó y verificó todas las validaciones antes de proceder.',
        msg_confirm_delete: 'Eliminar Reserva',
        tab_basic: 'Información Básica',
        tab_summary: 'Resumen',
        tab_activities: 'Actividades',
        tab_tours: 'Paseos',
        tab_experiences: 'Experiencias',
        tab_services: 'Reservas de Servicios',
        tab_services_list: 'Listado de Servicios',
        tab_orders: 'Pedidos de Hotel',
        label_loading: 'Cargando...',
        label_loading_orders: 'Cargando pedidos...',
        label_order_details: 'Detalles del Pedido',
        label_no_data: 'Ningún pedido encontrado',
        label_pending: 'Ningún pedido está reservado en este momento.',
        tab_title: 'Pedidos de Hotel',
        label_order: 'Pedido',
        label_orders: 'Pedidos',
        label_total_spent: 'Total Gastado: {value}',
        label_total_orders: 'Total de Pedidos',
        label_total_spent_label: 'Total Gastado',
        label_total_paid_label: 'Total Pagado',
        label_products: 'Productos',
        label_quantity: 'Cantidad',
        label_sku: 'SKU',
        label_delivery: 'Entrega',
        label_delivery_address: 'Dirección de Entrega',
        label_withdraw_address: 'Dirección de Retiro',
        label_financial_summary: 'Resumen Financiero',
        label_products_label: 'Productos',
        label_delivery_fee: 'Tasa de Entrega',
        label_discount: 'Descuento',
        label_total: 'Total',
        label_payment_na: 'Pago N/A',
        label_payment_offline: 'Pago Offline',
        label_payment_card: 'Pago con Tarjeta',
        label_payment_credit: 'Crédito',
      },
      hospitality_room_reservation_tabs: {
        basic_info: {
          tab_title: 'Información Básica',
          label_customer: 'Cliente',
          label_room: 'Habitación',
          label_checkin: 'Check-in',
          label_checkout: 'Check-out',
          label_status: 'Estado',
          label_price: 'Valor',
          label_notes: 'Observaciones',
          placeholder_notes: 'Añada observaciones de la reserva',
          status_edit_warning:
            'El estado de la reserva no puede ser editado después de la confirmación o cancelación.',
          selected_room_details:
            'Habitación {roomNumber} - {type} (Capacidad: {capacity}) - R$ {price}',
          selected_customer_details: 'Cliente: {name} | Email: {email} | Teléfono: {phone}',
          optional_checkout: 'El check-out es opcional y se puede rellenar posteriormente.',
          status_pending: 'Pendiente',
          status_confirmed: 'Confirmada',
          status_in_progress: 'En curso',
          status_completed: 'Concluida',
          status_cancelled: 'Cancelada',
          summary_capacity: 'Capacidad',
          summary_people: 'personas',
          btn_change_password: 'Cambiar Contraseña',
        },
        summary: {
          tab_title: 'Resumen',
          room_details: 'Detalles de la Habitación',
          label_total: 'Total',
          label_paid: 'Pagado',
          label_pending: 'Pendiente',
          label_services: 'Servicios',
          label_products: 'Productos',
          label_activities: 'Actividades',
          label_experiences: 'Experiencias',
          label_tours: 'Paseos',
          label_room: 'Habitación',
          label_customer: 'Cliente',
          label_checkin: 'Check-in',
          label_checkout: 'Check-out',
          label_status: 'Estado',
          label_price: 'Valor',
          label_notes: 'Observaciones',
          label_capacity: 'Capacidad',
          label_people: 'Personas',
          label_orders: 'Pedidos de Hotel',
          label_payment_method: 'Método de Pago',
          label_discount: 'Descuento',
          label_tax: 'Tasa',
          label_total_with_tax: 'Total con Tasa',
          label_total_with_discount: 'Total con Descuento',
          label_total_paid: 'Total Pagado',
          label_total_pending: 'Total Pendiente',
          label_summary: 'Resumen de la Reserva',
          label_details: 'Detalles',
          label_edit: 'Editar',
          label_delete: 'Eliminar',
          label_confirm: 'Confirmar',
          label_cancel: 'Cancelar',
          label_no_data: 'Sin datos disponibles',
          label_success: '¡Operación realizada con éxito!',
          label_error: '¡Error en la operación!',
          label_warning: 'Atención',
          label_info: 'Información',
          label_actions: 'Acciones',
          label_service: 'Servicio',
          label_product: 'Producto',
          label_activity: 'Actividad',
          label_experience: 'Experiencia',
          label_tour: 'Paseo',
          label_order: 'Pedido',
          label_date: 'Fecha',
          label_time: 'Horario',
          label_type: 'Tipo',
          label_edit_reservation: 'Editar Reserva',
          label_delete_reservation: 'Eliminar Reserva',
          label_confirm_reservation: 'Confirmar Reserva',
          label_cancel_reservation: 'Cancelar Reserva',
          label_status_confirmed: 'Confirmada',
          label_status_in_progress: 'En curso',
          label_status_completed: 'Concluida',
          label_status_cancelled: 'Cancelada',
          label_status_no_show: 'No Presentado',
          label_status_pending: 'Pendiente',
        },
        activities: {
          tab_title: 'Actividades',
          label_activity: 'Actividad',
          label_activities: 'Actividades',
          label_no_data: 'Ninguna actividad encontrada',
          label_pending: 'Ninguna actividad está reservada en este momento.',
          label_people: 'Participantes',
          label_category: 'Categoría',
          label_location: 'Localización',
          label_session_time: 'Horario de la Sesión',
          label_skill_level: 'Nivel de Habilidad',
          label_special_requests: 'Solicitudes Especiales',
          label_price: 'Valor',
          label_date: 'Fecha',
          label_time: 'Horario',
          label_status: 'Estado',
          label_actions: 'Acciones',
          label_description: 'Descripción',
          status_confirmed: 'Confirmado',
          status_pending: 'Pendiente',
          status_cancelled: 'Cancelado',
          status_completed: 'Completado',
          btn_add_activity: 'Añadir Actividad',
        },
        experiences: {
          tab_title: 'Experiencias',
          label_experience: 'Experiencia',
          label_experiences: 'Experiencias',
          label_no_data: 'Ninguna experiencia encontrada',
          label_pending: 'Ninguna experiencia está reservada en este momento.',
          label_people: 'Participantes',
          label_category: 'Categoría',
          label_location: 'Localización',
          label_session_time: 'Horario de la Sesión',
          label_skill_level: 'Nivel de Habilidad',
          label_special_requests: 'Solicitudes Especiales',
          label_price: 'Valor',
          label_date: 'Fecha',
          label_time: 'Horario',
          label_status: 'Estado',
          label_actions: 'Acciones',
          label_description: 'Descripción',
          status_confirmed: 'Confirmado',
          status_pending: 'Pendiente',
          status_cancelled: 'Cancelado',
          status_completed: 'Completado',
          btn_add_experience: 'Añadir Experiencia',
          label_duration: 'Duración',
          label_rating: 'Evaluación',
          label_special_occasion: 'Ocasión Especial',
          label_includes: 'Incluye',
        },
        hotel_orders: {
          tab_title: 'Pedidos de Hotel',
          label_order: 'Pedido',
          label_orders: 'Pedidos',
          label_no_data: 'Ningún pedido encontrado',
          label_pending: 'Ningún pedido está reservado en este momento.',
          label_delivery: 'Entrega',
          label_quantity: 'Cantidad',
          label_sku: 'SKU',
          label_delivery_address: 'Dirección de Entrega',
          label_withdraw_address: 'Dirección de Retiro',
          label_financial_summary: 'Resumen Financiero',
          label_products: 'Productos',
          label_products_label: 'Productos',
          label_total_spent: 'Total Gastado: {value}',
          label_total_orders: 'Total de Pedidos',
          label_total_spent_label: 'Total Gastado',
          label_total_paid_label: 'Total Pagado',
          label_discount: 'Descuento',
          label_total: 'Total',
          label_payment_na: 'Pago N/A',
          label_payment_offline: 'Pago Offline',
          label_payment_card: 'Pago con Tarjeta',
          label_payment_credit: 'Crédito',
          label_delivery_fee: 'Tasa de Entrega',
          no_order_title: 'Ningún Pedido Encontrado',
        },
        tours: {
          tab_title: 'Paseos',
          label_tour: 'Paseo',
          label_tours: 'Paseos',
          label_no_data: 'Ningún paseo encontrado',
          label_pending: 'Ningún paseo está reservado en este momento.',
          label_people: 'Participantes',
          label_duration: 'Duración',
          label_difficulty: 'Dificultad',
          label_rating: 'Evaluación',
          label_transfer_included: 'Transfer Incluido',
          label_transfer_yes: 'Transfer Incluido',
          label_transfer_no: 'Sin Transfer',
          label_schedule: 'Horario',
          label_weather_concerns: 'Preocupaciones con el Clima',
          label_physical_requirements: 'Requisitos Físicos',
          label_special_requests: 'Solicitudes Especiales',
          label_price: 'Valor',
          label_date: 'Fecha',
          label_time: 'Horario',
          label_status: 'Estado',
          label_actions: 'Acciones',
          label_description: 'Descripción',
          status_confirmed: 'Confirmado',
          status_pending: 'Pendiente',
          status_cancelled: 'Cancelado',
          status_completed: 'Completado',
          btn_add_tour: 'Añadir Paseo',
        },
        services: {
          title: 'Reservas de Servicios',
          subtitle: 'Detalles de servicios reservados',
          no_services: 'No hay servicios reservados',
          service_info: 'Información del Servicio',
          service_name: 'Nombre del Servicio',
          service_type: 'Tipo de Servicio',
          description: 'Descripción',
          room_info: 'Información de Habitación',
          room_number: 'Habitación',
          booking_details: 'Detalles de Reserva',
          status: 'Estado',
          check_in: 'Check-in',
          check_out: 'Check-out',
          guest_name: 'Nombre del Huésped',
          reservation_name: 'Nombre de Reserva',
          number_of_rooms: 'Nº de Habitaciones',
          number_of_guests: 'Nº de Huéspedes',
          adults: 'Adultos',
          children: 'Niños',
          total_price: 'Precio Total',
          price_per_night: 'Precio por Noche',
          nights: 'Noches',
          additional_info: 'Información Adicional',
          booking_date: 'Fecha de Reserva',
          reservation_code: 'Código de Reserva',
          payment_status: 'Estado de Pago',
          special_requests: 'Solicitudes Especiales',
          service_details: 'Detalles del Servicio',
          view_details: 'Ver Detalles',
          total_services: 'Total de Servicios',
          active_services: 'Servicios Activos',
          pending_services: 'Servicios Pendientes',
          completed_services: 'Servicios Completados',
          service_image: 'Imagen del Servicio',
          no_image: 'Sin imagen disponible',
        },
        services_list: {
          title: 'Lista de Servicios',
          subtitle: 'Todos los servicios reservados',
          search_placeholder: 'Buscar por nombre, habitación o huésped...',
          filter_all: 'Todos',
          filter_active: 'Activos',
          filter_pending: 'Pendientes',
          filter_completed: 'Completados',
          table_service_name: 'Servicio',
          table_service_type: 'Tipo',
          table_room: 'Habitación',
          table_guest: 'Huésped',
          table_checkin: 'Check-in',
          table_checkout: 'Check-out',
          table_status: 'Estado',
          table_price: 'Precio',
          table_actions: 'Acciones',
          status_active: 'Activo',
          status_pending: 'Pendiente',
          status_completed: 'Completado',
          status_cancelled: 'Cancelado',
          no_services: 'No se encontraron servicios',
          no_services_desc: 'No hay servicios que coincidan con sus criterios',
          showing: 'Mostrando',
          of: 'de',
          services: 'servicios',
          items_per_page: 'Ítems por página',
          page: 'Página',
          previous: 'Anterior',
          next: 'Siguiente',
          view_details: 'Ver Detalles',
          total_found: 'Total encontrado',
          active_filters: 'Filtros activos',
          clear_filters: 'Limpiar filtros',
          filter_by_status: 'Filtrar por estado',
          search_active: 'Búsqueda activa',
          rooms: 'habitaciones',
          guests: 'huéspedes',
          nights: 'noches',
          loading: 'Cargando servicios...',
          error: 'Error al cargar servicios',
          retry: 'Reintentar',
          export: 'Exportar',
          refresh: 'Actualizar',
        },
      },
      hospitality_hotel_room: {
        label_room_number: 'Número de la Habitación *',
        image: 'Imagen de la Habitación',
        placeholder_room_number: 'Ej: 101, A201, Suite Presidencial',
        max_20_chars: 'Máximo 20 caracteres',
        label_status: 'Estado',
        label_capacity: 'Capacidad (personas)',
        placeholder_capacity: 'Ej: 2',
        label_price: 'Precio (R$)',
        placeholder_price: 'Ej: 150.00',
        label_type: 'Tipo de Habitación',
        title: 'Habitaciones de Hotel',
        subtitle: 'Gestión de habitaciones del hotel',
        create_multiples: 'Crear Múltiples Habitaciones',
        add_room: 'Añadir Habitación',
        header_number: 'Número',
        header_status: 'Estado',
        header_type: 'Tipo',
        header_capacity: 'Capacidad',
        header_price: 'Precio',
        header_actions: 'Acciones',
        action_edit: 'Editar Habitación',
        action_delete: 'Eliminar Habitación',
        modal_bulk_title: 'Crear Múltiples Habitaciones',
        modal_bulk_prefix: 'Prefijo (opcional)',
        modal_bulk_prefix_placeholder: 'Ej: A, B, 1º',
        modal_bulk_start: 'Número Inicial *',
        modal_bulk_start_placeholder: '101',
        modal_bulk_end: 'Número Final *',
        modal_bulk_end_placeholder: '110',
        modal_bulk_capacity: 'Capacidad',
        modal_bulk_capacity_placeholder: '2',
        modal_bulk_price: 'Precio',
        modal_bulk_price_placeholder: '150.00',
        modal_bulk_type: 'Tipo',
        type_single: 'Individual',
        type_double: 'Doble',
        type_twin: 'Twin',
        type_queen: 'Queen',
        type_king: 'King',
        type_suite: 'Suite',
        type_junior_suite: 'Suite Junior',
        type_master_suite: 'Suite Master',
        type_presidential: 'Presidencial',
        type_family: 'Familiar',
        type_accessible: 'Accesible',
        modal_bulk_cancel: 'Cancelar',
        modal_bulk_create: 'Crear Habitaciones',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_hotel_room: 'Habitaciones de Hotel',
        create_title: 'Crear Habitación de Hotel',
        create_subtitle: 'Añadir nueva habitación al hotel',
        edit_title: 'Editar Habitación de Hotel',
        edit_subtitle: 'Editar información de la habitación #{room}',
        breadcrumb_create: 'Crear Habitación',
        breadcrumb_edit: 'Editar Habitación',
      },
      hospitality_experiences: {
        tab_basic: 'Información Básica',
        edit: 'Editar Experiencia',
        edit_subtitle: 'Actualizar información de la experiencia',
        create: 'Crear Experiencia',
        create_subtitle: 'Rellene los detalles para crear una nueva experiencia',
        tab_details: 'Elementos detallados',
        tab_image: 'Imagen',
        tab_schedules: 'Horarios',
        list_title: 'Experiencias del Hotel',
        list_subtitle: 'Gestione todas las experiencias del hotel',
        field_title: 'Título',
        field_title_placeholder: 'Ej: Cena Romántica Exclusiva',
        field_description: 'Descripción',
        field_description_placeholder: 'Describa detalladamente la experiencia ofrecida...',
        field_image: 'Nueva Imagen',
        field_price: 'Precio (R$)',
        field_price_placeholder: '0.00',
        field_duration: 'Duración',
        field_duration_placeholder: 'Ej: 2 horas',
        field_type: 'Tipo de Experiencia',
        field_rating: 'Evaluación (0-5)',
      },
      services: {
        title: 'Reservas de Servicios',
        subtitle: 'Detalles de servicios reservados',
        no_services: 'No hay servicios reservados',
        service_info: 'Información del Servicio',
        service_name: 'Nombre del Servicio',
        service_type: 'Tipo de Servicio',
        description: 'Descripción',
        room_info: 'Información de Habitación',
        room_number: 'Habitación',
        booking_details: 'Detalles de Reserva',
        status: 'Estado',
        check_in: 'Check-in',
        check_out: 'Check-out',
        guest_name: 'Nombre del Huésped',
        reservation_name: 'Nombre de Reserva',
        number_of_rooms: 'Nº de Habitaciones',
        number_of_guests: 'Nº de Huéspedes',
        adults: 'Adultos',
        children: 'Niños',
        total_price: 'Precio Total',
        price_per_night: 'Precio por Noche',
        nights: 'Noches',
        additional_info: 'Información Adicional',
        booking_date: 'Fecha de Reserva',
        reservation_code: 'Código de Reserva',
        payment_status: 'Estado de Pago',
        special_requests: 'Solicitudes Especiales',
        service_details: 'Detalles del Servicio',
        view_details: 'Ver Detalles',
        total_services: 'Total de Servicios',
        active_services: 'Servicios Activos',
        pending_services: 'Servicios Pendientes',
        completed_services: 'Servicios Completados',
        service_image: 'Imagen del Servicio',
        no_image: 'Sin imagen disponible',
      },
      services_list: {
        title: 'Lista de Servicios',
        subtitle: 'Todos los servicios reservados',
        search_placeholder: 'Buscar por nombre, habitación o huésped...',
        filter_all: 'Todos',
        filter_active: 'Activos',
        filter_pending: 'Pendientes',
        filter_completed: 'Completados',
        table_service_name: 'Servicio',
        table_service_type: 'Tipo',
        table_room: 'Habitación',
        table_guest: 'Huésped',
        table_checkin: 'Check-in',
        table_checkout: 'Check-out',
        table_status: 'Estado',
        table_price: 'Precio',
        table_actions: 'Acciones',
        status_active: 'Activo',
        status_pending: 'Pendiente',
        status_completed: 'Completado',
        status_cancelled: 'Cancelado',
        no_services: 'No se encontraron servicios',
        no_services_desc: 'No hay servicios que coincidan con sus criterios',
        showing: 'Mostrando',
        of: 'de',
        services: 'servicios',
        items_per_page: 'Ítems por página',
        page: 'Página',
        previous: 'Anterior',
        next: 'Siguiente',
        view_details: 'Ver Detalles',
        total_found: 'Total encontrado',
        active_filters: 'Filtros activos',
        clear_filters: 'Limpiar filtros',
        filter_by_status: 'Filtrar por estado',
        search_active: 'Búsqueda activa',
        rooms: 'habitaciones',
        guests: 'huéspedes',
        nights: 'noches',
        loading: 'Cargando servicios...',
        error: 'Error al cargar servicios',
        retry: 'Reintentar',
        export: 'Exportar',
        refresh: 'Actualizar',
      },
      field_rating_placeholder: '0',
      field_status: 'Estado Activo',
      field_includes: 'Elementos Incluidos',
      field_includes_placeholder: 'Ej: Champán, decoración especial...',
      field_show_additional_services: 'Mostrar opciones de servicios predefinidas',
      field_actions: 'Acciones',
      status_active: 'Activo',
      status_inactive: 'Inactivo',
      no_rating: 'Sin evaluación',
      no_includes: 'Ningún elemento incluido',
      currency: 'R$',
      btn_add: 'Añadir Experiencia',
      btn_edit: 'Editar',
      btn_delete: 'Eliminar',
      btn_update: 'Actualizar Experiencia',
      btn_create: 'Crear Experiencia',
      btn_remove: 'Eliminar',
      btn_add_item: 'Añadir Elemento',
      edit_title: 'Editar Experiencia',
      create_title: 'Crear Experiencia',
      msg_success_create: '¡Experiencia creada con éxito!',
      msg_success_update: '¡Experiencia actualizada con éxito!',
      msg_success_delete: 'Experiencia eliminada',
      msg_success_delete_text: '¡Experiencia eliminada con éxito!',
      msg_error_create: 'Error al crear experiencia',
      msg_error_update: 'Error al actualizar experiencia',
      msg_error_delete: 'Error al eliminar experiencia',
      msg_error_delete_text: '¡No fue posible eliminar la experiencia!',
      msg_error_load: 'Error al cargar experiencia',
      msg_error_load_text: '¡No fue posible cargar los datos de la experiencia!',
      msg_error_required_title: '¡Título es obligatorio!',
      msg_error_title_length: '¡Título debe tener un máximo de 255 caracteres!',
      msg_error_required_description: '¡Descripción es obligatoria!',
      msg_error_required_price: '¡Precio es obligatorio!',
      msg_error_price_negative: '¡Precio debe ser mayor o igual a cero!',
      msg_error_required_duration: '¡Duración es obligatoria!',
      msg_error_duration_length: '¡Duración debe tener un máximo de 100 caracteres!',
      msg_error_required_includes: '¡Al menos un elemento debe estar incluido!',
      msg_error_rating_range: '¡La evaluación debe estar entre 0 y 5!',
      field_order: 'Orden',
      field_order_placeholder: 'Ej: 1, 2, 3...',
      header_order: 'Orden',
      msg_error_order_negative: '¡El orden debe ser mayor o igual a cero!',
    },
    entertainment_services: {
      list_title: 'Servicios de Entretenimiento',
      list_subtitle: 'Gestionar los servicios de entretenimiento disponibles',
      create: 'Crear Servicio de Entretenimiento',
      create_subtitle: 'Complete los detalles para crear un nuevo servicio',
      create_title: 'Crear Servicio de Entretenimiento',
      edit: 'Editar Servicio de Entretenimiento',
      edit_subtitle: 'Actualizar la información del servicio',
      edit_title: 'Editar Servicio de Entretenimiento',
      field_title: 'Título',
      field_title_placeholder: 'Ej: Spa y Masaje',
      field_type: 'Tipo de Servicio',
      field_status: 'Estado Activo',
      field_actions: 'Acciones',
      type_experience: 'Experiencia de Entretenimiento',
      type_activity: 'Actividad de Entretenimiento',
      type_tour: 'Tour de Entretenimiento',
      status_active: 'Activo',
      status_inactive: 'Inactivo',
      btn_add: 'Agregar Servicio',
      btn_edit: 'Editar',
      btn_delete: 'Eliminar',
      btn_update: 'Actualizar Servicio',
      btn_create: 'Crear Servicio',
      btn_search: 'Buscar',
      btn_clear: 'Limpiar',
      search_placeholder: 'Buscar por título...',
      msg_success_create: '¡Servicio creado con éxito!',
      msg_success_update: '¡Servicio actualizado con éxito!',
      msg_success_delete: 'Servicio eliminado',
      msg_success_delete_text: '¡Servicio eliminado con éxito!',
      msg_error_create: 'Error al crear servicio',
      msg_error_update: 'Error al actualizar servicio',
      msg_error_delete: 'Error al eliminar servicio',
      msg_error_delete_text: '¡No se pudo eliminar el servicio!',
      msg_error_load: 'Error al cargar servicio',
      msg_error_load_text: '¡No se pudo cargar los datos del servicio!',
      msg_error_required_title: '¡El título es obligatorio!',
      msg_error_title_length: '¡El título debe tener un máximo de 255 caracteres!',
    },
    hospitality_activities: {
      hotel_reservation: {
        page_title: 'Reservas de Servicios',
        details_title: 'Detalles de la Reserva',
        cancel_title: 'Cancelar Reserva',
        cancel_reason_label: 'Motivo de la Cancelación *',
        cancel_reason_placeholder: 'Seleccione el motivo de la cancelación',
        cancel_reason_select: 'Seleccione un motivo',
        type_tour: 'Paseo',
        type_experience: 'Experiencia',
        type_activity: 'Actividad',
        type_room_service: 'Servicio de Habitación',
        status_pending: 'Pendiente',
        status_confirmed: 'Confirmado',
        status_cancelled: 'Cancelado',
        status_completed: 'Concluido',
        error_title: 'Error',
        error_load: '¡Error al cargar las reservas!',
        error_details: '¡Error al cargar detalles de la reserva!',
        error_cancel: '¡Error al cancelar la reserva!',
        success_title: 'Éxito',
        success_cancel: '¡Reserva cancelada con éxito!',
        warning_title: 'Atención',
        warning_cancel_reason: 'Por favor, seleccione un motivo para la cancelación.',
        no_details: 'Detalles específicos no disponibles para este tipo de reserva.',
        reasons_tour: [
          'Cambio de planes',
          'Problemas climáticos',
          'Conflicto de horario',
          'Motivos de salud',
          'Cancelación del hotel',
        ],
        reasons_experience: [
          'Cambio de fecha de la estancia',
          'Ocasión especial cancelada',
          'Conflicto de agenda',
          'Motivos personales',
          'Preferencia por otro servicio',
        ],
        reasons_activity: [
          'No me siento preparado(a)',
          'Conflicto de horario',
          'Problemas de salud',
          'Cambio de planes',
          'Actividad no cumple expectativa',
        ],
        reasons_room_service: [
          'Cambio de planes',
          'Servicio no necesario',
          'Conflicto de horario',
          'Motivos personales',
          'Preferencia por otro servicio',
        ],
      },
      create_title: 'Crear Actividad del Hotel',
      create_subtitle: 'Añadir nueva actividad al hotel',
      edit_title: 'Editar Actividad del Hotel',
      edit_subtitle: 'Actualizar información de la actividad',
      list_title: 'Actividades del Hotel',
      list_subtitle: 'Gestión de actividades y entretenimiento',
      field_title: 'Título de la Actividad *',
      field_title_placeholder: 'Ej: Clase de Yoga, Show Musical, Recreación Infantil',
      field_title_hint: 'Máximo 255 caracteres',
      field_time: 'Horario *',
      field_time_placeholder: 'Ej: 08:00 - 09:00, Diariamente a las 15h',
      field_time_hint: 'Máximo 100 caracteres',
      field_description: 'Descripción *',
      field_description_placeholder:
        'Describa detalladamente la actividad, sus beneficios y lo que los huéspedes pueden esperar...',
      field_image: 'Imagen de la Actividad',
      field_location: 'Localización *',
      field_location_placeholder: 'Ej: Piscina principal, Salón de eventos, Playa',
      field_location_hint: 'Máximo 255 caracteres',
      field_capacity: 'Capacidad *',
      field_capacity_placeholder: 'Ej: 20, si 0 es ilimitado',
      field_capacity_hint: 'Máximo 50 caracteres',
      field_period: 'Periodo *',
      field_period_placeholder: 'Ej: 00:15 o 01:00 o 00:30',
      field_category: 'Categoría *',
      field_age_group: 'Rango de Edad',
      field_price: 'Precio (R$)',
      field_price_placeholder: '0.00 (deje vacío si es gratuito)',
      field_price_hint: 'Deje vacío para actividad gratuita',
      field_requires_reservation: 'Requiere Reserva',
      field_requires_reservation_hint: 'Marque si la actividad necesita reserva previa',
      field_is_active: 'Actividad Activa',
      field_is_active_hint: 'Desmarque para desactivar temporalmente la actividad',
      btn_edit: 'Editar Actividad',
      btn_delete: 'Eliminar Actividad',
      btn_create: 'Crear Actividad',
      btn_cancel: 'Cancelar',
      msg_success_create: '¡Actividad creada con éxito!',
      msg_success_update: '¡Actividad actualizada con éxito!',
      msg_success_delete: '¡Actividad eliminada con éxito!',
      msg_error_create: '¡Error al crear actividad!',
      msg_error_update: '¡Error al actualizar actividad!',
      msg_error_delete: '¡Error al eliminar actividad!',
      msg_error_load: '¡Error al cargar actividad!',
      msg_error_required_title: '¡Título es obligatorio!',
      msg_error_title_length: '¡Título debe tener un máximo de 255 caracteres!',
      msg_error_required_description: '¡Descripción es obligatoria!',
      msg_error_required_time: '¡Horario es obligatorio!',
      msg_error_time_length: '¡Horario debe tener un máximo de 100 caracteres!',
      msg_error_required_location: '¡Localización es obligatoria!',
      msg_error_location_length: '¡Localización debe tener un máximo de 255 caracteres!',
      msg_error_required_capacity: '¡Capacidad es obligatoria!',
      msg_error_capacity_length: '¡Capacidad debe tener un máximo de 50 caracteres!',
      msg_error_price_negative: '¡Precio debe ser mayor o igual a cero!',
      remove_schedule: 'Eliminar Horario',
      confirm_remove_schedule: '¿Está seguro de que desea eliminar este horario?',
      schedule_seasonal_start: 'Inicio de Temporada',
      schedule_seasonal_end: 'Fin de Temporada',
      schedule_start_time: 'Hora de Inicio',
      schedule_end_time: 'Hora de Fin',
      add_schedule: 'Añadir Horario',
      schedule_time: 'Hora *',
      schedule_time_placeholder: 'Ej.: 08:00 - 09:00, Diariamente a las 15h',
      schedule_description: 'Descripción *',
      schedule_days_of_week: 'Días de la Semana',
      schedule_status: 'Horario Activo',
      schedule_seasonal_hint: 'Defina un período estacional si aplica',
      field_duration_hint: 'Duración en horas y minutos (ej: 2h30min)',
      field_duration_placeholder: 'Duración en horas y minutos (ej: 2h30min)',
      field_order: 'Orden',
      field_order_placeholder: 'Ej: 1, 2, 3...',
      msg_error_order_negative: '¡El orden debe ser mayor o igual a cero!',
    },
    hotel_tour: {
      create_title: 'Crear Tour del Hotel',
      create_subtitle: 'Añadir nuevo paseo al hotel',
      edit_title: 'Editar Tour del Hotel',
      edit_subtitle: 'Actualizar información del paseo',
      list_title: 'Tours del Hotel',
      list_subtitle: 'Gestionar paseos y excursiones',
      field_title: 'Título del Paseo *',
      field_difficulty: 'Dificultad',
      field_duration: 'Duración',
      field_rating: 'Evaluación',
      field_participants: 'Participantes',
      field_schedules: 'Horarios',
      field_includes: 'Incluye',
      field_transfer: 'Transfer',
      field_currency: 'Moneda',
      field_currency_hint: 'Código de la moneda (ej: BRL, USD)',
      currency_brl: 'Real (BRL)',
      currency_usd: 'Dólar (USD)',
      currency_eur: 'Euro (EUR)',
      field_rating_placeholder: '0.0',
      field_rating_hint: 'Evaluación de 0 a 5 estrellas',
      field_participants_min: 'Participantes Mínimos *',
      field_participants_min_hint: 'Número mínimo de participantes',
      field_participants_max: 'Participantes Máximos',
      field_participants_max_placeholder: 'Deje vacío si es ilimitado',
      field_participants_max_hint: 'Número máximo de participantes (opcional)',
      field_age_restriction: 'Restricción de Edad',
      field_age_restriction_placeholder: 'Ej: Mayor de 12 años, No recomendado para menores de 18',
      field_age_restriction_hint: 'Restricciones de edad (opcional)',
      field_physical_requirements: 'Requisitos Físicos',
      field_physical_requirements_placeholder:
        'Ej: Buena condición física, Capacidad de caminar largas distancias',
      field_physical_requirements_hint: 'Requisitos físicos necesarios (opcional)',
      field_cancellation_hours: 'Cancelación (horas) *',
      field_cancellation_hours_hint: 'Horas antes para cancelación',
      field_discount_children: 'Descuento Niños (%)',
      field_discount_children_hint: 'Descuento en porcentaje',
      field_weather_dependent: 'Depende del Clima',
      field_weather_dependent_hint: 'Marque si depende de las condiciones climáticas',
      field_is_active: 'Tour Activo',
      field_is_active_hint: 'Desmarque para desactivar temporalmente',
      tab_basic: 'Información Básica',
      tab_details: 'Detalles y Configuraciones',
      tab_schedules: 'Horarios',
      tab_includes: 'Elementos Incluidos',
      tab_image: 'Imagen',
      no_schedule_added: 'Ningún horario añadido',
      click_add_schedule: 'Haga clic en "Añadir Horario" para comenzar.',
      includes_title: 'Elementos Incluidos en el Tour',
      selected: 'Seleccionados',
      field_image_hint: 'Seleccione una imagen representativa del tour',
      update_info: 'Actualizar información del tour',
      field_title_placeholder: 'Ej: City Tour, Excursión a la Playa, Caminata Histórica',
      field_title_hint: 'Máximo 255 caracteres',
      field_time: 'Horario *',
      field_time_placeholder: 'Ej: 08:00 - 09:00, Diariamente a las 15h',
      field_time_hint: 'Máximo 100 caracteres',
      field_description: 'Descripción *',
      field_description_placeholder:
        'Describa el paseo, destacados y lo que los huéspedes pueden esperar...',
      field_image: 'Imagen del Paseo',
      field_location: 'Localización *',
      field_location_placeholder: 'Ej: Centro, Playa, Museo',
      field_location_hint: 'Máximo 255 caracteres',
      field_capacity: 'Capacidad *',
      field_capacity_placeholder: 'Ej: 20 personas, Ilimitado, 10-15 participantes',
      field_capacity_hint: 'Máximo 50 caracteres',
      field_category: 'Categoría *',
      field_price: 'Precio (R$)',
      field_price_placeholder: '0.00 (deje vacío si es gratuito)',
      field_price_hint: 'Deje vacío para paseo gratuito',
      field_requires_reservation: 'Requiere Reserva',
      field_requires_reservation_hint: 'Marque si el paseo necesita reserva previa',
      btn_edit: 'Editar Paseo',
      btn_delete: 'Eliminar Paseo',
      btn_create: 'Crear Paseo',
      btn_cancel: 'Cancelar',
      table_title: 'Título',
      table_time: 'Horario',
      table_location: 'Localización',
      table_category: 'Categoría',
      table_price: 'Precio',
      table_capacity: 'Capacidad',
      table_actions: 'Acciones',
      msg_success_create: '¡Paseo creado con éxito!',
      msg_success_update: '¡Paseo actualizado con éxito!',
      msg_success_delete: '¡Paseo eliminado con éxito!',
      msg_error_create: '¡Error al crear paseo!',
      msg_error_update: '¡Error al actualizar paseo!',
      msg_error_delete: '¡Error al eliminar paseo!',
      msg_error_load: '¡Error al cargar paseo!',
      msg_error_required_title: '¡Título es obligatorio!',
      msg_error_title_length: '¡Título debe tener un máximo de 255 caracteres!',
      msg_error_required_description: '¡Descripción es obligatoria!',
      msg_error_required_time: '¡Horario es obligatorio!',
      msg_error_time_length: '¡Horario debe tener un máximo de 100 caracteres!',
      msg_error_required_location: '¡Localización es obligatoria!',
      msg_error_location_length: '¡Localización debe tener un máximo de 255 caracteres!',
      msg_error_required_capacity: '¡Capacidad es obligatoria!',
      msg_error_capacity_length: '¡Capacidad debe tener un máximo de 50 caracteres!',
      msg_error_price_negative: '¡Precio debe ser mayor o igual a cero!',
      schedule_start_time: 'Hora de Inicio',
      schedule_end_time: 'Hora de Fin',
      add_schedule: 'Añadir Horario',
      schedule_time: 'Hora *',
      schedule_time_placeholder: 'Ej.: 08:00 - 09:00, Diariamente a las 15h',
      schedule_description: 'Descripción *',
      schedule_days_of_week: 'Días de la Semana',
      schedule_status: 'Horario Activo',
      schedule_seasonal_hint: 'Defina un período estacional si aplica',
      field_duration_hint: 'Duración en horas y minutos (ej: 2h30min)',
      field_duration_placeholder: 'Duración en horas y minutos (ej: 2h30min)',
      schedule_seasonal_start: 'Inicio de Temporada',
      schedule_seasonal_end: 'Fin de Temporada',
      difficult: {
        easy: 'Fácil',
        medium: 'Moderado',
        hard: 'Difícil',
        extreme: 'Extremo',
      },
      field_order: 'Orden',
      field_order_placeholder: 'Ej: 1, 2, 3...',
      header_order: 'Orden',
      msg_error_order_negative: '¡El orden debe ser mayor o igual a cero!',
    },
    months: {
      jan: 'Ene',
      feb: 'Feb',
      mar: 'Mar',
      apr: 'Abr',
      may: 'May',
      jun: 'Jun',
      jul: 'Jul',
      aug: 'Ago',
      sep: 'Sep',
      oct: 'Oct',
      nov: 'Nov',
      dec: 'Dic',
    },
    permissions: {
      food: 'Smart Order',
      smartorder: 'Gestión de Productos',
      message_warning_find_variation:
        '¡Atención! Para gestionar las variaciones de un producto, debe acceder a la sección de "Variaciones" dentro del módulo de "Productos".',
      category: 'Categorías',
      subcategory: 'Subcategorías',
      product: 'Productos',
      mark: 'Marcas',
      grid: 'Grillas',
      variation: 'Variaciones',
      catalog: 'Catálogos',
      integration: 'Integraciones',
      int_pos: 'PDV',
      int_gateway: 'Medio de Pago',
      messaging: 'Mensajería',
      sms: 'Estado y SMS',
      multichannel: 'Multicanal',
      report: 'Informes',
      saleorder: 'Pedidos',
      indicators: 'Indicadores',
      orderReport: 'Pedidos',
      imports: 'Importación de Imágenes',
      importProductImage: 'Productos',
      importProductImageSKU: 'Variaciones',
      importCategoryImage: 'Categorías',
      customers: 'Clientes',
      customer_report: 'Lista de Clientes',
      measurement_unit: 'Unidades de Medida',
      logs: 'Logs',
      settings: 'Configuraciones',
      charge_integration: 'Cargas',
      summaryAccess: 'Accesos',
      sellerAccess: 'Dash Vendedor',
      managerAccess: 'Dash Gerente',
      managerGroupAccess: 'Dash Gestor del Grupo',
      orders: 'Pedidos',
      support: 'Soporte',
      translate: 'Idiomas y Relaciones',
      application: 'Webapp',
      messenger: 'Mensajería',
      others: 'Otros',
      settings_store: 'Configuraciones de la Tienda',
      settings_hotel: 'Configuraciones ',
      modalities: 'Modalidades',
      delivery_tax: 'Tasa de entrega',
      shifts: 'Turnos',
      whatsappweb: 'WhatsApp Web',
      filemanager: 'Gestor de Archivos',
      payment_plans: 'Planes de Pago',
      settings_account: 'Configuraciones de la Cuenta',
      account: 'Cuenta',
      groups: 'Grupos',
      users: 'Usuarios',
      terms: 'Términos',
      highlights: 'Destacados',
      menu: 'Menú',
      productReport: 'Productos',
      optional: 'Lista de Adicionales',
      locations: 'Sectores',
      stores_location: 'Establecimientos',
      service: 'Servicios',
      service_items: 'Servicios',
      service_category: 'Categorías',
      feed: 'Feed',
      content: 'Interfaz del Webapp',
      buttons: 'Botones',
      sessions: 'Sesiones',
      structured_content: 'Servicios Esenciales',
      orders_room_service: 'Pedidos de Habitación',
      orders_activities: 'Pedidos de Actividades',
      queue: 'Fila de espera',
      queue_config: 'Configuraciones',
      queue_manager: 'Gestión',
      checkout: 'Datos del Cliente',
      booking: 'Reserva',
      booking_management: 'Gestión',
      booking_config: 'Configuraciones',
      booking_environment: 'Ambientes',
      booking_day: 'Reservas del día',
      booking_report: 'Informes',
      booking_managerday: 'Gestión de Reservas Diarias',
      booking_management_dashboard: 'Panel de Gestión de Reservas',
      table_management: 'Gestión de Mesas',
      table_allocation_report: 'Informe de Asignación de Mesas',
      table_management_dashboard: 'Panel de Gestión de Mesas',
      liveShop: 'Live Commerce',
      icon_library: 'Biblioteca de Íconos',
      stores: 'Tiendas/Clientes',
      segments: 'Segmentos',
      payment: 'Pagos',
      serviceCategory: 'Categoría del Servicio',
      SDS: 'KDS',
      sds_manage: 'Mis KDS',
      sds_layout: 'Personalización',
      sds_link: 'Configuraciones',
      sds_display: 'Displays',
      /* Agregador */
      config: 'Configuraciones',
      config_account: 'Datos de la cuenta',
      config_sector: 'Sector de actuación',
      config_user: 'Usuarios',
      config_term: 'Términos',
      subCategory: 'Subcategoría',
      footer: 'Recursos del pie de página',
      footerFeature: 'Habilitar recursos',
      footerContent: 'Feed de recursos',
      footerContentAddEdit: 'Recursos',
      webapp: 'Personalizar',
      webapp_qrcode: 'Generar Código QR',
      ia_menu: 'Inteligencia Artificial',
      ia_config: 'Configuraciones',
      ia_fit: 'Entrenamiento',
      ia_file_manager: 'Gestor de Archivos',
      ia_folders: 'Carpetas',
      ia_files: 'Archivos',
      ia_settings: 'Configuraciones',
      ia_folders_blank: 'Ninguna carpeta encontrada',
      ia_filter: 'Filtrar',
      ia_recharge: 'Recargar',
      ia_final_date: 'Fecha Final',
      ia_initial_date: 'Fecha Inicial',
      summarize: 'Dashboard',
      consumption: 'Consumo IA',
      ct_account: 'Consumo y Valor',
      ct_s3_account: 'Cuenta S3',
      ct_data_cost_account: 'Datos y Costos',
      publication_highlight_banner: 'Banner Destacado',
      publication: 'Publicidad',
      cost: 'Costos',
      security_settings: 'Configuraciones de seguridad',
      coupon: 'Cupón',
      clean_safe: 'Clean & Safe',
      service_requests: 'Formularios de Servicio',
      grid_hotel: 'Grilla de Servicios',
      /*Hotelaria */
      hotel_maintenance: 'Mantenimiento',
      hotel_room: 'Habitación',
      hotel_reservation: 'Reservas de Habitación',
      hotel_activities_experiences: 'Actividades y Experiencias',
      hotel_activities: 'Actividades',
      hotel_tour: 'Tour Hotel',
      hotel_tour_schedules: 'Horarios Tour Hotel',
      hotel_tour_reservation: 'Reservas Generales',
      hotel_experiences: 'Experiencias',
      hotel_info: 'Información',
      hotel_reservations: 'Reservas',
      hotel_schedules: 'Programación del Hotel',
      publication_banner: 'Banner',
      feed_back: 'Feed Back',
      feedback_satisfaction: 'Encuesta y Satisfacción',
      grid_hotel_feedback: 'Grillas',
      feedback_list: 'Formularios',
      feedback: 'Resultados',
      post: 'Publicaciones',
      post_category: 'Categoría de Publicaciones',
      post_content: 'Contenido de la Publicación',
      booking_hotel: 'Gestión de Reservas',
      grid_hotel_booking: 'Grillas de Servicios',
      booking_config_hotel: 'Reservas de Servicios',
      page_publications: 'Página de Publicaciones',
      communication: 'Comunicación',
      communicationCenter: 'Central de Comunicación',
      hotel_management: 'Gestión del Hotel',
      hotel_management_entertainment: 'Entretenimiento',
    },
    customer: {
      select_group: 'Seleccione un grupo',
      select: 'Seleccionar',
      create: 'Crear cliente',
      create_group: 'Crear grupo',
      edit: 'Visualizar cliente',
      search_custom: 'Buscar...',
      customer: 'Clientes',
    },

    buttons: {
      create: 'Crear',
      back: 'Volver',
      previous: 'Anterior',
      register_pluginspace: 'Registrar Pluginspace',
      access: 'Acceder',
      add_modality: 'Añadir modalidad',
      add_km: 'Añadir Km',
      zip_code_list: 'Lista de Códigos Postales',
      add_zip_code: 'Añadir Código Postal',
      area: 'Áreas de Envío',
      list_of_negative_renge_zip_code: 'Lista de Códigos Postales negativos',
      add_negative_zip_code: 'Añadir Código Postal negativo',
      add_user: 'Añadir usuario',
      generate_password: 'Generar contraseña',
      generate_sku: 'Generar SKU',
      add_group: 'Añadir grupo',
      save: 'Guardar',
      add_term: 'Añadir término',
      add_integration: 'Añadir integración',
      filter: 'Filtrar',
      search: 'Buscar',
      register_product: 'Registrar Producto',
      choose_files: 'Elegir archivos',
      add_categories: 'Añadir categorías',
      add_subcategories: 'Añadir subcategorías',
      add_brand: 'Añadir marca',
      close: 'Cerrar',
      add_grade: 'Añadir grilla',
      add: 'Añadir',
      add_variation: 'Añadir variación',
      confirm_grades: 'Confirmar grillas',
      add_catalog: 'Añadir catálogo',
      generete_qr_code: 'Generar Código QR',
      personalize: 'Personalizar',
      settings: 'Configuraciones',
      add_interval: 'Añadir intervalo',
      add_gateway: 'Añadir gateway',
      overview: 'Vista general',
      view: 'Visualizar',
      load_csv: 'Cargar archivo',
      download_csv: 'Descargar XLSX Estándar',
      att_page: 'Actualizar página',
      export: 'Exportar',
      add_service: 'Registrar Servicio',
      add_environment: 'Añadir ambiente',
      generate_ia: 'Proponer',
      clear_table_card: 'Limpiar mesa o comanda',
      propose_image: 'Proponer imagen',
      cancel: 'Cancelar',
      next: 'Siguiente',
    },

    global: {
      success: 'Éxito',
      error: 'Error',
      warning: 'Atención',
      active: 'Activo',
      inactive: 'Inactivo',
    },

    modals: {
      warning_confirm: '¿Está seguro?',
      warning_save: 'Guardar',
      warning_close: 'Cerrar',
      text_close: 'Cerrar',
    },

    general: {
      delete_item: '¿Desea eliminar este ítem?',
      delete_product_observation:
        'Las variaciones de este producto también serán eliminadas, ¿desea continuar de todas formas?',
      delete_classification_observation:
        'Al eliminar esta categoría, todos los productos relacionados con ella irán a General, ¿desea continuar?',
      delete: 'Eliminar',
      edit: 'Editar',
      duplicate: 'Duplicar',
      attention: 'Atención',
      actions: 'Acciones',
      here_are_listed_the_modalities_along_with_their_respective_actions:
        'Aquí están listados los ítems junto con sus respectivas acciones',
      fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
        'Rellene la información a continuación y haga clic en el botón crear para guardar los cambios',
      save_changes_edit:
        'Rellene la información a continuación y haga clic en el botón guardar para confirmar los cambios',
      save_changes_duplicate:
        'Valide o cambie la información a continuación y haga clic en el botón guardar para confirmar los cambios',
      active: 'Activo',
      inactive: 'Inactivo',
      showing: 'Mostrando',
      of: 'de',
      to: 'a',
      records: 'registros',
      today: 'Hoy',
      copy: 'Copiar',
      linkS3: 'Enlace',
      linkedS3: 'Vinculado',
      downloadS3: 'Descargar',
      downloadedS3: 'Descarga Iniciada',
      copied: 'Copiado',
      copy_link: 'Copiar enlace del vendedor',
      test: 'Probar',
      success: 'Éxito',
      error: 'Error',
      paymentFree: 'Gratis',
    },

    pluginspaces: {
      hospitality: 'Hoteles',
      food: 'Food',
      healthcare: 'Hospitalidad',
      varejo: 'Venta al por menor',
      fashion: 'Moda',
    },

    dashboard: {
      totals_by_products: 'Totales por producto',
      totals_by_category: 'Totales por categoría',
      last_orders: 'Últimos pedidos',
      products: 'Productos',
      quantity: 'Cantidad',
      total: 'Total',
      category: 'Categoría',
      welcome: 'Bienvenido a Ninegrid',
      describe_dashboard:
        'Aquí tiene todas las herramientas para gestionar su tienda de forma sencilla y eficiente. Explore los menús laterales para navegar por nuestras funcionalidades. ¡Buen trabajo!',
    },

    modalities: {
      modalities: 'Modalidades',
      modalitie: 'Modalidad',
      here_are_listed_the_modalities_along_with_their_respective_actions:
        'Aquí están listadas las modalidades junto con sus respectivas acciones',
      delivery: 'Entrega',
      withdraw: 'Retiro',
      active: 'Activo',
      inactive: 'Inactivo',
      name: 'Nombre',
      code: 'Código',
      actions: 'Acciones',
      search: 'Buscar',
      type: 'Tipo',
      sector_name: 'Nombre del sector',
      table: 'Mesa',
      room: 'Habitación',
      counter: 'Mostrador',
      internal: 'Entrega Interna',
      synkar: 'Synkar',
    },

    delivery_fee: {
      delivery_fee: 'Tasa de entrega',
      create_delivery_fee: 'Crear tasa de entrega',
      edit_delivery_fee: 'Editar tasa de entrega',
      fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
        'Rellene la información a continuación y haga clic en el botón crear para guardar los cambios',
      save_changes_edit:
        'Rellene la información a continuación y haga clic en el botón guardar para confirmar los cambios',
      km_min: 'Km Mínimo',
      km_max: 'Km Máximo',
      value: 'Valor',
      actions: 'Acciones',
      patterns: 'Patrones de Importación',
      import_file:
        'Para importar los archivos, la primera celda del archivo debe seguir uno de los siguientes patrones:',
      import_delivery: 'Para importar por rango: kmmin, kmmax, Valor',
      import_cep: 'Para importar Código Postal: cep_inicio, cep_fin, valor',
      import_cep_negative: 'Para importar Código Postal negativo: cep_inicio, cep_fin',
      model: 'Modelo',
      continue_import:
        'Todos sus registros serán reemplazados, ¿está seguro de que desea continuar?',
      cep_delivery: 'Códigos Postales de Entrega',
      cep_info:
        'Aquí están listados los Códigos Postales de entrega junto con sus respectivas acciones.',
      cep_start: 'Código Postal Inicio',
      cep_end: 'Código Postal Fin',
      create_cep: 'Crear Códigos Postales de Entrega',
      edit_cep: 'Editar Códigos Postales de Entrega',
      cep_delivery_negative: 'Códigos Postales Negativos de Entrega',
      cep_info_negative:
        'Aquí están listados los Códigos Postales negativos de entrega junto con sus respectivas acciones.',
      create_cep_negative: 'Crear Código Postal Negativo',
      edit_cep_negative: 'Editar Código Postal Negativo',
      delete_cep_negative: 'Eliminar Código Postal Negativo',
    },

    user: {
      user: 'Usuarios',
      here_are_listed_the_users_along_with_their_respective_actions:
        'Aquí están listados los usuarios junto con sus respectivas acciones',
      fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
        'Rellene la información a continuación y haga clic en el botón crear para guardar los cambios',
      save_changes_edit:
        'Rellene la información a continuación y haga clic en el botón guardar para confirmar los cambios',
      picture: 'Foto',
      name: 'Nombre',
      type: 'Tipo',
      registration: 'Registro',
      create_user: 'Crear usuario',
      edit_user: 'Editar usuario',
      profile_picture: 'Imagen de perfil',
      password: 'Contraseña',
      generate_pass: 'Generar Contraseña',
      access_level: 'Grupo de acceso',
      select_a_access_level: 'Seleccione un grupo de acceso',
      select_type: 'Seleccione un tipo',
      active: 'Activo',
      actions: 'Acciones',
      discount_permission: 'Permiso para descuento en la venta',
      discount_value: 'Valor del descuento máximo (%)',
      phone: 'Número de teléfono',
    },

    groups: {
      groups: 'Grupos',
      group: 'Grupo',
      here_are_listed_the_groups_along_with_their_respective_actions:
        'Aquí están listados los grupos junto con sus respectivas acciones',
      name: 'Nombre',
      Integrations: 'Integraciones',
      means_of_payment: 'Medio de pago',
      products: 'Productos',
      category: 'Categorías',
      subcategory: 'Subcategoría',
      indicators: 'Indicadores',
      requests: 'Pedidos',
      reports: 'Informes',
      messenger: 'Mensajería',
    },

    shifts: {
      shifts: 'Turnos',
      here_are_listed_the_shifts_for_each_day_of_the_week:
        'Aquí están listados los turnos para cada día de la semana',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
      sunday: 'Domingo',
      start: 'Inicio',
      end: 'Fin',
    },

    account: {
      account: 'Cuenta',
      edit_account: 'Editar cuenta',
      registration_number: 'CNPJ',
      corporate_name: 'Razón social',
      customer_name: 'Nombre',
      name_of_the_establishment: 'Nombre del establecimiento',
      subdomain: 'Subdominio',
      code: 'Código',
      default_language: 'Idioma predeterminado',
      default_currency: 'Moneda predeterminada',
      login_of_person_in_charge: 'Login del responsable de la cuenta',
      name_of_person_in_charge: 'Nombre del responsable',
      address: 'Dirección',
      zip_code: 'Código Postal',
      number: 'Número',
      neighbourhood: 'Barrio',
      city: 'Ciudad',
      state: 'Estado',
      public_place: 'Calle',
      address_complement: 'Complemento',
      info: 'Para cambiar el subdominio contacte con soporte',
    },

    terms: {
      terms: 'Términos',
      here_are_the_terms_of_acceptance_of_the_sales_platform:
        'Aquí están listados los términos de aceptación de la plataforma de ventas',
      create_your_term: 'Cree su término',
      term_name: 'Nombre del término',
      valid_until: 'Válido hasta',
      name: 'Nombre',
      expirated: 'Expira',
    },

    payment_plans: {
      payment_plans: 'Planes de Pago',
      here_are_listed_the_payment_plans_along_with_their_respective_actions:
        'Aquí están listados los planes de pago junto con sus respectivas acciones',
      create_payment_plans: 'Crear Planes de Pago',
      fill_the_information_below_and_click_the_create_button_to_save_the_changes:
        'Rellene la información a continuación y haga clic en el botón crear para guardar los cambios',
      erp_integration: 'Integración ERP',
      integration_type: 'Tipo de Integración',
      select_an_integration: 'Seleccione una integración',
      card_flag: 'Bandera de la Tarjeta',
      flag: 'Bandera',
      type: 'Tipo',
      erp_code: 'Código ERP',
      card_installment: 'Pago a Plazos',
      payment_plan: 'Plan de pago',
      installment: 'Plazo',
      time: 'Plazo',
      credit: 'Crédito',
      debit: 'Débito',
    },

    indicators: {
      indicators: 'Indicadores',
      orders: 'Pedidos',
      filters: 'Filtros',
      first: 'Inicio',
      end: 'Fin',
      total_order: 'Total de pedidos',
      revenue: 'Ingresos',
      orders_by_location: 'Pedidos por modalidad',
      orders_by_month: 'Pedidos por mes',
      orders_by_day: 'Pedidos por día',
      orders_by_hour: 'Pedidos por hora',
      orders_by_month_sector: 'Pedidos por mes y modalidad',
      orders_by_day_sector: 'Pedidos por día y modalidad',
      orders_by_hour_sector: 'Pedidos por hora y modalidad',
      product: 'Productos',
      categories: 'Categorías',
      sales_by_category: 'Ventas por categoría',
      revenue_by_category: 'Ingresos por categoría',
      average_ticket: 'Ticket promedio',
      quantity: 'Cantidad',
      summary: 'Resumen',
      summaryAccess: 'Accesos',
      summaryAccessGroup: 'Áreas accedidas por período',
      summaryTimeAccessGroup: 'Total por horario',
      summaryIPAccessGroup: 'Total por usuario',
      summarySellerCart: 'Total de carritos creados por vendedor',
      period: 'Elija un período',
      summaryTypeCust: 'Suma por tipo de costo',
      summaryComposition: 'Composición de costos',
      cost: 'Costos',
      customer: 'Clientes',
      seller_sales_by_category: 'Ventas del vendedor por categoría',
      summary_seller: 'Resumen del Vendedor',
      sellers_invoice: 'Facturación del vendedor',
      comparative_sales_by_channel: 'Comparativa de ventas por canal',
      select_view: 'Seleccione vista',
      sales: 'Ventas',
      attended_customers: 'Clientes atendidos',
      carts: 'Carritos grabados',
      sales_conversion: 'Conversión de ventas',
      mean_ticket: 'Ticket promedio',
      sales_client: 'Comparativa/ Ranking de ventas por clientes',
      sellers: 'Vendedores',
      summary_store: 'Resumen de la Tienda',
      accesses: 'Visitas',
      active_sellers: 'Vendedores activos',
      revenue_store: 'Facturación de la Tienda',
      revenue_group: 'Facturación del Grupo',
      comparative_sales_by_seller: 'Comparativa de ventas por vendedor',
      comparative_sales_by_store: 'Comparativa de unidad de negocio',
      comparative_by_seller: 'Fuerza comercial - Comparativa de vendedores',
      stores: 'Tiendas',
      invoicing: 'Facturación',
      active_stores: 'Tiendas activas',
      summary_group: 'Resumen del Grupo',
      invoice_by_store: 'Facturación por tienda',
      rank_sellers: 'Ranking de vendedores',
      rank_stores: 'Ranking de tiendas',
    },

    customer_list: {
      customer_list: 'Lista de cliente',
      listed_customers: 'Aquí están listados los clientes junto con sus respectivas acciones.',
      select_time: 'Período de los pedidos realizados',
      name: 'Nombre',
      first: 'Inicio',
      end: 'Fin',
      phone: 'Teléfono',
      date: 'Fecha',
      detail: 'Detalles del Cliente',
      total_profit: 'Beneficio Total',
      total_itens: 'Total de Ítems',
      total_orders: 'Total de Pedidos',
      order_between: 'Pedidos entre',
      order_detail: 'Detalle del pedido',
      create: 'Crear Cliente',
      go_detail: 'Ver detalles',
      product: 'Producto',
      value: 'Valor',
      quantity: 'Cant.',
      total: 'Total',
      edit: 'Editar Cliente',
    },

    smart_order: {
      smart_order: 'Orden inteligente',
      service_classification: 'Clasificación de servicios',
      product: 'Productos',
      create_product: 'Crear Producto',
      here_are_listed_the_products_along_with_their_respective_actions:
        'Aquí están listados los productos junto con sus respectivas acciones',
      name: 'Nombre',
      code: 'Código',
      color_code: 'Código de cor',
      message_warning_find_variation:
        'Al realizar la búsqueda por nombre, preste atención al código de referencia,SKU y nome do produto',
      crop_image: 'Recortar Imagen',
      referenceCode: 'Código de Referencia',
      use_original_image: 'Usar Imagen Original',
      select_image_format: 'Seleccionar Formato de la Imagen',
      use_selected_size: 'Usar Tamaño Seleccionado',
      format_640x640: '640x640 (Cuadrado)',
      format_600x900: '600x900 (Retrato)',
      product_data: 'Datos del Producto',
      mark: 'Marca',
      measurement_unit: 'Unidad de Medida',
      description: 'Descripción',
      technical_specification: 'Especificación Técnica',
      from: 'de',
      characters: 'caracteres',
      order: 'Orden',
      product_image: 'Imágenes del Producto',
      additional_images: 'Imágenes Adicionales',
      product_groups: 'Grupos de clientes para el Producto',
      categories: 'Categorías',
      here_are_listed_the_categories_along_with_their_respective_actions:
        'Aquí están listadas las categorías junto con sus respectivas acciones',
      image: 'Imagen producto',
      image_variation: 'Imagen variación',
      category: 'Categoría',
      category_parent: 'Categoría Padre',
      category_name: 'Nombre de la categoría',
      category_code: 'Código de la categoría',
      perfil_image: 'Imagen de perfil',

      subcategories: 'Subcategorías',
      subcategory: 'Subcategoría',
      here_are_listed_the_subcategories_along_with_their_respective_actionsc:
        'Aquí están listadas las subcategorías junto con sus respectivas acciones',
      select_category: 'Seleccione una categoría',

      marks: 'Marcas',
      listened_marks: 'Aquí están listadas las marcas junto con sus respectivas acciones',

      measurements_units: 'Unidades de Medidas',
      listened_measurement:
        'Aquí están listadas las unidades de medidas junto con sus respectivas acciones',

      grid_products: 'Grillas',
      listened_grid:
        'Aquí están listadas las grillas de productos junto con sus respectivas acciones',
      grid_name: 'Nombre de la grilla',
      grid_code: 'Código',
      variation: 'Variación',
      grid: 'Grilla',
      grids: 'Grillas',

      variations: 'Variaciones',
      listened_variations:
        'Aquí están listadas las variaciones de productos junto con sus respectivas acciones',
      modality: 'Modalidad',
      select_modality: 'Seleccione una modalidad',
      prod: 'Producto',
      select_product: 'Seleccione un producto',
      no_variation: 'Producto sin variación',
      variation_product: 'Variación del producto',
      cost_price: 'Precio de Costo',
      sell_price: 'Precio de Venta',
      promotional_price: 'Precio Promocional',
      weight: 'Peso',
      height: 'Altura',
      width: 'Anchura',
      depth: 'Profundidad',
      availability: '¿Cuál es la disponibilidad del producto?',
      when_product_stock: '¿Cuando el producto se agote en stock?',
      stock: 'Cantidad de productos en stock',
      min_stock: 'Stock mínimo',
      price: 'Precio',

      catalogs: 'Catálogos',
      catalog: 'Catálogo',
      create_catalog: 'Crear Catálogo',
      edit_catalog: 'Editar Catálogo',
      catalog_link: 'Copiar Enlace del Catálogo',
      listened_catalogs:
        'Aquí están listados los catálogos de productos junto con sus respectivas acciones.',
      validity: 'Vigencia',
      first: 'Inicio',
      end: 'Fin',
      search_products: 'Búsqueda de Productos',

      product_status: 'Estado del producto',
      sku: 'SKU/EAN',
      status_variation: 'Estado de la variación',
      specification: 'Especificación',
      price_promotional: 'Precio con descuento',
      inventory: 'Inventario',
      preparation_time: 'Tiempo de preparación',
      service_title: 'Aquí están listados los servicios junto con sus respectivas acciones.',

      initial_hour: 'Hora inicial',
      final_hour: 'Hora final',

      date_start: 'Fecha Inicial',
      date_end: 'Fecha Final',

      add_group: 'Lista de Adicionales',
      no_add: 'Este producto aún no está asociado a ninguna lista de adicionales.',
      already_add: 'Este producto está asociado con las siguientes listas de adicionales.',
      associate_add: 'Asociar a una lista de adicionales',
      associate: 'Asociar',
      choose_add: 'Elija las listas de adicionales que se asociarán con este producto.',
      no_group_add: 'No hay listas de adicionales disponibles para asociar.',
      remove_add: 'Eliminar asociación',
      remove_add_text:
        '¿Desea eliminar la asociación de este producto con la lista de adicionales "@"?',
      limit_range: 'Límite máximo de intervalos alcanzado',

      remove_add_soon:
        '¡Atención! Esta pestaña se eliminará pronto. Podrá seguir gestionando sus adicionales con normalidad. Acceda a la pestaña "Información Básica" y vaya a la sesión "Grupo de Adicionales" para ver los adicionales de este producto.',
      create_image_ia: 'Propuesta de Imagen IA',
      create_image_ia_text: 'Informe una descripción del producto para generar las imágenes.',
      generate_images: 'Generar imágenes',
      generate_description: 'Personalizar descripción',
      generate_new_options: 'Generar nuevas opciones',
      save_image_selected: 'Guardar la foto seleccionada',
      reference_image_ia: 'Imagen de referencia',
      image_qtd_ia: 'Cantidad de imágenes',
      save_img_ia: 'Guardar imágenes',
      cancel: 'Cancelar',

      more_category: 'Ver más configuraciones de esta categoría',
      selectAll: 'Seleccionar Todos',
      alterLot: 'Alterar Lote',
      edit_category:
        'No está permitido cambiar el vínculo de categoría, le recomendamos crear una nueva categoría',

      catalog_image: 'Imagen del Catálogo',
    },

    service_grid: {
      service_grid: 'Grillas de Servicios',
      service_grid_single: 'Grilla de Servicio',
      create_service_grid: 'Crear Grilla de Servicios',
      edit_service_grid: 'Editar Grilla de Servicios',
      service_grid_name: 'Nombre de la Grilla de Servicios',
      service_grid_name_placeholder: 'Nombre de la grilla de servicios',
      start_hour: 'Hora Inicial',
      start_hour_placeholder: '00:00',
      end_hour: 'Hora Final',
      end_hour_placeholder: '23:59',
      interval: 'Intervalo',
      interval_placeholder: '00:15',
      interval_tooltip: 'Intervalo de tiempo entre pedidos',
      service_list: 'Lista de Servicios',
      service_placeholder: 'Servicios',
      missing_fields: 'Campos faltantes',
      missing_fields_message: '¡Verifique si ha llenado todos los campos!',
      grid_created: 'Grilla registrada',
      grid_created_message: '¡Registro realizado con éxito!',
      grid_updated: 'Grilla alterada',
      grid_updated_message: '¡Edición realizada con éxito!',
      error: 'Error',
      error_create_message: '¡Error al registrar la grilla!',
      error_update_message: '¡Error al alterar la grilla!',
      fill_information_create:
        'Rellene la información a continuación y haga clic en el botón crear para guardar los cambios',
      save_changes_edit:
        'Rellene la información a continuación y haga clic en el botón guardar para confirmar los cambios',
      dashboard: 'Dashboard',
      title: 'Título',
      listed_grids:
        'Aquí están listadas las grillas de servicios junto con sus respectivas acciones',
      grid_deleted: 'Grilla eliminada',
      grid_deleted_message: '¡Eliminación realizada con éxito!',
      error_delete_message: '¡Error al eliminar la grilla!',
      status: 'Estado',
      grid_linked_warning: 'Grilla vinculada',
      grid_linked_message:
        'Esta grilla está vinculada a {count} formulario(s) de servicio(s) y no puede ser eliminada.',
    },

    webapp: {
      webapp: 'Webapp',
      generate_qrcode: 'Generar Código QR',
      personalize: 'Personalizar',
      settings: 'Configuraciones',
      link: 'Enlace a Webapp',

      webapp_data: 'Datos del Webapp',
      name: 'Nombre',
      place: 'Local',
      product_pagination: 'Cantidad de productos en la paginación',
      logo_ninegrid: 'Logo de Ninegrid',
      light: 'Clara',
      dark: 'Oscura',
      logo_totvs: 'Logo de TOTVS',
      use_icon_menu: 'Usar ícono en el menú del Webapp',
      description: 'Descripción',
      icon: 'Ícono',
      color_setting: 'Configuración de colores',
      background_webapp: 'Fondo del Webapp',
      background_default_webapp: 'Color Predeterminado del WebApp',
      background_header: 'Fondo del encabezado',
      text_header: 'Texto del encabezado',
      icon_header: 'Íconos del encabezado',
      background_footer: 'Fondo del pie de página',
      icon_footer: 'Íconos del pie de página',
      highlight_footer: 'Resalte del pie de página',
      notification_cart: 'Notificación del carrito',
      notification_text: 'Texto de la notificación',
      home_button: 'Botón de inicio',
      text_home_button: 'Texto del botón de inicio',
      title_bar: 'Barra de título',
      text_title_bar: 'Texto de la barra de título',
      icon_title_bar: 'Íconos de la barra de título',
      text_category: 'Texto de categorías',
      webapp_button: 'Tema del Webapp',
      text_button: 'Texto de los botones',
      background_menu: 'Fondo del menú lateral',
      text_menu: 'Texto del menú lateral',
      price_card_background: 'Fondo de la tarjeta de precio',
      price_card_font_color: 'Color de fuente de la tarjeta de precio',
      order_status: 'Estado del pedido',
      order_active_status: 'Estado del pedido activo',
      text_order_active_status: 'Texto del estado del pedido',
      info_cart: 'Informativo del carrito',

      settings_webapp: 'Configuraciones del Webapp',
      type_delivery: 'Tipo de restricción de entrega',
      integration: 'Integración',
      select_integration: 'Seleccione una integración',
      payment_method_card: 'Medio de pago Tarjeta',
      payment_method_pix: 'Medio de pago Pix',
      payment_method_delivery: 'Medio de pago en la entrega',
      consent_letter: 'Activar carta de consentimiento',
      product_no_stock: 'Venta de productos sin stock',
      show_subcategory: 'Mostrar subcategoría',
      show_observation: 'Mostrar observación',
      use_category_list: 'Mostrar subcategorías y productos en listas',
      use_category_list_v2: 'Mostrar categorías y subcategorías en listas',
      use_product_list: 'Mostrar productos en listas',
      remove_shadow: 'No añadir sombra en categorías y catálogos',
      remove_show_mode: 'Remover modo de exhibición',
      no_shadow: 'No añadir sombra en categorías',
      is_order_number: 'Ordenar categoría',
      order_number: 'Por orden',
      order_category: 'Alfabética',
      show_layout: 'Exhibir Layout',
      image_type: 'Estilo de la imagen del producto',

      withdraw_fee: 'Tasa de Retiro',
      minimum_value: 'Valor Mínimo del Pedido',
      seller_checkout: 'Modalidad del Checkout',

      no_sales: 'No permitir ventas',
      safe_mode: 'Modo de seguridad',
      time_safe_mode: 'Tiempo de Sesión del Modo de seguridad (en minutos)',
      limit_characteres_explanation:
        'Para tiendas con integración Wintor o Protheus, lo recomendado es como máximo 50 caracteres.',
      limit_characteres: 'Límite de caracteres',

      skip_entry: 'Saltar pantalla de entrada',
      payment_table: 'Pago en la mesa',

      payment_card: 'Pago en la comanda',

      slides_homePage: 'Imágenes de Destacado HomePage',
      slides_initial: 'Imágenes de Destacado Inicial',

      slides_not_found: 'No se encontró ninguna imagen del slider',

      externalLink: 'Enlace externo',
      buttonType: 'Tipo del Botón',
      ableUserLocation: 'Permitir búsqueda de dirección por localización',
      ableWaiter: 'Desactivar opción de llamar camarero',
      closeAccountButton: 'Quitar botón de cierre de cuenta',
      emitNfChef: '¿Emitir Factura después del pago del pedido? (Mostrador/Mesa/Comanda)',

      seller_cart_limit_time: 'Tiempo de expiración del carrito del vendedor por hora',
      seller_cart_limit_time_explanation:
        'Tiempo máximo que el cliente puede usar el carrito del vendedor',
      settings_webapp_aggregator: 'Personalizar',
      generate_qrcode_webapp_aggregator: 'Generar código QR',
      qrcode_webapp_aggregator: 'Aplicación Web',
      security_settings: 'Configuraciones de seguridad',
      maximus_radius: 'Localización: Radio de proximidad permitido (en metros)',
      access_maximus: 'Número máximo de accesos por mesa',
      limit_time: 'Tiempo de acceso para que la comanda expire (en minutos)',
      password: 'Contraseña para liberar el acceso',
      flag_discount: 'Formato de la bandera de descuento',
      color_flag_discount: 'Color de la etiqueta',

      config_tags: 'Configurar Etiquetas',
      promotional_tags: 'Etiqueta promocional',

      pre_created: 'Pre-registro',

      show_classification_button: 'Mostrar botón de visualizar todas las categorías',
      show_catalog_button: 'Mostrar botón de visualizar todos los catálogos',
      show_catalog_name: 'Mostrar nombre de los catálogos',
      show_classification_name: 'Mostrar nombre de las categorías',
      show_mark_name: 'Mostrar marca de los productos',
      show_stock_quantity: 'Mostrar stock de los productos',
      show_promotional_tags: 'Mostrar Etiqueta Promocional',
      show_product_sku: 'Mostrar sku del producto',
      tag_display_groups: 'Mostrar grupos de etiquetas en la lista de productos',
      text_free_delivery: 'Texto personalizado para entrega o retiro gratuito',
      tooltip_free_delivery:
        'Si se rellena, este texto se mostrará cuando la entrega o retiro sea gratuito. Si está vacío, se mostrará el valor R$ 0,00',
      place_holder_free_delivery: 'Ej: Gratis',
      no_show_grid: 'Omitir grillas de variaciones únicas del producto',
      explain_show_grid:
        'Oculta grillas con variaciones únicas. Las grillas con múltiples opciones (ej: tamaños G; GG) permanecerán visibles en la selección de producto, pero ocultas en otros lugares.',

      type_image: 'Tipo de Imagen',
      type_image_square: 'Cuadrada',
      type_image_rectangle: 'Rectangular',

      directlink: 'Enlace Directo',
      infoDirectLink:
        'No obligatorio, solo cuando sea necesario enviar directamente a otra página o sitio, máximo de 350 caracteres',

      block_add_in_limit: 'Bloquear adición en el límite',

      family_fonte: 'Familia de la Fuente',
      rounding_images: 'Redondeo de las Imágenes',
      rounding_bars: 'Redondeo de las Barras',
      color_icons: 'Color de los íconos',
      color_icons_header_footer: 'Color de los íconos en el encabezado y pie de página',
      background_icon_button: 'Color de fondo de los íconos',
      background_icon_custom: 'Color personalizado',
      restaurant_list: 'Mostrar restaurantes en listas',
      restaurant_display_mode: 'Cambiar modo de visualización de restaurantes',
      icon_button_size: 'Tamaño de los íconos de los botones',
      shadow_image: 'Sombra de la Imagen',
      black_logo_nine: 'Logo Ninegrid Oscuro',
      skip_loud_screen: 'Saltar pantalla de carga',
      can_acesse_restaurant:
        'Permitir visualización del catálogo (Tienda/Restaurante) sin iniciar sesión',
      info_acesse_restaurant:
        'La activación de esta opción permite que el usuario acceda al menú/catálogo del restaurante o tienda sin necesidad de iniciar sesión. Si existe una integración de pago activa, se solicitará el inicio de sesión directamente en la propia WebApp de la tienda o restaurante, antes de la etapa de pago, para que el pedido se asocie correctamente al contexto del usuario (perfil/reserva) en el sistema del hotel.',
    },

    integration: {
      integration: 'Integración',
      means_of_payment: 'Medio de Pago',
      here_are_listed_the_means_of_payment_along_with_their_respective_actions:
        'Aquí están listados los medios de pago junto con sus respectivas acciones',
      PDV: 'Integración PDV',
      listed_here_are_the_integrations_along_with_their_respective_actions:
        'Aquí están listadas las integraciones junto con sus respectivas acciones',
      integration_name: 'Nombre de la Integración',
      type_of_integration: 'Tipo de Integración',
      actions: 'Acciones',
      search: 'Buscar',
      example: 'Ejemplo de Payload',

      loads: 'Cargas',
      name: 'Nombre',
      price: 'Precio',
      stock: 'Stock',
      measurements_units: 'Unidades de Medida',
      grid: 'Grillas',
      classifications: 'Categorías',
      products: 'Productos',
      status_sync: 'Sincronización de Estado',
      marks: 'Marcas',
      orders: 'Pedidos',
      trigger_load: 'Activar Carga',
      first: 'Inicio',
      end: 'Fin',
      load: 'Cargar',
      messenger: 'Mensajería',
      others: 'Otros',
      test: '¿Desea probar la integración?',
      params_test: 'Ver parámetros de esta integración',
      copy_params: 'Copiar parámetros',
      result_test: 'Resultados de la prueba de la integración',
      success_1: '¡Éxito! La integración',
      success_2: 'fue exitosa.',
      result_log: 'Log de resultado',
      copy_result: 'Copiar resultado',
      search_result: 'Buscar en los resultados',
      error_1: 'La integración',
      error_2: 'devolvió un error. Consulte el log a continuación para más información.',

      success_food_1: '¡Éxito! La integración',
      success_food_2: 'fue exitosa.',
      error_food_1: 'La integración',
      error_food_2: 'devolvió offline.',

      integrationPrint: 'Probar Conexión',
    },

    reports: {
      orders: 'Pedidos',
      order_report: 'Informe de Pedidos',
      order_list: 'Lista de Pedidos',
      first: 'Inicio',
      end: 'Fin',
      firstTime: 'Hora inicial',
      endTime: 'Hora final',
      orders_between: 'Pedidos entre',
      order_number: 'Número del Pedido',
      date: 'Fecha',
      consumer: 'Consumidor',
      modality: 'Modalidad',
      total_value: 'Valor',
      cancel_order: 'Cancelar pedido',

      products: 'Productos',
      quantity: 'Cantidad',
      qtt: 'Cant.',
      product: 'Producto',
      value: 'Valor',
      total: 'Total',
      order_status: 'Estado del Pedido',
      payment_method: 'Forma de pago',
      billing_address: 'Dirección de cobro',
      product_value: 'Valor de los productos',
      discount: 'Descuento',
      order: 'Pedido',

      listened_logs: 'Aquí están listados los logs junto con sus respectivas acciones.',
      methods: 'Métodos',
      log_details: 'Detalles del Log',

      withdraw: 'Retiro',
      delivery: 'Entrega',
      table: 'Mesa',
      counter: 'Mostrador',
      responsible_withdraw: 'Responsable del retiro',
      responsible_delivery: 'Responsable de la recepción',
      address_withdraw: 'Dirección de retiro',
      address_delivery: 'Dirección de entrega',
      seller: 'Vendedor',
      seller_link: 'Enlace del Vendedor',
      external_code: 'Número externo',
      payment: 'Pago',
      internal_delivery: 'Entrega Interna',
      origin: 'Origen',
      historial: 'Histórico del pedido',
      approval_moment: 'Fecha y hora de la aprobación',
      id: 'Código de la Reserva',
      pluginspace: 'Hotel',
      hotel: 'Pedido asociado al hotel',
      document: 'Documento de la Reserva',
      room: 'Código de la Habitación',
      status_payment: 'Estado del pago',
      authorization_code: 'Código de autorización',
      transaction: 'ID de la transición',
      made_in: 'Realizado el',
      send_method: 'Método de envío',
      send_date: 'Fecha de envío',
      estimated_delivery: 'Previsión de entrega',
      freight: 'Flete',
      tracking_code: 'Código de rastreo',
      website: 'Abrir sitio de rastreo',
      label: 'Imprimir etiqueta de envío',
      payment_delivery: 'Pago en la entrega',
      payment_money: 'Pago en efectivo',
      change_money: 'Cambio',
      label_code: 'Etiqueta',
      label_website: 'Abrir sitio de la etiqueta',
      declaration_code: 'Declaración',
      declaration_website: 'Abrir sitio de la declaración',
      height: 'Altura (cm)',
      width: 'Anchura (cm)',
      length: 'Longitud (cm)',
      weight: 'Peso (kg)',
      send_text: 'Forma de envío elegida por el cliente: ',
      success_label: 'Su etiqueta de envío fue generada con éxito.',
      continue: 'Continuar',
      confirm: 'Confirmar',
      change_multiple_status: 'Cambiar estado de múltiples pedidos',
      change_status_text: '¿Desea cambiar el estado de los pedidos a continuación?',
      new_status: 'Nuevo estado',
      change_status: 'Cambiar estado',

      synkar: 'Automatización',
      invalid_data: 'Por favor, seleccione las fechas de inicio y fin.',

      details: 'Detalles',
    },

    imports: {
      imports: 'Importaciones',
      import_image_product: 'Importaciones de Imágenes para Productos',
      import_image_category: 'Importaciones de Imágenes para Categorías',
      listened_import_product:
        'Aquí están listadas las importaciones de imágenes para productos junto con sus respectivas acciones.',
      no_upload_images: 'No realizar carga de imágenes',
      first: 'Inicio',
      end: 'Fin',
      total_products: 'Total de Productos',
      sync_products: 'Productos Sincronizados',
      import_image_sku: 'Importaciones de Imágenes para Variaciones',
      listened_import_sku:
        'Aquí están listadas las importaciones de imágenes para variaciones junto con sus respectivas acciones.',
      verify_verification: 'Verificación de la variación',
      product_code: 'Código del producto',
      code: 'Código',
      total_variations: 'Total de Variaciones',
      sync_variations: 'Variaciones Sincronizadas',
      total_categories: 'Total de Categorías',
      sync_categories: 'Categorías Sincronizadas',
      problem_title: 'Imágenes con problema',
      images_success: 'imágenes fueron enviadas con éxito.',
      images_error: 'imágenes presentaron problema y no fueron enviadas.',
      file: 'Archivo',
      status: 'Estado de la importación',
      new_import: 'Realizar nueva importación',
      import_xls: 'Importar imágenes con archivo XLS',
      import_repo: 'Importar imágenes desde Google Drive o Dropbox',
      steps: 'Paso a paso para importación',
      step_1: '1. Coloque todas las imágenes en un servidor web público.',
      step_2: '2. Verifique si el servidor es público y accesible vía web.',
      step_3: '3. Descargue nuestro archivo XLSX en blanco.',
      step_4: '4. Rellene con los datos de su banco de imágenes.',
      step_5: '5. Suba el archivo rellenado.',
      step_1_repo:
        '1. Verifique si la carpeta de la tienda está creada como "fotos_loja_<identificador de la tienda>".',
      step_2_repo: '2. Cree la carpeta "produtos" dentro de la carpeta de su tienda.',
      step_2_repo_sku: '2. Cree la carpeta "variacoes" dentro de la carpeta de su tienda.',
      step_2_repo_category: '2. Cree la carpeta "categorias" dentro de la carpeta de su tienda.',
      step_3_repo: '3. Confirme si los archivos están como "<codigo del producto>.<extensión>".',
      step_3_repo_sku: '3. Confirme si los archivos están como "<sku>.<extensión>".',
      step_3_repo_category:
        '3. Confirme si los archivos están como "<codigo de la categoría>.<extensión>".',
      step_4_repo: '4. En caso de ser un producto adicional, verificar si posee "_<numero>".',
      step_4_repo_sku:
        '4. Confirme que la variación es una imagen y si está en la extensión JPG o PNG.',
      step_4_repo_category:
        '4. Confirme que la categoría es una imagen y si está en la extensión JPG o PNG.',
      step_5_repo: '5. Confirme que el producto es una imagen y si está en la extensión JPG o PNG.',
      download: 'Descargar el archivo XLSX en blanco',
      download_problems: 'Exportar informe',
      upload: 'Enviar archivo',
      upload_anex: 'Adjuntar archivo',
      import_dropbox: 'Importar con Dropbox',
      import_drive: 'Importar con Google Drive',
      spreadsheet: 'Hoja de cálculo',
      gdrive: 'Google Drive',
      dropbox: 'Dropbox',
      type: 'Tipo',
      type_resize: 'Tipo de Redimensionamiento',
      agroup_color: 'Agrupar fotos por color',
      banner_size: 'Tratar categoría N1 como banner',
      select_dimensions: 'Seleccione las dimensiones',
      square: 'Tratar con 640x640',
      vertical: 'Tratar con 600x900',
    },

    sms: {
      sms: 'SMS',
      listened_sms: 'Aquí están listadas las mensajes (SMS) junto con sus respectivas acciones.',
      order: 'Orden',
      name: 'Nombre',
      message: 'Mensaje',
      markers: 'Los marcadores [pedido] y [status] deben estar en el mensaje',
      waiting: 'Esperando',
      opened: 'Abierto',
      ready: 'Listo',
      refused: 'Rechazado',
    },

    multichannel: {
      multichannel: 'Multicanal',
      listened_multichannel:
        'Aquí están listadas las configuraciones de multicanal junto con sus respectivas acciones.',
    },

    feed: {
      content: 'Contenido',
      title: 'Título',
      fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
        'Rellene la información a continuación y haga clic en el botón crear para guardar los cambios',
    },
    feedCategory: {
      feedCategory: 'Categoría del Contenido',
    },

    structured_content: {},

    queue: {
      index: 'Fila de espera',
      menage: 'Gestión',
      config: 'Configuraciones de la fila de espera',
      able: 'Permitir fila de espera',
      link: 'Enlace de la fila de espera:',
      limit_people: 'Número máximo de personas',
      limit_people_text: 'Límite de la fila de espera',
      limit_time: 'Límite de tiempo para exhibir alerta',
      limit_time_text: 'Tiempo máximo en minutos para considerar atrasado',
      image_title: 'Definición de imágenes',
      image_text:
        'El sistema de fila exhibe 2 imágenes. Suba fotos de su restaurante, o seleccione fotos estándar abajo. Las fotos enviadas serán ajustadas para el tamaño de 350x250 píxeles.',
      image: 'Imagen',
      position: 'Posición',
      time: 'Tiempo de espera',
      people: 'personas',
      cancel: 'Cancelación',
      cancel_text: '¿Desea remover esta persona de la fila de espera?',
      cancel_button: 'Remover',
      confirm: 'Confirmación',
      confirm_text: '¿Desea confirmar la llegada del reservante?',
      confirm_button: 'Confirmar llegada',
      empty: 'No hay lista de espera en el momento',
      confirm_all: 'Confirmar todas',
      cancel_all: 'Cancelar todas',
      observation: 'Observación',
      use_terms: 'Activar términos de consentimiento',
      total_people: 'Total de personas por grupo',
      total_people_text: 'Límite de la fila de espera por grupo',
      all: 'Todos',
      in_queue: 'En la fila',
      preferential: 'Preferencial',
      confirmed: 'Confirmado',
      removed: 'Rechazado',
      show: 'Exhibir',
      show_text: 'Últimas @ horas',
      yes: 'Sí',
      no: 'No',
      add: 'Añadir Cliente a la Fila',
      use_location: '¿Permitir localización?',
      use_menu: '¿Desea utilizar menú?',
      use_ninegrid_menu: '¿Utilizar el menú Ninegrid?',
      external_menu_link: 'Informe el enlace del menú',
      edit: 'Editar Cliente en la Fila',
    },
    booking: {
      index: 'Reserva',
      config: 'Configuraciones de la reserva',
      able: 'Permitir reserva',
      link: 'Enlace de la reserva:',
      image_title: 'Definición de imágenes',
      image_text:
        'El sistema de reservas exhibe 2 imágenes. Suba fotos de su restaurante, o seleccione fotos estándar abajo. Las fotos enviadas serán ajustadas para el tamaño de 350x250 píxeles.',
      image: 'Imagen',
      days_week: 'Días de la semana',
      booking_day: '¿Permitir reservas en este día?',
      booking_day_text: 'Defina abajo los horarios liberados para reservas.',
      booking_day_subtext:
        'Al seleccionar un horario se definirá una ventana de 1 hora. Ejemplo: al seleccionar 19:00 las personas podrán hacer reservas entre 19:00 y 20:00.',
      max_people: 'Número máximo de personas por reserva',
      max_people_text: 'Es el tamaño máximo de un grupo de personas que puede hacer una reserva',
      expiry_time: 'Tiempo máximo hasta que la reserva expire',
      expiry_time_text: 'Tiempo en minutos para aguardar la llegada del reservante',
      day_confirm: 'Exigir confirmación en el día',
      day_confirm_text: 'El usuario necesita confirmar la reserva en la fecha elegida',
      payment_confirm: 'Exigir pago anticipado en la reserva',
      value_payment_confirm: 'Valor del pago anticipado',
      week: 'Semana',
      month: 'Mes',
      year: 'Año',
      use_terms: 'Activar términos de consentimiento',
      empty: 'No hay reservas en el momento',
      use_time: 'Permitir reserva por período',
      time: 'Duración de la reserva (HH:mm)',
    },
    booking_day: {
      booking: 'Reservas del día',
      date: 'Fecha',
      people: 'personas',
      expiry: 'Expira en',
      cancel_title: 'Cancelación',
      cancel_subtitle: '¿Desea cancelar esta reserva?',
      cancel_button: 'Cancelar reserva',
      confirm_title: 'Confirmación',
      confirm_subtitle: '¿Desea confirmar la llegada del reservante?',
      confirm_button: 'Confirmar llegada',
      accessibility_needs: 'Necesidad de Accesibilidad',
      accessibility_elderly: 'Apoyo a Personas Mayores',
      accessibility_wheelchair: 'Usuario de Silla de Ruedas',
      accessibility_physical: 'Discapacidad Física',
      filter_accessibility: 'Filtrar por Accesibilidad',
      all_accessibility: 'Todas las necesidades',
    },
    booking_report: {
      report: 'Informes',
      search: 'Búsqueda de reservas',
      time: 'Seleccione el período',
      date_start: 'Fecha inicio',
      date_end: 'Fecha fin',
      confirm: 'Confirmación',
      noShow: 'No show',
      confirmed: 'Reservas confirmadas',
      canceled: 'Reservas canceladas',
      open: 'Abierto',
      map: 'Mapa de reservas',
      booking: 'reservas',
      accessibility_stats: 'Estadísticas de Accesibilidad',
      accessibility_total: 'Total con necesidades',
      accessibility_percentage: 'Porcentaje',
    },
    booking_report_management: {
      management: 'Gestión de reservas',
      search: 'Búsqueda de reservas',
      phone: 'Teléfono',
      date_start: 'Fecha inicio',
      date_end: 'Fecha fin',
      today: 'Hoy',
      tomorrow: 'Mañana',
      calendar: 'Calendario',
      see_all: 'Ver todas',
      people: 'personas',
      noShow: 'No show',
      confirmed: 'Confirmada',
      canceled: 'Cancelada',
      open: 'Abierto',
      search_text: 'Resultados por la búsqueda de teléfono o selección de fecha',
    },
    environment: {
      map: 'Mapa de ambientes',
      environment: 'Ambiente',
      index: 'Ambientes',
      name: 'Nombre del ambiente',
      tables: 'Número de mesas',
      seats_available: 'Total de asientos disponibles',
      actions: 'Acciones',
    },
    week_day: {
      sun: 'Dom',
      mon: 'Lun',
      tue: 'Mar',
      wed: 'Mié',
      thur: 'Jue',
      fri: 'Vie',
      sat: 'Sáb',
    },
    week_day_full: {
      sun: 'Domingo',
      mon: 'Lunes',
      tue: 'Martes',
      wed: 'Miércoles',
      thur: 'Jueves',
      fri: 'Viernes',
      sat: 'Sábado',
    },
    checkout: {
      title: 'Datos del Cliente',
      here_are_listed_the_modalities_along_with_their_respective_actions:
        'Aquí están listados los campos necesarios para la creación del cliente.',
      active_mandatory: 'Campo Obligatorio',
      active_visibility: 'Campo Visible',
    },

    liveShop: {
      liveShop: 'Live Commerce',
      liveShop_list:
        'Aquí están listados los eventos de Live Commerce junto con sus respectivas acciones.',
      create: 'Crear Live Commerce',
      edit: 'Editar Live Commerce',
      dateInit: 'Inicio',
      hourInit: 'Hora de Inicio',
      dateEnd: 'Fin',
      hourEnd: 'Hora de Término',
      status: 'Estado',
      initDate: 'Fecha y Hora de Inicio',
      fimDate: 'Fecha y Hora de Término',
      name: 'Nombre',
      variations: 'Variaciones del Producto',
      search_products_Attentions:
        'Los Productos y Variaciones devueltos deben poseer estado activado, poseer precio, stock e imagen',
      alert_delete: '¡No es posible remover una Live cuando comenzó o fue finalizada!',
      alert_Edit: '¡No es posible editar una Live cuando comenzó o fue finalizada!',
      delete: 'Eliminar Live Commerce',
    },

    logs: {
      //PagSeguro
      pagseguroPaymentCodePhone: 'Error código del teléfono Pagseguro',
      pagseguroPaymentErrorCountry: 'Error del código País Pagseguro',
      pagseguroPaymentErrorEmail: 'Error del email Pagseguro',
      authenticatePagseguro: 'Autenticación Pagseguro',
      pagseguroPayment: 'Pago Pagseguro',
      pagseguroPaymentCatch: 'Pago Pagseguro',
      pagseguroPaymentResponse: 'Respuesta del pago Pagseguro',
      pagseguroPaymentTransactions: 'Transacción del pago Pagseguro',
      pagseguroReturnPayment: 'Retorno del pago Pagseguro',
      paymentPixPagseguro: 'Pago Pix Pagseguro',

      pagseguroPaymentGateway: 'Gateway de pago Pagseguro',
      getAuthPagseguroEmailSpace: 'Autenticación del Pagseguro por email',
      getOneApplicationClientId: 'Obtener aplicación del cliente Pagseguro',
      createAuthPagseguro: 'Crear autenticación Pagseguro',
      generatePublicKeyPagseguro: 'Generar clave pública Pagseguro',
      updateCodeRedirectApplication: 'Actualización del Código de la aplicación Pagseguro',
      deleteAuthPagseguroByEmail: 'Remover autenticación Pagseguro',
      createPluginconfig: 'Configuración del plugin',

      //Totvs pagamento HUB
      refundTotvs: 'Estorno vía Totvs',
      refundPayCard: 'Estorno vía Totvs por tarjeta',
      paymentTotvs: 'Pago vía Totvs',
      paymentPixTotvs: 'Pago Pix vía Totvs',

      //Card Structure
      sendUnregisteredCardBrands: 'Bandera no encontrada',
      cardStructure: 'Estructura del tarjeta',
      cardStructureInvalidPlugin: 'Plugin inválido para el gateway',
      cardStructureGatewayError: 'Error del tarjeta para el gateway',
      cardStructureData: 'Datos del Tarjeta',
      cardStructureError: 'Error de los Datos tarjeta',
      cardStructureDecrypt: 'Desencriptación del tarjeta',
      cardStructureFields: 'Campos del Tarjeta',
      refundCard: 'Estorno del Tarjeta',

      //Status
      analysisSatusOrder: 'Status del pedido para análisis',
      statusPayPix: 'Status Pix',

      //Antifraude
      analyseAntifraud: 'Análisis del Antifraude',
      dataClearSale: 'Datos del ClearSale',
      statusAnalysis: 'Status del Análisis',

      //estoque
      addSkuInventory: 'Adicionar al stock',
      subtractSku: 'Remover del stock',
      viewCargoHistory: 'Visualizar histórico de carga',
      viewCargoHistoryBySku: 'Visualizar histórico de carga por SKU',

      // Order-Pedido
      sendOrderIn: 'Envío del pedido',
      cancelOrder: 'Cancelar Pedido',
      sendOrder: 'Enviar Pedido',
      sendOrderRefund: 'Estorno del Pedido',
      sendOrderError: 'Error al enviar pedido',
      sendOrderResultRefund: 'Resultado del estorno del pedido',
      sendOrderResultData: 'Resultado del envío del pedido',
      sendOrderAntifrud: 'Antifraude en el envío del pedido',
      sendOrderPaymentStruct: 'Estructura del pago del pedido',

      sendOrderDescryptor: 'Desencriptación del Pedido',
      sendOrderStatus: 'Status del pedido',
      sendOrderConfigNotFound: 'Configuración del envío del pedido',
      sendOrderMandatoryCustomer: 'Cliente del pedido',
      sendOrderMandatory: 'Estructura obligatoria del pedido',
      sendOrderResultGateway: 'Resultado del envío al gateway',
      OrderFashionService: 'Servicio de pedido Fashion',
      OrderFashionServiceError: 'Error en el servicio de pedido Fashion',
      cartOrderLive: 'Carrito del pedido Live',
      cartOrderLiveError: 'Error en el carrito del pedido Live',
      sendOrderErrorGeral: 'Error en el pedido',
      sendPushNotification: 'Enviar notificación push',

      //Pre-Order
      preOrderStatusPix: 'Status del Pre pedido vía pix',
      processQueuePreOrder: 'Procesamiento de la fila del pre order',
      getAllPreOrderBySpace: 'Obtener todos los pre pedidos por pluginspace',
      sendPreOrder: 'Envío del Pre pedido',
      makeOrderTransparent: 'Verificación pedido',
      statusPreOrder: 'Actualización del Status del Pix del Pre pedido',
      preOrderStatusCanceledPix: 'Cancelar Pre pedido vía Pix',

      //Totvs Wintor
      buildOrderTotvsWinthor: 'Crear Pedido',
      sendOrderWinthor: 'Envío del pedido para Totvs',
      sendCustomerOrderWinthor: 'Envío del cliente para Totvs',

      //Totvs Varejo
      buildOrderTotvsVarejo: 'Crear Pedido',
      setConfimTicket: 'Confirmación de Ticket',
      SyncOrderLive: 'Sincronización de Pedidos',
      ObterProdutos: 'Obtener Productos',
      taskPrice: 'Carga de Precio',
      calculationPromotion: 'Cálculo de Promoción',
      PayloadCalcPromotion: 'Payload Cálculo de Promoción',

      //Totvs Moda
      changeStatus: 'Cambio de Status',
      sendOrderFashion: 'Envío del pedido para Totvs',
      sendCustomerFashion: 'Envío del cliente para Totvs',
      searchPersonTotvsByCPF: 'Búsqueda de Cliente Totvs',
      sendErrorCustomerFashion: 'Error en el envío del Cliente para el Fashion',
      buildCustomerTotvsFashion: 'Creación de cliente en Totvs',
      ResumeSnyOrderFashion: 'Resumen sincronía con el Fashion',
      changeStatusFashion: 'Cambiar Status',
      buildOrderTotvsFashion: 'Crear Pedido Fashion',

      //Totvs Food
      updateStatusOrderFoodIntegration: 'Cambio de Status',
      buildOrderTotvsFood: 'Crear Pedido',
      changeStatusOrderFood: 'Cambio de Status',
      sendOrderTotvsFood: 'Envío del pedido para la Totvs',
      confirmMenu: 'Menú Confirmado',
      getMenu: 'Obtener Menú Totvs',

      //Totvs Live
      sendCustomerLive: 'Envío del Cliente Live',
      sendOrderLive: 'Envío Pedido Live',

      //Synkar
      updateStatusOrderSynkar: 'Actualización Pedido Synkar',
      sendingOrderMessageSynkar: 'Envío Mensajería Synkar',
      responseOrderMessageSynkar: 'Respuesta Mensajería Synkar',
      sendingOrderSynkar: 'Envío Synkar',
      responseOrderSynkar: 'Respuesta Synkar',

      //SDS
      sdsGetOrders: 'Obtener los pedidos SDS',
      sdsOrderIn: 'Envío de los pedidos SDS',
      sdsOrderInResult: 'Envío del pedido al SDS',
      sdsSyncCardapio: 'Sincronía del menú con el SDS',
      'sendOrderfood-sdsOrderIn': 'Error al enviar pedido SDS',

      //S3
      createRoute: 'Crear Ruta S3',
      getStatusfiftythree: 'Status Ruta 53',
      updateDistribution: 'Actualiza Distribución',
      deleteRoute: 'Elimina Ruta S3',
      deleteDistribution: 'Elimina Distribución',

      //Erede
      refundErede: 'Estorno Erede',
      paymentErede: 'Pago Erede',

      //Cielo
      refundCielo: 'Estorno Cielo',
      paymentCielo: 'Pago Cielo',

      //Pagseguro
      refundPagseguro: 'Estorno Pagseguro',
      getApplicationPagseguro: 'Gateway Aplicación Pagseguro',

      //pagamento offline
      paymentOffline: 'Pago en la entrega',

      //Geral
      chargeSyncOrderErro: 'Error en la Sincronía de Status',
      chargeSyncOrder: 'Sincronía de Status',
      chargeProductLive: 'Sincronía de Productos del Live',
      chargeBalanceLive: 'Sincronía de Stock del Live',
      chargePriceLive: 'Sincronía de Precios del Live',
      chargeProductLiveErro: 'Error en la Sincronía de Productos del Live',
      chargeBalanceLiveErro: 'Error en la Sincronía de Stock del Live',
      chargePriceLiveErro: 'Error en la Sincronía de Precios del Live',

      chargeProduct: 'Sincronía de Productos',
      chargeBalance: 'Sincronía de Stock',
      chargePrice: 'Sincronía de Precios',
      chargeProductErro: 'Error en la Sincronía de Productos',
      chargeBalanceErro: 'Error en la Sincronía de Stock',
      chargePriceErro: 'Error en la Sincronía de Precios',

      taskBalanceIntegration: 'Integración de la Carga de stock',
      taskBalanceCharge: 'Carga de stock iniciada',
      SnyOrder: 'Sincronismo de status de pedido',
      syncronyzePriceInteration: 'Carga de Precio',
      syncronyzePrice: 'Sincronización de Precio',
      chargeClassification: 'Carga de categoría y subcategoría',
      chargeGrid: 'Carga de grilla',
      chargeGridItens: 'Ítems de Carga de grilla',
      chargeMeasure: 'Carga de unidad de medida',
      deleteAllProducts: 'Eliminar todos los Productos',

      chargeGridToken: 'Token para carga de Grilla',
      classificationChargeToken: 'Token para carga de Clasificación',
      syncronyzeBalanceToken: 'Token para sincronización de Stock',
      syncronyzePriceToken: 'Token para sincronización de Precio',
      chargeMeasureToken: 'Token para carga de Unidad de Medida',
      taskClassificationBySpace: 'Carga de Clasificación',
      syncStatusOrderPayload: 'Payload de Sincronización de Status del Pedido',
      syncStatusOrder: 'Sincronización de Status del Pedido',
      syncStatusOrderToken: 'Token de Sincronización de Status del Pedido',
      syncronyzeBalancePayload: 'Payload de Sincronización de Stock',
      syncronyzeBalance: 'Sincronización de Stock',
      taskBalanceChargeBySpace: 'Carga de Stock',
      syncronyzePricePayload: 'Payload de Sincronización de Precio',
      priceSkuVariationItens: 'Precio de los Ítems de la Variación',
      configSyncOrderBySpace: 'Configuración de Sincronización de Pedido',
      configSyncOrder: 'Configuración de Sincronización de Pedido',
      taskGridChargeBySpace: 'Carga de Grilla',
      productChargeInternal: 'Carga de Producto',
      taskChargeProductBySpace: 'Carga de Producto',
      skuLocationVariation: 'Sincronismos de Variación por Localización',
      stockSkuVariation: 'Sincronismos de Variación',
      taskPriceChargeBySpace: 'Carga de Precio por Pluginspace',

      automaticChargeBalance: 'Sinc Automático de Stock',
      automaticChargePrice: 'Sinc Automático de Precio',
      automaticChargeClassification: 'Sinc Automático de Clasificación',
      automaticTaskGridCharge: 'Sinc Automático de Grilla',
      automaticTaskMeassure: 'Sinc Automático de Unid. Medidas',
      automaticSnyOrder: 'Sinc Automático Status de Pedidos',
      chargeMeasureItens: 'Ítems de carga de Unid Medida',
      searchMeasurementAll: 'Carga de unidad de medida',
      taskGridCharge: 'Carga de Grilla',
      taskMeassure: 'Carga de unidad de medida',

      getCredential: 'Obtener Token',
      LoadPricePerList: 'Carga de Precios',
      processPriceList: 'Procesamiento de la Lista de Precios',
      updateProductKit: 'Actualización de Productos',
      UpdateProductSingle: 'Actualización de Productos',
      updateProductStatus: 'Actualización de Status de Producto',
      taskBalanceIntegrationLink: 'Enlace de integración de stock',
      taskPriceIntegrationLink: 'Enlace de integración de precio',
      taskProductIntegrationLink: 'Enlace de integración de producto',
      token: 'Obtención de Token',
      automaticChargeProduct: 'Carga automática de productos',

      //Desconto Ninegrid
      calculateDiscount: 'Cálculo del descuento en el ninegrid',
      sendDiscountNinegrid: 'Descuento Ninegrid',

      //Customer Cart
      updateCustomerCartStatus: 'Actualización del carrito del Cliente',

      //Cliente
      createCustomer: 'Creación del Cliente',
      validCodeCustomer: 'Código de validación del Cliente',

      //clearSale
      statusAnalisis: 'Análisis del Status',
      antifraudValidation: 'Validación de la antifraude',
      clearSale: 'ClearSale Garantizado',
      searchOrderStatusClearSale: 'Búsqueda Status ClearSale',

      printLabelFrenet: 'Etiqueta Frenet',
      changeStatusFrenet: 'Cambio de status Frenet',
      callWaiter: 'Llamar Camarero',
      paymentTable: 'Pago en la mesa',

      // Generacion de nota Fiscal Do Chef
      generateNfOrderFood: 'Generar nota fiscal del pedido',
      getNotaFiscalChef: 'Recuperar nota fiscal del Chef',
      finishOrderFood: 'Verificación previa a la nota fiscal',

      // Log de error del pedido Chef
      buildCardData: 'Error al crear datos para Comanda',
      buildTableData: 'Error al crear datos para Mesa',
      buildTablePaymentData: 'Error al crear datos para Pago Mesa',
      buildCounterData: 'Error al crear datos para Mostrador',
      buildDeliveryData: 'Error al crear datos para Entrega/Retiro',

      generateCustomerWholeSalerByCSV: 'Generar cliente mayorista por CSV',

      validateStockWholeSaleCart: 'Alerta de pedido',
      validateWholeSaleCart: 'Alerta de pedido',

      chargeImageService: 'Servicio de carga de imágenes',

      webhookNisRedis: 'Limpieza del Redis de la Tienda',

      /*Envio de email  */
      sendEmailWelcome: 'Enviar email de bienvenida',
      sendEmailOrderNotification: 'Enviar notificación por email de pedido',
      sendEmailAccountNotification: 'Enviar notificación por email de cuenta',
      createCustomerLogin: 'Enviar email de creación de login de cliente',
    },

    copy: {
      definition: 'Definición de Pluginspace',
      origin: 'Seleccione el Pluginspace de origen',
      destination: 'Seleccione el Pluginspace de destino',
      configurations: 'Configuraciones de la copia',
      store: 'Configuraciones de la Tienda',
      deliveryFee: 'Tasa de entrega',
      shifts: 'Turnos',
      paymentPlans: 'Planes de Pago',
      clientData: 'Datos del Cliente',
      account: 'Configuraciones de la Cuenta',
      groups: 'Grupos',
      terms: 'Términos',
      webapp: 'Webapp',
      webappConfig: 'Configuraciones',
      webappPersonalize: 'Personalización',
      whatsappweb: 'WhatsApp Web',
      whatsappwebConfig: 'Configuraciones',
      whatsappwebPersonalize: 'Personalización',
      integrations: 'Integraciones',
      integrationPayment: 'Medios de pago',
      integrationPdv: 'PDV',
      integrationMessaging: 'Mensajería',
      integrationOthers: 'Otros',
      button: 'Copiar Pluginspace',
    },

    payment: {
      methods: 'Medios de pago',
      method: 'Forma de pago',
      gateway: 'Gateway de pago',
      card: 'Tarjeta de crédito',
      debit: 'Tarjeta de débito',
      food: 'Vale alimentación',
      pix: 'Pix',
      others: 'Otros',
      pay_money: 'Dinero',
      config: 'Configuraciones',
      add: 'Configurar medio de pago',
      back: 'Volver a los gateways de pago',
      basic_settings: 'Configuraciones básicas',
      modalities: 'Modalidades donde este medio de pago será utilizado',
      add_payment: 'Añadir forma de pago',
      code_erp: 'Código ERP',
      installments: 'Número de cuotas',
      edit_payment: 'Editar forma de pago',
      delete: 'Eliminar forma de pago',
      money: 'Pago en efectivo',
      max_installments: '¿Cuál es el número máximo de cuotas?',
      min_value_installments: '¿Cuál es el valor mínimo para las cuotas?',
      confirm: 'Confirmar eliminación',
      delete_payment: 'Desea eliminar la forma de pago',
      change: '¿Desea realizar este cambio?',
      inative: '¿Desea inactivar esta forma de pago?',
      inative_change: '¿Desea activar esta forma de pago e inactivar la antigua?',
      motive: 'Por favor informe el motivo',
      /* usado para desconto */
      config_descount_payment: 'Configuración de descuento por medio de pago',

      able_discount_pix: 'Habilitar descuento para pago Pix',
      able_discount_card: 'Habilitar descuento para pago Tarjeta',
      able_discount: 'Habilitar descuento para pago',

      discount_percentage: 'Descuento Porcentual',
      discount_monetary: 'Descuento Monetario',
      discount_value: 'Valor del descuento',
    },

    icon: {
      title: 'Íconos',
      subtitle: 'Aquí están listados todos los íconos de la biblioteca',
    },
    freight: {
      title: 'Modalidades de envío',
      map: 'Mapa',
      map_text: 'Opción para pago en la entrega del pedido',
      range: 'Radio',
      range_text: 'Opción para pago en la entrega del pedido',
      cep: 'Lista de CEP',
      cep_text: 'Opción para pago en la entrega del pedido',
      config: 'Configuraciones',
      delivery: 'Entrega propia',
      delivery_text: 'Son 3 opciones de entrega personalizables:',
      frenet: 'Frenet',
      frenet_text: 'Gestión completa de fletes con diversas transportadoras y medios de envío.',
      frenet_text_2: 'Para habilitar esta integración es necesario tener un plan de Frenet.',
      site: 'Ver el sitio oficial',
      coming_soon: 'Próximamente...',
    },
    frenet: {
      title: 'Integración con Frenet',
      back: 'Volver a los medios de entrega',
      integration: 'Integración',
      config: 'Configuraciones',
      dimensions: 'Dimensiones básicas de entrega en centímetros',
      height: 'Altura',
      width: 'Anchura',
      length: 'Longitud',
      value: 'Valor declarado de los productos',
      use: 'Utilizar',
      dont_use: 'No utilizar',
      price: '¿Usar cotización simplificada?',
      yes: 'Sí',
      no: 'No',
      branchCode: 'Punto de postagem Jadlog',
      no_balance: 'Sin saldo en Frenet',
      value_balance: 'Usted tiene @ de saldo en Frenet',
      print_balance:
        'Para imprimir la etiqueta de envío de este pedido es necesario cargar saldo en su cuenta de Frenet.',
      click_balance: 'Haga clic en el botón de abajo para acceder a Frenet en otra pestaña.',
      open_balance: 'Abrir cuenta Frenet',
      valid_token: 'Token inválido',
      declared_value: 'El valor declarado es utilizado en caso de seguro por la transportadora.',
      getToken:
        'Para encontrar el token en Frenet, es necesario acceder a la sección de claves de acceso y copiar el valor del campo "TOKEN".',
      weight_frenet: 'Peso patrón (kg)',
      height_frenet: 'Altura patrón (cm)',
      width_frenet: 'Anchura patrón (cm)',
      depth_frenet: 'Profundidad patrón (cm)',
      alert_title: 'Dimensiones de referencia para cálculo de flete',
      alert_warning: '¡Atención!',
      alert_description:
        'Estas medidas se usarán para calcular el flete de productos sin volumetría registrada.',
      alert_wrong_values: 'Valores incorrectos pueden generar:',
      alert_overpriced: 'Fletes sobrefacturados (alejando clientes).',
      alert_additional_costs:
        'Costos adicionales (si la transportadora ajusta el valor posteriormente).',
      alert_recommendation: 'Recomendamos registrar la volumetría real de cada producto.',
      alert_reference: 'Dimensiones de referencia:',
      alert_small_products: 'Productos pequeños',
      alert_small_examples: '(ej: accesorios, bisutería, cables)',
      alert_small_weight: 'Peso: 0,1–0,3 kg',
      alert_small_dimensions: 'Dimensiones: 10 × 10 × 5 cm',
      alert_medium_products: 'Productos medianos',
      alert_medium_examples: '(ej: ropa, libros, electrónicos pequeños)',
      alert_medium_weight: 'Peso: 0,5–2 kg',
      alert_medium_dimensions: 'Dimensiones: 25 × 20 × 10 cm',
      alert_large_products: 'Productos grandes',
      alert_large_examples: '(ej: electrodomésticos, cajas voluminosas)',
      alert_large_weight: 'Peso: 5–20 kg o más',
      alert_large_dimensions: 'Dimensiones: 50 × 40 × 30 cm o mayores',
    },
    chat: {
      you: 'Usted',
      now: 'Enviado ahora',
      send: 'Enviar',
      type_message: 'Escriba un mensaje...',
      initial_message: 'Bienvenido(a) al chat IA de Ninegrid',
      error_message:
        'No pude encontrar una respuesta para su mensaje, sea más específico o intente más tarde.',
      tip_language: 'Responda en español por favor.',
      title_config: 'Configuraciones de Inteligencia Artificial',
      config: 'Configurar Inteligencia Artificial',
      fit: 'Entrenamiento de la Inteligencia Artificial',
      fit_header: 'Aquí están listadas las preguntas con las respectivas respuestas creadas',
      add_question: 'Añadir pregunta',
      edit_question: 'Editar pregunta',
      delete_question: '¿Desea eliminar la pregunta a continuación?',
      question: 'Pregunta',
      answer: 'Respuesta',
      date: 'Fecha',
      actions: 'Acciones',
      active: 'Activo',
      delete: 'Eliminar',
      sync: 'Sincronizar IA',
      upload: 'Carga del archivo',
      about: 'Acerca de',
      chatia: 'Chat',
      about_title: 'Acerca de Ninegrid IA',
      about_description_title: 'Descripción',
      about_description:
        'Ninegrid IA es un asistente virtual inteligente diseñado para ayudarle con tareas de soporte.',
      about_support_title: 'Soporte',
      about_support_description:
        'Si tiene alguna pregunta o necesita ayuda, nuestro equipo de soporte está listo para ayudarle.',
      about_support_contact_1: 'Para hablar con soporte, contáctenos por e-mail',
      about_support_contact_2: 'o abra un llamado en nuestro portal:',
      about_features_title: 'Recursos',
      tips: 'Consejos para crear sus preguntas',
      about_tips_1: 'Use preguntas claras y objetivas para obtener mejores respuestas.',
      about_tips_2: 'Evite jergas o términos técnicos complejos.',
      about_tips_3: 'Si la respuesta no es satisfactoria, intente reformular la pregunta.',
      about_tips_4:
        'Ninegrid IA aprende con las interacciones, por lo que cuanto más lo use, mejor será.',
      feature_1: 'Conversación en lenguaje natural',
      feature_2: 'Soporte a comandos de voz',
      feature_3: 'Síntesis de voz para respuestas',
      feature_4: 'Interfaz intuitiva y responsiva',
      about_manuals: 'Manuales',
      about_manuals_description:
        'Consulte nuestros manuales para aprender más sobre cómo usar el Ambiente Ninegrid,',
      about_faq: 'Preguntas Frecuentes',
      about_faq_description:
        'Vea las preguntas más frecuentes y sus respuestas para aclarar dudas comunes,',
      about_version_title: 'Información del Sistema',
      version: 'Versión',
      last_update: 'Última actualización',
      rights_reserved: 'Todos los derechos reservados',
      access_here: 'acceda aquí',
      our_faq: 'ver las preguntas frecuentes',
      or: 'o',
      and: 'e',
    },
    sumary_access: {
      cart: 'Carrito',
      seller: 'Login Vendedor',
      category: 'Categorías',
      pdv: 'Detalles del Producto',
      subcategory: 'Subcategoría',
      product: 'Lista de Productos',
      home: 'Pantalla Inicial',
      'search-order': 'Pedidos',
      'store-info': 'Información de la Tienda',
      customer: 'Registro de cliente',
      receipt: 'Recibo de pago',
      order: 'Pago',
      card: 'Pago Tarjeta',
      'order-qrcode': 'Pago Pix Cliente',
      'success-order': 'Éxito de la Compra',
      'filter/pdv': 'Resultado de los Filtros',
      filter: 'Selección de Filtros',
      'seller-qrcode': 'Enlace de Pago',
      'vendor-order ': 'Consulta de carrito Vendedor',
      'finalize-order': 'Resumen de la compra',
    },
    optional: {
      optionals: 'Adicionales',
      list: 'Lista de Adicionales',
      name: 'Nombre',
      used: 'Utilizado en',
      config: 'Configurar',
      link: 'Asociar productos',
      products_optional: 'Productos asociados a la lista',
      edit: 'Editar lista de adicionales',
      type: 'Tipo de selección',
      max: 'Máximo',
      mandatory: 'Obligatorio',
      order: 'Orden',
      code: 'Código',
      qtd: 'Cant. máxima',
      price: 'Precio',
      include: 'Incluir un adicional',
      create: 'Crear lista de adicionales',
      description: 'Descripción webapp',
      emptyProduct: 'Ningún producto está utilizando este adicional',
    },

    coupons: {
      title: 'Cupones',
      report: 'Informes de Cupones',
      titleCreate: 'Crear Cupones',
      titleUpdate: 'Editar Cupones',
      subTitle: 'Aquí están listados los cupones junto con sus respectivas acciones.',
      create: 'Crear Cupón',
      edit: 'Editar Cupón',
      delete: 'Eliminar Cupón',

      //variables del input
      name: 'Nombre del Cupón',
      name_helper: 'Máximo de 15 caracteres',
      description: 'Descripción',
      description_placeholder: 'debe aceptar un máximo de 200 caracteres',
      seller: 'Vendedor',
      catalog: 'Catálogo',
      discountValue: 'Valor del Descuento',
      discountPercentage: 'Porcentaje del Descuento',
      type: 'Tipo',
      dateInit: 'Fecha de inicio',
      dateEnd: 'Fecha de fin',
      quantitative: 'Cantidad de utilizaciones',
    },

    order_print: {
      title: 'Confirme la información del pedido antes de confirmar la impresión',
      print_text: 'Imprimir',
      information:
        'El QZ Tray solicitará permiso para establecer la conexión. Haga clic en "Allow" para proceder con la impresión.',
      order_details: 'Detalles del Pedido',
      client: 'Cliente',
      payment: 'Pago',
      created: 'Creado',
      print: 'Imprimir Pedido',
      print_confirm:
        '¿Desea imprimir este pedido? Asegúrese de que la impresora esté conectada y configurada correctamente antes de continuar',
    },

    whatsappweb: {
      title: 'WhatsApp Web',
      subtitle:
        'Aquí están listadas las configuraciones de WhatsApp junto con sus respectivas acciones.',
      titleCreate: 'Sincronizar WhatsApp',
      titleDelete: 'Eliminar Sincronización WhatsApp',
      create: 'Sincronizar WhatsApp',
      delete: 'Eliminar Sesión WhatsApp',
      active: 'Activo',
      welcome: 'WhatsApp Web de Ninegrid',
      describe_whatsappweb:
        '¡Aquí es posible realizar el enlace de WhatsAppWEB con el celular de la tienda!',
      config: 'Para configurar el WhatsApp',
      step1: 'Abra WhatsApp en su celular.',
      step2: 'Toque en Más opciones ⋮ en Android o en Configuración ⚙️ en iPhone.',
      step3: 'Toque en Dispositivos conectados y, a continuación, en Conectar un dispositivo.',
      step4: 'Apunte su celular a esta pantalla para escanear el código QR.',
    },

    fileManagement: {
      title: 'Gestor de Archivos',
      subtitle: 'Aquí están listados los archivos junto con sus respectivas acciones.',
      create: 'Crear Archivo',
      edit: 'Editar Archivo',
      delete: 'Eliminar Archivo',
      download: 'Descargar Archivo',
      upload: 'Enviar Archivo',
      file: 'Archivo',
      file_name: 'Nombre del Archivo',
      file_item: 'Ítem',
      file_itens: 'Ítems',
      file_type: 'Tipo del Archivo',
      file_size: 'Tamaño del Archivo',
      file_date: 'Fecha de Creación',
      file_actions: 'Acciones',
      file_folder: 'Carpeta',
      file_new_folder: 'Nueva Carpeta',
      file_folder_name: 'Nombre de la Carpeta',
      file_last_modified: 'Última Modificación',
      file_description: 'Descripción del Archivo',
      file_description_placeholder: 'Descripción del archivo',
      file_description_helper: 'Máximo de 200 caracteres',
      file_name_placeholder: 'Nombre del archivo',
      file_name_helper: 'Máximo de 15 caracteres',
      file_page_showing: 'Mostrando',
      file_not_found: 'Ningún archivo encontrado',
      file_uploading: 'Cargando archivo',
      file_upload: 'Cargar Archivo',
      file_changing: 'Cambiando archivo',
      file_Loading: 'Cargando archivos',
      file_update: 'Actualizar',
      file_sync_knowledge_base: 'Sincronizar Base de Conocimiento',
      file_history_sync: 'Histórico de Sincronización',
      scanned: 'Escaneado',
      indexed: 'Indexado',
      modified: 'Modificado',
      completed: 'Concluido',
      deleted: 'Eliminado',
      failed: 'Fallado',
      available: 'Disponible',
      last_update: 'Última actualización',
      status: 'Estado',
      status_job: 'Estado de la Tarea',
      data_source: 'Fuente de Datos',
      knowledge_base: 'Base de Conocimiento',
      history_sync: 'Histórico de Sincronización',
      chart_scanned_doc: 'Documentos Escaneados',
      chart_indexed_doc: 'Documentos Indexados',
      chart_modified_doc: 'Documentos Modificados',
      chart_deleted_doc: 'Documentos Eliminados',
      chart_failed_doc: 'Documentos con Fallo',
      chart_docs_processed: 'Documentos Procesados',
      chart_docs_total: 'Total de Documentos',
      total_jobs_processed: 'Total de Tareas Procesadas',
      jobs_info: 'Información sobre las Tareas',
      observation_table_jobs_phase:
        'Tabla de Jobs Procesados presenta los últimos 5 jobs de cada fuente de datos.',
    },
    service_requests: {
      title: 'Formularios de Servicio',
      subtitle: 'Gestione los formularios de solicitud de servicios',
      create: 'Crear Formulario de Servicio',
      edit: 'Editar Formulario de Servicio',
      delete: 'Eliminar Formulario de Servicio',
      create_form: 'Crear Formulario',
      edit_form: 'Editar Formulario',
      delete_form: 'Eliminar Formulario',
      form_title: 'Título',
      form_icon: 'Ícono',
      form_status: 'Estado',
      form_description: 'Descripción',
      form_components: 'Componentes',
      form_grids: 'Grillas',
      priority_label: 'Prioridad',
      priority_low: 'Baja',
      priority_normal: 'Normal',
      priority_high: 'Alta',
      priority_critical: 'Crítica',
      choose_icon: 'Elegir',
      add_component: 'Añadir',
      sections: 'Secciones',
      empty_message: 'Haga clic en Añadir para insertar componentes y arrastre para reordenar.',
      success_created: 'El formulario de servicio fue creado con éxito.',
      success_updated: 'El formulario de servicio fue actualizado con éxito.',
      success_deleted: 'Formulario de servicio eliminado con éxito.',
      error_create: 'Ocurrió un error al crear el formulario de servicio.',
      error_update: 'Ocurrió un error al actualizar el formulario de servicio.',
      error_delete: 'Error al eliminar el formulario de servicio.',
      error_load: '¡Error al cargar!',
      validation_title: 'Por favor, informe un título para la sesión',
      validation_icon: 'Por favor, elija un ícono para la sesión',
      validation_components: 'Añada al menos un componente antes de guardar',
      placeholder_title: 'Ej.: Limpieza',
      icon_selected: 'Ícono seleccionado (SVG)',
      icon_none: 'Ningún ícono seleccionado',
      visual_instructions:
        'Monte visualmente la sesión. Arrastre para reordenar. Los campos son solo visuales (no interactivos).',
      component: 'componente',
      components_plural: 'componentes',
      grid: 'grilla',
      grids_plural: 'grillas',
      grid_services: 'Grillas de Servicios',
      grid_services_title: 'Seleccionar Grillas de Servicios',
      grid_services_search: 'Buscar grillas',
      grid_services_label: 'Grillas',
      grid_services_selected: 'Grillas seleccionadas',
      grid_services_error: 'Error al buscar grillas de hotel',
      add_component_modal: 'Añadir componente',
      validation_grids_required: 'Grillas obligatorias',
      validation_grids_text:
        'Todos los componentes de selección deben tener al menos una grilla de servicios seleccionada.',
      actions: 'Acciones',
      breadcrumb_dashboard: 'Dashboard',
      breadcrumb_essential_services: 'Servicios Esenciales',
      // UI Elements
      drag_title: 'Arrastrar',
      drag_action: 'Arrastre',
      remove_title: 'Eliminar',
      remove_aria_label: 'Eliminar bloque',
      max_quantity_title: 'Cantidad máxima:',
      max_prefix: 'Máx:',
      description_label: 'Descripción',
      sections_label: 'Secciones',
      // Modal titles and actions
      select_icon_title: 'Seleccionar',
      no_icons_available: 'No hay ningún ícono disponible…',
      search_placeholder: 'Escriba para buscar...',
      grid_services_selected_label: 'Seleccionadas:',
      no_grid_found: 'Ninguna grilla encontrada',
      no_grid_available: 'Ninguna grilla disponible',
      grid_status_active: 'Activo',
      grid_status_inactive: 'Inactivo',
      grid_item_name_placeholder: 'Nombre (Ej.: Masaje Relajante)',
      grid_item_value_placeholder: 'Valor (Ej.: 50,00)',
      cancel_button: 'Cancelar',
      save_button: 'Guardar',
      confirm_button: 'Confirmar',
      // Quantity modal
      max_quantity_modal_title: 'Definir Cantidad Máxima',
      max_quantity_label: 'Cantidad máxima',
      max_quantity_placeholder: 'Escriba la cantidad máxima',
      max_quantity_helper:
        'Define el número máximo de ítems que pueden ser seleccionados en este campo.',
      // Breadcrumbs
      breadcrumb_create: 'Crear',
      breadcrumb_edit: 'Editar',
      // Form components
      sample_service_1: 'Servicio 1',
      sample_service_2: 'Servicio 2',
      sample_hygiene: 'Higiene',
      sample_drinks: 'Bebidas',
      room_number_label: 'Número de la habitación',
      select_placeholder: 'Seleccione...',
      date_label: 'Fecha',
      hour_label: 'Hora',
      quantity_label: 'Cantidad',
      between_placeholder: 'Entre',
      and_placeholder: 'y',
      select_list_label: 'Selección (lista)',
      select_item_placeholder: 'Seleccione un ítem',
      select_checkbox_label: 'Selección (checkbox)',
      // Visibility
      visible_to_label: 'Visible para',
      visible_to_employees: 'Empleados',
      visible_to_customers: 'Clientes',
      visible_to_both: 'Ambos',
      select_category_placeholder: 'Seleccione una categoría',
      select_quantity_label: 'Selección (cantidad)',
      qty_label: 'Cant.',
      // Catalog titles
      catalog_room_number: 'Número de la habitación',
      catalog_date: 'Fecha',
      catalog_hour: 'Hora',
      catalog_date_hour: 'Fecha + Hora',
      catalog_select_list: 'Selección (lista)',
      catalog_select_list_quantity: 'Selección (Lista) + Cantidad',
      catalog_select_checkbox: 'Selección (checkbox)',
      catalog_select_count: 'Selección (cantidad)',
      catalog_quantity: 'Cantidad',
    },
    base_modal: {
      attention_title: '¡Atención!',
      unsaved_changes_text: 'Los cambios realizados se perderán, ¿está seguro de que desea salir?',
      confirm_button: 'Sí',
      cancel_button: 'No',
    },
    summarize_ia: {
      title: 'Resumen de Utilización de la IA',
      subtitle: 'Aquí están listadas las informaciones de resumen de la IA.',
      create: 'Crear Resumen IA',
      edit: 'Editar Resumen IA',
      delete: 'Eliminar Resumen IA',
      summarize: 'Resumir',
    },
    hospitality: {
      add_room: 'Añadir Habitación',
      create_multiples: 'Crear Múltiples',
      add_activity: 'Añadir Actividad',
      add_experience: 'Añadir Experiencia',
      experiences: 'Experiencias ',
      experience_type: 'Tipo de Experiencia',
      experience_duration: 'Duración',
      experience_price: 'Precio',
      experience_rating: 'Evaluación',
      experience_includes: 'Incluye',
      create_experience: 'Crear Experiencia',
      edit_experience: 'Editar Experiencia',
      experience_created: '¡Experiencia creada con éxito!',
      experience_updated: '¡Experiencia actualizada con éxito!',
      experience_deleted: '¡Experiencia eliminada con éxito!',
    },
    hospitality_content: {
      page_title: 'Botones',
      page_subtitle: 'Los botones de las secciones se enumeran aquí.',
      add_button: 'Añadir Botón',
      filters: {
        sections: 'Secciones',
      },
      table: {
        headers: {
          title: 'Título',
          order: 'Orden',
          formTitle: 'Título del Formulario',
          type: 'Tipo',
          visibility: 'Visibilidad',
          actions: 'Acciones',
        },
      },
      tabs: {
        buttons: 'Botones',
        native_buttons: 'Botones Nativos',
      },
      actions: {
        edit: 'Editar botón',
        delete: 'Eliminar botón',
        delete_confirm: '¿Está seguro de que desea eliminar este botón?',
      },
      type_labels: {
        service_form: 'Formularios de Servicio',
        feedback: 'Su Opinión',
        service: 'Servicios',
        information: 'Información',
        activities_leisure: 'Actividades y Ocio',
        bars_restaurants: 'Bares y Restaurantes',
        schedule: 'Programación',
        experience: 'Experiencia',
        booking: 'Citas',
        check_in: 'Check-in',
        check_out: 'Check-out',
        tours: 'Paseos',
        page_dynamic: 'Página Dinámica',
      },
      no_category: 'Sin categoría',
      messages: {
        filter_error_title: 'Error',
        filter_error_text: 'Error al filtrar secciones',
        load_error_title: 'Error de Carga',
        load_error_text: '¡No se pudieron cargar las secciones!',
        section_not_found_title: 'Error',
        section_not_found_text: '¡Sección no encontrada!',
        deleted_title: 'Sección Eliminada',
        deleted_text: '¡Eliminación realizada con éxito!',
        delete_error: '¡Error al eliminar la sección!',
        visibility_updated_title: 'Visibilidad Actualizada',
        visibility_updated_text: '¡Visibilidad del botón actualizada con éxito!',
        visibility_error_title: 'Error de Actualización',
        visibility_error_text: '¡Error al actualizar la visibilidad del botón!',
        form: 'Formulario',
        page: 'Página',
      },
      create_modal: {
        modal_title: 'Añadir Contenido',
        alert_title: 'Selección de Sección y Contenido',
        alert_subtitle: 'Seleccione la sección y el contenido correspondientes.',
        label_section: 'Sección',
        label_content: 'Contenido',
        placeholder_select: 'Seleccionar',
        placeholder_select_section: 'Seleccione la sección',
        placeholder_select_content: 'Seleccione el contenido',
        order_label: 'Orden',
        selection_summary: 'Resumen de la selección:',
        badge_section: 'Sección',
        badge_content: 'Contenido',
        select_form_label: 'Seleccione el formulario (roomService)',
        tips_title: 'Consejos',
        tips: {
          item1: 'La sección puede tener múltiples contenidos',
          item2: 'El contenido puede pertenecer a múltiples secciones',
          item3: 'El orden define la posición en la lista',
        },
        buttons: {
          cancel: 'Cancelar',
          create: 'Crear',
        },
        swal: {
          missing_field_title: 'Campo faltante',
          missing_section: 'Seleccione una sección para continuar',
          missing_content: 'Seleccione un contenido para continuar',
          invalid_field_title: 'Campo inválido',
          invalid_order: 'El orden debe ser un número positivo o cero',
          created_title: 'Contenido registrado',
          created_text: '¡Registro realizado con éxito!',
          create_error: '¡Error al registrar el contenido!',
        },
      },
      edit_modal: {
        modal_title: 'Editar Contenido',
        alert_title: 'Edición de Contenido',
        alert_subtitle:
          'Cambie la sección y el orden según sea necesario. El contenido actual no se puede modificar.',
        label_section: 'Sección',
        label_content: 'Contenido',
        placeholder_select: 'Seleccionar',
        placeholder_select_section: 'Seleccione la sección',
        placeholder_select_content: 'Seleccione el contenido',
        order_label: 'Orden',
        selection_summary: 'Resumen de la selección:',
        badge_section: 'Sección',
        badge_content: 'Contenido',
        tips_title: 'Consejos',
        tips: {
          item1: 'Solo puede cambiar la sección',
          item2: 'El orden define la posición en la lista',
        },
        buttons: {
          cancel: 'Cancelar',
          save: 'Guardar',
        },
        swal: {
          missing_field_title: 'Campo faltante',
          missing_section: 'Seleccione una sección para continuar',
          missing_content: 'Seleccione un contenido para continuar',
          invalid_field_title: 'Campo inválido',
          invalid_order: 'El orden debe ser un número positivo o cero',
          updated_title: 'Contenido actualizado',
          updated_text: '¡Actualización realizada con éxito!',
          update_error: '¡Error al actualizar el contenido!',
        },
      },
      category: {
        page_title: 'Secciones',
        page_subtitle:
          'Aquí se enumeran las secciones de contenido junto con sus respectivas acciones.',
        add_button: 'Añadir',
        breadcrumbs: {
          dashboard: 'Dashboard',
          categories: 'Categorías',
        },
        table: {
          headers: {
            section: 'Sección',
            order: 'Orden',
            status: 'Estado',
            actions: 'Acciones',
          },
        },
        options: {
          edit_category: 'Editar categoría',
          delete_section: 'Eliminar sección',
          delete_confirm: 'Eliminar sección',
        },
        swal: {
          deleted_title: 'Sección eliminada',
          deleted_text: '¡Eliminación realizada con éxito!',
          delete_error: '¡Error al eliminar la sección!',
        },
        create: {
          missing_fields_title: 'Campos faltantes',
          missing_fields_text: '¡Verifique si ha llenado todos los campos correctamente!',
          created_title: 'Categoría registrada',
          created_text: '¡Registro realizado con éxito!',
          create_error: '¡Error al registrar la categoría!',
        },
        update: {
          missing_fields_title: 'Campos faltantes',
          missing_fields_text: '¡Verifique si ha llenado todos los campos correctamente!',
          updated_title: 'Categoría actualizada',
          updated_text: '¡Edición realizada con éxito!',
          update_error: '¡Error al actualizar la categoría!',
        },
        type: {
          default: 'Predeterminado',
          banner: 'Banner Destacado',
        },
      },
    },
    clean_safe: {
      title: 'Clean & Safe',
      subtitle: 'Gestione medidas de seguridad, protocolos de limpieza y certificaciones',
      security_measures: 'Medidas de Seguridad',
      cleaning_protocols: 'Protocolos de Limpieza',
      certifications: 'Certificaciones',
      add_security_measure: 'Añadir Medida',
      add_cleaning_protocol: 'Añadir Protocolo',
      add_certification: 'Añadir Certificación',
      add_new_security_measure: 'Añadir Nueva Medida',
      add_new_cleaning_protocol: 'Añadir Nuevo Protocolo',
      add_new_certification: 'Añadir Nueva Certificación',
      security_measure: 'Medida de Seguridad',
      cleaning_protocol: 'Protocolo de Limpieza',
      certification: 'Certificación',
      icon: 'Ícono',
      choose_icon: 'Elegir Ícono',
      title_field: 'Título',
      description: 'Descripción',
      status: 'Estado',
      active: 'Activo',
      inactive: 'Inactivo',
      remove: 'Eliminar',
      save: 'Guardar',
      required_title: 'Título es obligatorio',
      required_icon: 'Ícono es obligatorio',
      required_fields: 'Campos obligatorios',
      required_fields_message: 'Por favor, rellene todos los campos obligatorios.',
      confirmation: 'Confirmación',
      delete_security_measure_confirm:
        '¿Está seguro de que desea eliminar esta medida de seguridad?',
      delete_cleaning_protocol_confirm:
        '¿Está seguro de que desea eliminar este protocolo de limpieza?',
      delete_certification_confirm: '¿Está seguro de que desea eliminar esta certificación?',
      yes: 'Sí',
      no: 'No',
      error: 'Error',
      error_delete: 'Error al eliminar ítem.',
      success: 'Éxito',
      success_save: '¡Datos de higiene y seguridad guardados con éxito!',
      error_save: 'Ocurrió un error al guardar los datos.',
      empty_security_measures: 'Ninguna medida de seguridad añadida aún.',
      empty_cleaning_protocols: 'Ningún protocolo de limpieza añadido aún.',
      empty_certifications: 'Ninguna certificación añadida aún.',
      empty_start_message: 'Haga clic en "Añadir" para comenzar.',
      placeholder_security_title: 'Escriba el título de la medida de seguridad',
      placeholder_protocol_title: 'Escriba el título del protocolo',
      placeholder_certification_title: 'Escriba el título de la certificación',
      placeholder_security_description: 'Escriba una descripción breve (máximo 100 caracteres)',
      placeholder_protocol_description:
        'Escriba la descripción detallada del protocolo de limpieza',
    },
    orders_room_service: {
      title: 'Pedidos de Habitación',
      subtitle: 'Gestión de pedidos de servicios del hotel',

      // Filtros
      status: 'Estado',
      start_date: 'Fecha Inicial',
      end_date: 'Fecha Final',
      reservation_id: 'Código de la Reserva',
      post_id: 'ID del Post',
      service_type: 'Tipo de Servicio',
      search: 'Buscar',
      clear_filters: 'Limpiar Filtros',

      // Estado
      status_pending: 'Pendiente',
      status_confirmed: 'Confirmado',
      status_in_progress: 'En Curso',
      status_cancelled: 'Cancelado',
      status_concluded: 'Concluido',
      status_completed: 'Completado',

      // Opciones de filtro
      all_status: 'Todos los estados',
      all_types: 'Todos los tipos',
      service_forms: 'Formularios de Servicio',
      services: 'Servicios',

      // Headers de la tabla
      service: 'Servicio',
      room: 'Habitación',
      price: 'Precio',
      people_qty: 'Cantidad de Personas',
      reservation: 'Reserva',
      date: 'Fecha',
      time: 'Horario',
      priority: 'Prioridad',
      created_at: 'Creado el',
      actions: 'Acciones',

      // Tooltip actions
      view_details: 'Ver Detalles',
      change_status: 'Cambiar Estado',

      // Modal de detalles
      order_details: 'Detalles del Pedido',
      close: 'Cerrar',
      loading_details: 'Cargando detalles del pedido...',
      loading: 'Cargando...',

      // Información del pedido
      order: 'Pedido',
      room_service: 'Servicio de Habitación',
      location: 'Localización',
      room_number: 'Número de la Habitación',
      scheduled_date: 'Fecha Agendada',
      no_time: 'Sin horario',
      reservation_id_label: 'Código de la Reserva',

      // Información del cliente
      customer_info: 'Información del Cliente',
      full_name: 'Nombre Completo',
      email: 'E-mail',
      phone: 'Teléfono',

      // Detalles de la solicitud
      request_summary: 'Resumen de la Solicitud',
      service_details: 'Detalles del Servicio',
      request_details: 'Detalles de la Solicitud',
      no_items_selected: 'Ningún ítem seleccionado',
      not_informed: 'No informado',
      units: 'unidades',

      // Información técnica
      technical_info: 'Información Técnica',
      post: 'Post',
      booking_type: 'Tipo de Reserva',
      hotel_info: 'Información del Hotel',
      hotel_name: 'Nombre del Hotel',
      subdomain: 'Subdominio',
      type: 'Tipo',
      service_form: 'Formulario de Servicio',
      last_update: 'Última Actualización',
      additional_notes: 'Observaciones Adicionales',

      // Modal de alteración de status
      change_status_title: 'Cambiar Estado',
      current_status: 'Estado Actual',
      new_status: 'Nuevo Estado',
      select_status: 'Seleccione un estado',

      // Placeholders
      select_status_placeholder: 'Seleccione el estado',
      select_service_type_placeholder: 'Seleccione el tipo de servicio',
      start_date_placeholder: 'Fecha inicial',
      end_date_placeholder: 'Fecha final',
      reservation_id_placeholder: 'Escriba el ID de la reserva',
      post_id_placeholder: 'Escriba el ID del post',
      new_status_placeholder: 'Seleccione el nuevo estado',

      // Mensajes de error y éxito
      error: 'Error',
      success: 'Éxito',
      warning: 'Atención',
      error_loading_orders: '¡Error al cargar los pedidos!',
      error_loading_details: '¡Error al cargar detalles del pedido!',
      error_changing_status: '¡Error al cambiar estado del pedido!',
      success_status_changed: '¡Estado cambiado con éxito!',
      select_status_warning: 'Por favor, seleccione un estado.',

      // Evaluación del cliente
      customer_review: 'Evaluación del Cliente',
      rating: 'Calificación',
      review_comment: 'Comentario',
    },
    s3Analytics: {
      title: 'Analytics S3',
      startDate: 'Fecha Inicial',
      endDate: 'Fecha Final',
      pluginspaceId: 'ID del Pluginspace',
      pluginspaceIdPlaceholder: 'Escriba el ID del pluginspace',
      method: 'Método',
      methodPlaceholder: 'Escriba el método (GET, POST, etc.)',
      loadData: 'Cargar Datos',
      generateAIAnalysis: 'Generar Análisis IA',
      chatWithAI: 'Conversar con IA',
      showRanking: 'Mostrar Ranking',
      analyzeWithAI: 'Analizar con IA',
      close: 'Cerrar',
      totalRequests: 'Total de Peticiones',
      totalCost: 'Costo Total',
      averageCostPerRequest: 'Costo Promedio por Petición',
      consumptionByPluginspace: 'Consumo por Pluginspace',
      consumptionByMethod: 'Consumo por Método',
      consumptionByDate: 'Consumo por Fecha',
      costAnalysis: 'Análisis de Costos',
      aiAnalysis: 'Análisis de la IA',
      chatMessage: 'Escriba su pregunta sobre los datos...',
      speakAnalysis: 'Escuchar Análisis',
      filterData: 'Filtrar Datos',
      noDataFound: 'Ningún dato encontrado para los filtros seleccionados',
      errorLoadingData: 'Error al cargar datos',
      errorGeneratingAnalysis: 'Error al generar análisis de la IA',
      analysisGenerated: '¡Análisis generado con éxito!',
      dataLoaded: '¡Datos cargados con éxito!',
      rankingData: 'Datos de Ranking',
      aiChatResponse: 'Respuesta de la IA',
      s3Analytics: 'Analytics S3',
      filters: 'Filtros',
      totalConsumption: 'Consumo Total',
      totalRecords: 'Total de Registros',
      error: 'Error',
      fetchError: 'Error al buscar datos del S3',
      aiAnalysisError: 'Error al generar análisis de la IA',
      aiChatError: 'Error al conversar con IA',
      askQuestion: 'Escriba su pregunta sobre los datos...',
      ask: 'Preguntar',
      cancel: 'Cancelar',
      ok: 'OK',
      aiResponse: 'Respuesta de la IA',
      aiAnalysisTitle: 'Análisis de la IA',
      account: 'Cuenta',
      pluginspace: 'Tienda',
      uniquePluginspaces: 'Tiendas Únicas',
      methodDistribution: 'Distribución por Método',
      timeAnalysis: 'Análisis Temporal',
      dataTable: 'Tabla de Datos',
      showingFirst10: 'Mostrando los 10 primeros',
      of: 'de',
      records: 'registros',
      consumption: 'Consumo',
      cost: 'Costo',
      date: 'Fecha',
      allMethods: 'Todos los Métodos',
      exportData: 'Exportar Datos',
    },
    hospitality_store: {
      establishment: 'Establecimiento',
      select_establishment: 'Seleccione...',
      link: 'Enlace',
      status: 'Estado',
      payment_integrated: 'Pago Integrado',
      order: 'Orden',
      store_image: 'Imagen de la Tienda',
      store_image_hint: 'Seleccione una imagen representativa de la tienda',
      description: 'Descripción',
      cnpj: 'CNPJ',
      code: 'Código',
      store_id_placeholder: 'ID de la tienda',
      type: 'Tipo',
      store_type_placeholder: 'Tipo del establecimiento',
      no_store_found: 'Ningún establecimiento encontrado.',
      edit_store: 'Editar Establecimiento',
      edit_store_subtitle: 'Edite los datos del establecimiento.',
    },
    stores_pages: {
      title: 'Establecimientos',
      subtitle:
        'Aquí están listados los establecimientos del hotel junto con sus respectivas acciones.',
      create: 'Crear Establecimiento',
      no_results: 'Ningún establecimiento encontrado.',
      table: {
        code: 'Código',
        image: 'Imagen',
        name: 'Tienda',
        cnpj: 'CNPJ',
        vinculation: 'Vinculación',
        vinculation_default: 'Predeterminado',
        vinculation_dynamic: 'Dinámico',
        type: 'Tipo',
        order: 'Orden',
        status: 'Estado',
        status_active: 'Activo',
        status_inactive: 'Inactivo',
        payment_integrated: 'Pago Integrado',
        actions: 'Acciones',
      },
      actions: {
        edit: 'Editar Establecimiento',
        delete_confirm: '¿Está seguro de que desea eliminar?',
        delete: 'Eliminar Establecimiento',
      },
      delete_success: 'Establecimiento eliminado con éxito.',
      delete_error: 'Error al eliminar el establecimiento. Por favor, intente de nuevo.',
      success: '¡Éxito!',
      error: '¡Error!',
    },
    stores_pages_create: {
      title: 'Crear Establecimiento',
      subtitle: 'Cree un nuevo establecimiento para el hotel.',
      form: {
        establishment: 'Establecimiento',
        select_placeholder: 'Seleccione...',
        link: 'Enlace',
        link_placeholder: 'https://webapp.ninegrid.com.br/...',
        status: 'Estado',
        status_options: {active: 'Activo', inactive: 'Inactivo'},
        payment_integrated: 'Pago Integrado',
        payment_options: {active: 'Activo', inactive: 'Inactivo'},
        order: 'Orden',
        image_label: 'Imagen del Establecimiento',
        image_smalltext: 'Seleccione una imagen representativa del establecimiento',
        description: 'Descripción',
        info_title: 'Información del Establecimiento',
        cnpj: 'CNPJ',
        code: 'Código',
        type: 'Tipo',
        vinculation_label: 'Tipo de Vinculación',
        vinculation_options: {default: 'Predeterminado', dynamic: 'Dinámico'},
        empty_message: 'Ningún establecimiento encontrado.',
      },
      placeholders: {
        order: '0',
        cnpj: '00.000.000/0000-00',
        store_id: 'ID de la tienda',
      },
      console_messages: {
        image_upload_error: 'Error al cargar imagen',
      },
      messages: {
        warning_title: 'Atención',
        select_store_warning: 'Por favor, seleccione un establecimiento válido antes de guardar.',
        error_saving:
          'Ocurrió un error al guardar el establecimiento. Por favor, intente de nuevo.',
        success_saved: 'Establecimiento guardado con éxito.',
      },
    },
    feedback_reviews: {
      title: 'Reseñas de Búsqueda y Satisfacción',
      subtitle:
        'Visualice y gestione todas las valoraciones y respuestas de los formularios de feedback',
      breadcrumb_feedback: 'Feedback de Satisfacción',
      error: 'Error',
      success: 'Éxito',
      loading: 'Cargando...',
      loading_details: 'Cargando detalles de la reseña...',
      close: 'Cerrar',
      error_loading_reviews: 'Error al cargar las reseñas',
      error_loading_details: 'Error al cargar los detalles de la reseña',
      error_changing_status: 'Error al cambiar el estado de la reseña',
      success_status_changed: 'Estado cambiado con éxito',
      confirm_status_change: 'Confirmar cambio de estado',
      confirm_status_change_text: '¿Está seguro de que desea cambiar el estado de esta reseña?',

      // Status
      status_pending: 'Pendiente',
      status_approved: 'Aprobado',
      status_rejected: 'Rechazado',

      // Tipos de campos mostrados en las respuestas
      types: {
        title: 'Título',
        text: 'Texto',
        textarea: 'Área de Texto',
        stars: 'Calificación',
        checkbox: 'Casilla',
        radio: 'Opción Única',
        select: 'Selección',
        number: 'Número',
        date: 'Fecha',
        time: 'Hora',
        image: 'Imagen',
        link: 'Enlace',
      },

      anonymous_active: 'Activo',
      anonymous_inactive: 'Inactivo',

      // Filtros
      filters: {
        feedback_form: 'Formulario',
        status: 'Estado',
        anonymous: 'Anónimo',
        select_anonymous_placeholder: 'Todos',
        rating: 'Valoración',
        reservation_id: 'ID de Reserva',
        start_date: 'Fecha Inicial',
        end_date: 'Fecha Final',
        date: 'Fecha',
        all_forms: 'Todos los Formularios',
        all_status: 'Todos los Estados',
        all_ratings: 'Todas las Valoraciones',
        select_form_placeholder: 'Seleccione un formulario',
        select_status_placeholder: 'Seleccione un estado',
        select_rating_placeholder: 'Seleccione una valoración',
        reservation_id_placeholder: 'Ingrese el ID de la reserva',
        start_date_placeholder: 'Seleccione la fecha inicial',
        end_date_placeholder: 'Seleccione la fecha final',
        filter_button: 'Filtrar',
        clear_filters: 'Limpiar Filtros',
      },

      // Tabela
      table: {
        feedback_form: 'Formulario',
        customer: 'Cliente',
        room: 'Habitación',
        reservation: 'Reserva',
        rating: 'Valoración',
        status: 'Estado',
        date: 'Fecha',
        time: 'Hora',
        actions: 'Acciones',
      },

      // Ações
      actions: {
        view_details: 'Ver Detalles',
        approve: 'Aprobar',
        reject: 'Rechazar',
      },

      // Detalhes do Review
      review_details: 'Detalles de la Reseña',
      room: 'Habitación',
      reservation: 'Reserva',
      feedback_form: 'Formulario',
      responses: 'Respuestas',
      technical_info: 'Información Técnica',
      created_at: 'Creado en',
      updated_at: 'Actualizado en',
      review_id: 'ID de la Reseña',
      plugin_space_id: 'ID del Espacio del Plugin',
      anonymous_response: 'Respuesta Anónima',
      no_reservation_linked: 'Esta respuesta no está vinculada a una reserva específica',
      no_detailed_responses: 'No hay respuestas detalladas disponibles para esta reseña',
      anonymous_label: 'Anónimo',
      email_anonymous: 'Correo no disponible (respuesta anónima)',
      email_not_informed: 'Correo no informado',
      response_title: 'Título',
      no_rating_provided: 'No se proporcionó calificación',
      no_items_selected: 'Ningún elemento seleccionado',
      no_option_selected: 'Ninguna opción seleccionada',
      no_answer_provided: 'No se proporcionó respuesta',
      form_label: 'Formulario:',
      client_not_identified: 'Cliente no identificado',
    },
    stores_pages_edit: {
      title: 'Editar Establecimiento',
      subtitle: 'Edite los datos del establecimiento.',
      form: {
        establishment: 'Establecimiento',
        select_placeholder: 'Seleccione...',
        link: 'Enlace',
        link_placeholder: 'https://webapp.ninegrid.com.br/...',
        status: 'Estado',
        status_options: {active: 'Activo', inactive: 'Inactivo'},
        payment_integrated: 'Pago Integrado',
        payment_options: {active: 'Activo', inactive: 'Inactivo'},
        order: 'Orden',
        image_label: 'Imagen del Establecimiento',
        image_smalltext: 'Seleccione una imagen representativa del establecimiento',
        description: 'Descripción',
        info_title: 'Información del Establecimiento',
        cnpj: 'CNPJ',
        code: 'Código',
        type: 'Tipo',
        vinculation_label: 'Tipo de Vinculación',
        vinculation_options: {default: 'Predeterminado', dynamic: 'Dinámico'},
        empty_message: 'Ningún establecimiento encontrado.',
      },
      placeholders: {
        order: '0',
        cnpj: '00.000.000/0000-00',
        store_id: 'ID de la tienda',
      },
      console_messages: {
        image_upload_error: 'Error al cargar imagen',
        image_remove_error: 'Error al eliminar imagen al guardar',
      },
      messages: {
        success_updated: 'Establecimiento actualizado con éxito.',
        error_updating:
          'Ocurrió un error al actualizar el establecimiento. Por favor, intente de nuevo.',
        payment_change_warning_title: 'Atención',
        payment_change_warning_text:
          'Esta alteración puede cambiar el valor de las reservas en curso en el momento del check-out.',
        payment_confirm: 'Sí, continuar',
        cancel: 'Cancelar',
      },
    },
    hospitality_section: {
      index: {
        page_title: 'Páginas de Publicación',
        page_subtitle:
          'Aquí se listan las páginas de publicación de contenido junto con sus respectivas acciones.',
        add_button: 'Agregar Página de Publicación',
        filters: {
          sections: 'Página de Publicación',
        },
        table: {
          headers: {
            title: 'Título',
            order: 'Orden',
            formTitle: 'Título del Formulario',
            type: 'Tipo',
            actions: 'Acciones',
          },
        },
        actions: {
          edit: 'Editar Páginas de Publicación',
          delete: 'Eliminar Páginas de Publicación',
        },
      },
      create: {
        page_title: 'Crear Páginas de Publicación',
        page_subtitle: 'Cree una nueva página de publicación de contenido para el hotel.',
        add_button: 'Agregar Páginas de Publicación',
        filters: {
          sections: 'Secciones',
        },
      },
      edit: {
        page_title: 'Editar Páginas de Publicación',
        page_subtitle: 'Edite los datos de la página de publicación de contenido.',
      },
      // Traducciones dinámicas para secciones
      types: {
        category: 'Categoría',
        content: 'Contenido',
        simple: 'Simple',
        form: 'Formulario',
        page: 'Restaurante y tienda',
      },
      status: {
        active: 'Activo',
        inactive: 'Inactivo',
      },
      actions: {
        create: 'Crear',
        edit: 'Editar',
        delete: 'Eliminar',
        save: 'Guardar',
        cancel: 'Cancelar',
        update: 'Actualizar',
        remove_icon: 'Remover Ícono',
        select_icon: 'Seleccionar Ícono',
      },
      fields: {
        title: 'Título del Botón',
        type: 'Tipo de Página de Publicación',
        category: 'Categoría',
        order: 'Orden',
        status: 'Estado',
        icon: 'Ícono',
        icon_selected: 'Ícono Seleccionado',
        icon_not_selected: 'Ningún Ícono Seleccionado',
        icon_description: 'Seleccione un ícono de la lista al lado para la sección',
        icon_change_description:
          'Seleccione un ícono diferente de la lista al lado o elimine el actual',
      },
      placeholders: {
        title: 'Ingrese el título del botón',
        type: 'Seleccione el tipo',
        category: 'Seleccione una categoría',
        order: '0',
        search_icon: 'Buscar ícono...',
        all_categories: 'Todas las categorías',
      },
      warnings: {
        stores:
          'No se encontró ninguna tienda de tipo Dinámico.\nPara continuar, vaya a Configuración → Tiendas y Establecimientos y configure una tienda con tipo Dinámico.',
      },
      messages: {
        validation: {
          title_required: '¡El título es obligatorio!',
          category_required: '¡Seleccione una categoría!',
          icon_required: '¡Seleccione un ícono!',
        },
        success: {
          created: '¡Página de Publicación creada con éxito!',
          updated: '¡Página de Publicación actualizada con éxito!',
          deleted: '¡Página de Publicación eliminada con éxito!',
        },
        error: {
          create: '¡Error al crear la Página de Publicación!',
          update: '¡Error al actualizar la Página de Publicación!',
          delete: '¡Error al eliminar la Página de Publicación!',
          load: '¡Error al cargar los datos de la Página de Publicación!',
        },
        confirm: {
          delete_title: '¿Está seguro?',
          delete_text: '¡Esta acción no se puede deshacer!',
          delete_confirm: 'Sí, eliminar',
          delete_cancel: 'Cancelar',
        },
        delete: {
          deleted_title: 'Páginas de Publicación eliminadas',
          deleted_text: '¡Eliminación realizada con éxito!',
          error_title: '¡Error al eliminar las Páginas de Publicación!',
          error_text:
            'Ocurrió un error al eliminar las Páginas de Publicación. Por favor, inténtelo de nuevo.',
        },
      },
    },
    hospitality_classification_post: {
      index: {
        page_title: 'Categoría de Publicaciones',
        page_subtitle:
          'Aquí se listan las categorías de publicaciones junto con sus respectivas acciones.',
        add_button: 'Agregar Categoría de Publicación',
        filter_all: 'Todas',
        table: {
          headers: {
            title: 'Título',
            image: 'Imagen',
            summary: 'Resumen',
            status: 'Estado',
            classification: 'Clasificación',
            code: 'Código',
            actions: 'Acciones',
          },
          actions: {
            edit: 'Edit Publication Category',
            delete: 'Delete Publication Category',
          },
        },
      },
      create: {
        page_title: 'Crear Categoría de Publicación',
        page_subtitle: 'Cree una nueva categoría de publicación para el hotel.',
        add_button: 'Agregar Categoría de Publicación',
        success: {
          created_title: 'Categoría de Publicación creada',
          created_text: '¡Registro completado con éxito!',
        },
        error: {
          created_title: '¡Error al crear la Categoría de Publicación!',
          created_text: 'Ocurrió un error al crear la categoría. Por favor, inténtelo de nuevo.',
        },
      },
      edit: {
        page_title: 'Editar Categoría de Publicación',
        page_subtitle: 'Edite los datos de la categoría de publicación.',
        success: {
          created_title: 'Categoría de Publicación editada',
          created_text: '¡Registro completado con éxito!',
        },
        error: {
          created_title: '¡Error al editar la Categoría de Publicación!',
          created_text: 'Ocurrió un error al editar la categoría. Por favor, inténtelo de nuevo.',
        },
      },
    },
    hospitality_post: {
      posts: 'Publicaciones',
      index: {
        page_title: 'Publicaciones',
        page_subtitle:
          'Aquí se listan las publicaciones del hotel junto con sus respectivas acciones.',
        add_button: 'Agregar Publicación',
        filter_all: 'Todos',
        filter: 'Categorías',
        table: {
          headers: {
            title: 'Título',
            image: 'Imagen',
            summary: 'Resumen',
            order: 'Orden',
            status: 'Estado',
            classification: 'Clasificación',
            actions: 'Acciones',
          },
          actions: {
            edit: 'Editar Publicación',
            delete: 'Eliminar Publicación',
          },
        },
      },
      create: {
        page_title: 'Crear Publicación',
        page_subtitle: 'Cree una nueva publicación para el hotel.',
        success: {
          created_title: 'Publicación creada',
          created_text: '¡Registro completado con éxito!',
        },
        error: {
          created_title: '¡Error al crear la Publicación!',
          created_text: 'Ocurrió un error al crear la publicación. Por favor, inténtelo de nuevo.',
        },
      },
      edit: {
        page_title: 'Editar Publicación',
        page_subtitle: 'Edite los datos de la publicación.',
        success: {
          created_title: 'Publicación editada',
          created_text: '¡Registro completado con éxito!',
        },
        error: {
          created_title: '¡Error al editar la Publicación!',
          created_text: 'Ocurrió un error al editar la publicación. Por favor, inténtelo de nuevo.',
        },
      },
      form_validate: {
        title_required: '¡El título es obligatorio!',
        summary_required: '¡El resumen es obligatorio!',
        classification_required: '¡La clasificación es obligatoria!',
        content_required: '¡El contenido es obligatorio!',
        fields_missing: '¡Verifique si ha completado todos los campos!',
      },
    },
    hospitality_post_page: {
      types: {
        simple: 'Sencillo',
        section: 'Sección',
        form: 'Formulario',
        category: 'Categoría',
      },
      index: {
        page_title: 'Páginas de Publicaciones',
        page_subtitle:
          'Aquí se listan las páginas de publicación de contenido junto con sus respectivas acciones.',
        add_button: 'Agregar Página de Publicación',
        edit_button: 'Editar Página de Publicación',
        delete_button: 'Eliminar Página de Publicación',
      },
      create: {
        page_title: 'Crear Página de Publicación',
        page_subtitle: 'Cree una nueva página de publicación de contenido para el hotel.',
        form: {
          title: 'Título de la Página de Publicación',
          type: 'Tipo de Página de Publicación',
          status: 'Estado',
        },
        icon: {
          icon: 'Ícono SVG',
          lib: 'Biblioteca de Íconos SVG',
          search: 'Buscar ícono...',
          category: 'Categoría del Ícono',
          description: 'Seleccione un ícono de la lista lateral para la página de publicación',
          selected: 'Ícono Seleccionado',
          no_selected: 'Ningún Ícono Seleccionado',
          selected_description:
            'Seleccione un ícono de la lista lateral para la página de publicación',
          no_selected_description:
            'Ningún ícono seleccionado. Seleccione un ícono de la lista lateral para la página de publicación',
          change_description:
            'Seleccione un ícono diferente de la lista lateral o elimine el actual',
        },
        success: {
          created_title: 'Página de Publicación creada',
          created_text: '¡Registro completado con éxito!',
        },
        error: {
          created_title: '¡Error al crear la Página de Publicación!',
          created_text: 'Ocurrió un error al crear la página. Por favor, inténtelo de nuevo.',
        },
      },
      edit: {
        page_title: 'Editar Página de Publicación',
        page_subtitle: 'Edite los datos de la página de publicación de contenido.',
        form: {
          title: 'Título de la Página de Publicación',
          type: 'Tipo de Página de Publicación',
          status: 'Estado',
        },
        icon: {
          icon: 'Ícono SVG',
          lib: 'Biblioteca de Íconos SVG',
          search: 'Buscar ícono...',
          category: 'Categoría del Ícono',
          description: 'Seleccione un ícono de la lista lateral para la página de publicación',
          selected: 'Ícono Seleccionado',
          no_selected: 'Ningún Ícono Seleccionado',
          selected_description:
            'Seleccione un ícono de la lista lateral para la página de publicación',
          no_selected_description:
            'Ningún ícono seleccionado. Seleccione un ícono de la lista lateral para la página de publicación',
          change_description:
            'Seleccione un ícono diferente de la lista lateral o elimine el actual',
        },
        success: {
          created_title: 'Página de Publicación editada',
          created_text: '¡Edición completada con éxito!',
        },
        error: {
          created_title: '¡Error al editar la Página de Publicación!',
          created_text: 'Ocurrió un error al editar la página. Por favor, inténtelo de nuevo.',
        },
      },
    },
    // Translations for Booking Hotel Services
    booking_hotel_services: {
      // Index page
      page_title: 'Reservas de Servicios',
      page_subtitle: 'Gestionar reservas de servicios',
      breadcrumb_services: 'Servicios de Reserva',
      breadcrumb_booking: 'Servicios de Reserva',
      create_button: 'Crear Reserva de Servicio',

      // Table headers
      table_image: 'Imagen',
      table_title: 'Título',
      table_order: 'Orden',
      table_status: 'Estado',
      table_actions: 'Acciones',

      // Table actions
      action_edit: 'Editar',
      action_delete: 'Eliminar',

      // Status
      status_active: 'Activo',
      status_inactive: 'Inactivo',

      // Messages
      delete_success: 'Reserva eliminada',
      delete_error: 'Error al eliminar reserva',
      delete_confirm: '¿Confirmar eliminación?',

      // Create page
      create_title: 'Crear Reserva de Servicio',
      create_subtitle: 'Complete la información para crear una nueva reserva de servicio',

      // Edit page
      edit_title: 'Editar Reserva de Hotel',
      edit_subtitle: 'Editar información de la reserva',

      // Form fields
      field_title_label: 'Título',
      field_title_placeholder: 'Ej.: Reserva de Spa',
      field_status_label: 'Estado',
      field_description_label: 'Descripción',
      field_image_label: 'Imagen',
      field_icon_label: 'Icono',

      // Icon picker
      icon_choose: 'Elegir Icono',
      icon_choose_modal: 'Elegir Icono',

      // Day configuration
      day_config_title: 'Configuración de Días',
      day_config_info_line1:
        'Si el día no tiene franjas horarias definidas, este límite se aplica a todo el día.',
      day_config_info_line2:
        'Si el día tiene franjas horarias con intervalos, este límite se aplica a cada franja/intervalo.',
      day_configure: 'Configurar',
      day_periods_title: 'Períodos de Tiempo',
      day_period_add: 'Agregar Período',
      day_period_max: 'Máximo 3 períodos',
      day_period_none: 'Ningún período configurado. Agregue al menos un período.',
      day_period_overlap: 'Los periodos no pueden superponerse. Ajuste los horarios configurados.',
      day_period_label: 'Período',
      day_period_remove: 'Eliminar',
      day_interval_label: 'Intervalo (min)',
      day_start_time_label: 'Hora de Inicio',
      day_end_time_label: 'Hora de Fin',

      // Day names
      day_sunday: 'Domingo',
      day_monday: 'Lunes',
      day_tuesday: 'Martes',
      day_wednesday: 'Miércoles',
      day_thursday: 'Jueves',
      day_friday: 'Viernes',
      day_saturday: 'Sábado',

      // Grid selection
      grid_title: 'Grillas Vinculadas',
      grid_select: 'Seleccionar Grillas',
      grid_selected: 'grilla(s) seleccionada(s)',
      grid_capacity: 'Capacidad',
      grid_multiple: 'Múltiple',
      grid_multiple_yes: 'Sí',
      grid_multiple_no: 'No',
      grid_status_active: 'Activo',
      grid_status_inactive: 'Inactivo',

      // Action buttons
      button_back: 'Volver',
      button_save: 'Guardar',
      button_update: 'Actualizar',
      button_create: 'Crear',
      button_cancel: 'Cancelar',
      button_confirm: 'Confirmar',

      // Validation messages
      validation_title_required: 'Campo obligatorio',
      validation_title_text: 'El título es obligatorio.',
      validation_icon_required: 'Campo obligatorio',
      validation_icon_text: 'Seleccione un icono.',
      validation_day_required: 'Configuración requerida',
      validation_day_text: 'Configure al menos un día de la semana.',

      // Success messages
      success_created: 'Reserva creada',
      success_created_text: '¡La reserva fue creada exitosamente!',
      success_updated: 'Reserva actualizada',
      success_updated_text: '¡La reserva fue actualizada exitosamente!',

      // Error messages
      error_create: 'Error al crear',
      error_create_text: 'Ocurrió un error al crear la reserva.',
      error_update: 'Error al actualizar',
      error_update_text: 'Ocurrió un error al actualizar la reserva.',
      error_save: 'Error',
      error_save_text: 'Ocurrió un error al guardar la reserva.',
      error_load: 'Error',
      error_load_text: 'Error al cargar datos de la reserva.',

      // Breadcrumbs
      breadcrumb_dashboard: 'Panel de Control',
      breadcrumb_hospitality: 'Hospitalidad',
      breadcrumb_hotel_reservations: 'Reservas de Hotel',
      breadcrumb_create: 'Crear',
      breadcrumb_edit: 'Editar',
    },
    users: {
      houserkeeping: 'Personal de limpieza',
      maintenancetechnician: 'Técnico de mantenimiento',
      receptionist: 'Recepcionista',
      manager: 'Gerente',
      administrator: 'Administrador',
      waiter: 'Camarero',
      kitchenchief: 'Jefe de cocina / Chef',
      warehouse: 'Responsable de almacén',
      concierge: 'Conserje',
      messenger: 'Mensajero',
      receptionsupervisor: 'Supervisor de Recepción',
      telephonist: 'Telefonista',
      cook: 'Cocinero',
      barman: 'Barman / Bartender',
      roomserviceattendant: 'Asistente de Servicio de Habitaciones',
      steward: 'Steward (Limpieza de Cocina)',
      sommelier: 'Sommelier',
      plumber: 'Fontanero',
      airconditiontechnician: 'Técnico de Aire Acondicionado',
      maintenancesupervisor: 'Supervisor de Mantenimiento',
      reservationagent: 'Agente de Reservas',
      reservationcoordinator: 'Coordinador de Reservas',
      salesexecutive: 'Ejecutivo de Ventas',
      revenuemanager: 'Gerente de Revenue',
      commercialmanager: 'Gerente Comercial',
      administrativeassistant: 'Asistente Administrativo',
      financeaccountspayable: 'Finanzas / Cuentas por Pagar',
      accountant: 'Contador',
      humanresources: 'Recursos Humanos',
      purchasingwarehouse: 'Compras / Almacén',
      recreator: 'Recreador',
      activityinstructor: 'Instructor de Actividades',
      experiencecoordinator: 'Coordinador de Experiencias',
      tourguide: 'Guía Turístico',
      childmonitor: 'Monitor Infantil',
      securityguard: 'Guardia de Seguridad',
      doorman: 'Portero',
      accesscontroller: 'Controlador de Acceso',
      securitysupervisor: 'Supervisor de Seguridad',
      generalmanager: 'Gerente General',
      assistantmanager: 'Subgerente',
      operationalmanager: 'Gerente Operacional',
      departmentsupervisorscoordinators: 'Supervisores y Coordinadores de Departamento',
      floormanager: 'Encargada de Pisos',
      governancesupervisor: 'Supervisora de Gobernanza',
      generalservicesassistant: 'Auxiliar de Servicios Generales',
      laundryattendant: 'Asistente de Lavandería',
      laundrymanager: 'Encargada de Ropa Blanca',
      machinist: 'Operador de Máquinas',
      ironer: 'Planchador',
      electrician: 'Electricista',
      carpenter: 'Carpintero',
    },
  },
}

export {messages}
